webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(54);




var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: "https://api.control.villamadelief.nl"
});

http.interceptors.request.use(function (request) {
  request.headers['Authorization'] = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2__auth__["getAccessToken"]();
  return request;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && error.response.status === 401) {
    __WEBPACK_IMPORTED_MODULE_2__auth__["logout"]();
    if (window) {
      window.location.reload(true); // HACK: Forces to go to login page
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (http);

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(737),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);


var socket = new WebSocket('wss://' + "scanner.control.villa-madelief.nl" + ':' + "19999");
var emitter = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  data: function data() {
    return {
      connectedToBarcodeScanner: false
    };
  },

  methods: {
    send: function send(message) {
      if (socket.readyState === 1) {
        socket.send(message);
        return true;
      } else {
        return false;
      }
    },
    close: function close() {
      socket.close();
    }
  }
});

socket.onmessage = function (msg) {
  emitter.$emit('message', msg.data);
};
socket.onerror = function (err) {
  emitter.$emit('error', err);
};

/* harmony default export */ __webpack_exports__["a"] = (emitter);

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(740),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(576)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(698),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(722),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(706),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["login"] = login;
/* harmony export (immutable) */ __webpack_exports__["logout"] = logout;
/* harmony export (immutable) */ __webpack_exports__["loadUser"] = loadUser;
/* harmony export (immutable) */ __webpack_exports__["getUser"] = getUser;
/* harmony export (immutable) */ __webpack_exports__["isAuthenticated"] = isAuthenticated;
/* harmony export (immutable) */ __webpack_exports__["getAccessToken"] = getAccessToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var ACCESS_TOKEN_KEY = 'access_token';

var user = null;

var baseURL = "https://api.control.villamadelief.nl";

function login(username, password) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(baseURL + '/login', { username: username, password: password }).then(function (response) {
    var token = response.data.data.auth_token;
    window.localStorage.setItem(ACCESS_TOKEN_KEY, token);
  });
}

function logout() {
  window.localStorage.removeItem(ACCESS_TOKEN_KEY);
}

function loadUser() {
  var token = getAccessToken();
  if (!token) return null;

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(baseURL + '/me', {
    headers: {
      Authorization: 'Bearer ' + token
    }
  }).then(function (response) {
    user = response.data.data;
  });
}

function getUser() {
  return user;
}

function isAuthenticated() {
  var token = getAccessToken();
  return !!token;
}

function getAccessToken() {
  return window.localStorage.getItem(ACCESS_TOKEN_KEY);
}

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(728),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(759),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(714),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(586)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(752),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ba4edc04",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(690),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(718),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(753),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(707),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_delay__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_delay__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    alert: { required: true },
    type: { type: String, default: 'text' }
  },
  data: function data() {
    return {
      show: false
    };
  },

  computed: {
    variant: function variant() {
      return this.alert.variant;
    },
    message: function message() {
      return this.alert.message;
    },
    icon: function icon() {
      switch (this.alert.variant) {
        case 'success':
          return 'fa-check';
        case 'warning':
          return 'fa-exclamation-circle';
        case 'danger':
          return 'fa-times-circle';
        case 'info':
          return 'fa-info-circle';
      }
    }
  },
  watch: {
    alert: function alert(val) {
      var _this = this;

      if (!val) {
        this.show = false;
      } else if (!this.show) {
        this.show = true;
        __WEBPACK_IMPORTED_MODULE_0_lodash_delay___default()(function () {
          _this.show = false;
          _this.$emit('update:alert', false);
        }, 5000); // Close alert after 5 seconds
      }
    }
  }
});

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(721),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(573)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(687),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(686),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(766),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fe838bd4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(750),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(578)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(708),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d59abe2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(574)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(689),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b1ebcd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(579)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(711),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46308c3a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(692),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */,
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_alerts_Alert_vue__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_alerts_Alert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_alerts_Alert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_alerts_TextAlert_vue__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_alerts_TextAlert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_alerts_TextAlert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);




/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('alert', __WEBPACK_IMPORTED_MODULE_0__common_alerts_Alert_vue___default.a);
    Vue.component('text-alert', __WEBPACK_IMPORTED_MODULE_1__common_alerts_TextAlert_vue___default.a);
    Vue.component('exclude-toggle', __webpack_require__(292).default);
    Vue.component('multiselect', __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a);
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters_capitalize__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters_money__ = __webpack_require__(330);



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.filter('capitalize', __WEBPACK_IMPORTED_MODULE_0__filters_capitalize__["a" /* default */]);
    Vue.filter('money', __WEBPACK_IMPORTED_MODULE_1__filters_money__["a" /* default */]);
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_DefaultLayout__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_DefaultLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layout_DefaultLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_LoginPage__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_LoginPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__auth_LoginPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboard_DashboardPage__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboard_DashboardPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__dashboard_DashboardPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__orders_OrdersPage__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__orders_OrdersPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__orders_OrdersPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__refunds_RefundsPage__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__refunds_RefundsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__refunds_RefundsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__products_ProductsPage__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__products_ProductsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__products_ProductsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_UsersPage__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_UsersPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__users_UsersPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settings_SettingsPage__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settings_SettingsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__settings_SettingsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sales_channels_SalesChannelsPage__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sales_channels_SalesChannelsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__sales_channels_SalesChannelsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dropshipment_DropshipmentPage__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dropshipment_DropshipmentPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__dropshipment_DropshipmentPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__orders_PickOrdersPage__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__orders_PickOrdersPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__orders_PickOrdersPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reports_ReportProductsPage__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reports_ReportProductsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__reports_ReportProductsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reports_RevenueReportPage__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reports_RevenueReportPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__reports_RevenueReportPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reports_ReportProfitMarginPage__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reports_ReportProfitMarginPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__reports_ReportProfitMarginPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__employees_HourRegistrationPage__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__employees_HourRegistrationPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__employees_HourRegistrationPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__reports_PurchasingValuesOrdersPage__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__reports_PurchasingValuesOrdersPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__reports_PurchasingValuesOrdersPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__order_lists_OrderListPage__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__order_lists_OrderListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__order_lists_OrderListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__products_UnknownProductsPage__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__products_UnknownProductsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__products_UnknownProductsPage__);




// Components



















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_4__auth_LoginPage___default.a,
    beforeEnter: rejectIfAuthenticated
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__layout_DefaultLayout___default.a,
    beforeEnter: rejectIfNotAuthenticated,
    children: [{ path: '/', name: 'dashboard', component: __WEBPACK_IMPORTED_MODULE_5__dashboard_DashboardPage___default.a }, { path: '/bestellingen', name: 'orders', component: __WEBPACK_IMPORTED_MODULE_6__orders_OrdersPage___default.a }, { path: '/bestellingen/pick', name: 'pick-orders', component: __WEBPACK_IMPORTED_MODULE_13__orders_PickOrdersPage___default.a }, { path: '/producten', name: 'products', component: __WEBPACK_IMPORTED_MODULE_8__products_ProductsPage___default.a }, { path: '/retouren', name: 'refunds', component: __WEBPACK_IMPORTED_MODULE_7__refunds_RefundsPage___default.a }, { path: '/gebruikers', name: 'users', component: __WEBPACK_IMPORTED_MODULE_9__users_UsersPage___default.a }, { path: '/verkoopkanalen', name: 'sales-channels', component: __WEBPACK_IMPORTED_MODULE_11__sales_channels_SalesChannelsPage___default.a }, { path: '/dropshipmentkanalen', name: 'dropshipment', component: __WEBPACK_IMPORTED_MODULE_12__dropshipment_DropshipmentPage___default.a }, { path: '/settings', name: 'settings', component: __WEBPACK_IMPORTED_MODULE_10__settings_SettingsPage___default.a }, { path: '/rapportage/producten', name: 'report_products', component: __WEBPACK_IMPORTED_MODULE_14__reports_ReportProductsPage___default.a }, { path: '/rapportage/winstmarges', name: 'report_profit_margins', component: __WEBPACK_IMPORTED_MODULE_16__reports_ReportProfitMarginPage___default.a }, { path: '/rapportage/omzet', name: 'report_revenue', component: __WEBPACK_IMPORTED_MODULE_15__reports_RevenueReportPage___default.a },
    // { path: '/producten/voorraadwaarde', name: 'stock_value', component: StockValuePage },
    { path: '/urenregistratie', name: 'hour_registration', component: __WEBPACK_IMPORTED_MODULE_17__employees_HourRegistrationPage___default.a }, { path: '/rapportage/inkoopwaarde/orders', name: 'report_purchasing_value_orders', component: __WEBPACK_IMPORTED_MODULE_18__reports_PurchasingValuesOrdersPage___default.a },
    // { path: '/voorraadmanagement', name: 'stock_management', component: StockManagementPage },
    { path: '/bestellijst', name: 'order_lists', component: __WEBPACK_IMPORTED_MODULE_19__order_lists_OrderListPage___default.a }, { path: '/producten/onbekend', name: 'unknown_products', component: __WEBPACK_IMPORTED_MODULE_20__products_UnknownProductsPage___default.a }]
  }],
  mode: 'history',
  linkExactActiveClass: 'active'
}));

function rejectIfNotAuthenticated(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_2__utils_auth__["isAuthenticated"]()) {
    return next({ name: 'login', query: { session_expired: true } });
  }

  __WEBPACK_IMPORTED_MODULE_2__utils_auth__["loadUser"]().then(function () {
    return next();
  });
}

function rejectIfAuthenticated(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_2__utils_auth__["isAuthenticated"]()) {
    return next({ name: 'dashboard' });
  }
  return next();
}

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["syncProducts"] = syncProducts;
/* harmony export (immutable) */ __webpack_exports__["getProduct"] = getProduct;
/* harmony export (immutable) */ __webpack_exports__["removeProduct"] = removeProduct;
/* harmony export (immutable) */ __webpack_exports__["getOrder"] = getOrder;
/* harmony export (immutable) */ __webpack_exports__["getOrderNotification"] = getOrderNotification;
/* harmony export (immutable) */ __webpack_exports__["syncAllOrders"] = syncAllOrders;
/* harmony export (immutable) */ __webpack_exports__["syncOrders"] = syncOrders;
/* harmony export (immutable) */ __webpack_exports__["syncRefunds"] = syncRefunds;
/* harmony export (immutable) */ __webpack_exports__["syncStocks"] = syncStocks;
/* harmony export (immutable) */ __webpack_exports__["getOrders"] = getOrders;
/* harmony export (immutable) */ __webpack_exports__["getOrderReport"] = getOrderReport;
/* harmony export (immutable) */ __webpack_exports__["getOrderReportTotals"] = getOrderReportTotals;
/* harmony export (immutable) */ __webpack_exports__["getRefunds"] = getRefunds;
/* harmony export (immutable) */ __webpack_exports__["getRefund"] = getRefund;
/* harmony export (immutable) */ __webpack_exports__["getHourRegistrations"] = getHourRegistrations;
/* harmony export (immutable) */ __webpack_exports__["getOrderLists"] = getOrderLists;
/* harmony export (immutable) */ __webpack_exports__["getOrderList"] = getOrderList;
/* harmony export (immutable) */ __webpack_exports__["getOrderNumbers"] = getOrderNumbers;
/* harmony export (immutable) */ __webpack_exports__["changeOrderStatus"] = changeOrderStatus;
/* harmony export (immutable) */ __webpack_exports__["createShipment"] = createShipment;
/* harmony export (immutable) */ __webpack_exports__["getShippingCosts"] = getShippingCosts;
/* harmony export (immutable) */ __webpack_exports__["getBarcodeScanners"] = getBarcodeScanners;
/* harmony export (immutable) */ __webpack_exports__["getSalesChannelCommissions"] = getSalesChannelCommissions;
/* harmony export (immutable) */ __webpack_exports__["printLabel"] = printLabel;
/* harmony export (immutable) */ __webpack_exports__["printInvoices"] = printInvoices;
/* harmony export (immutable) */ __webpack_exports__["getJobs"] = getJobs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/*
 * Products
 */
function syncProducts(salesChannelKey) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/sales-channels/' + salesChannelKey + '/import-products');
}
function getProduct(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/products/' + id, { params: params });
}
function removeProduct(id) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete('/products/' + id);
}

/*
 * Orders
 */
function getOrder(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/orders/' + id, { params: params });
}

function getOrderNotification() {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/order-notification');
}

function syncAllOrders() {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/sales-channels/import-orders');
}

function syncOrders(salesChannelKey) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/sales-channels/' + salesChannelKey + '/import-orders');
}

function syncRefunds(salesChannelKey) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/sales-channels/' + salesChannelKey + '/import-refunds');
}

function syncStocks(salesChannelKey) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/sales-channels/' + salesChannelKey + '/sync-stocks');
}

function getOrders(params) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/orders', { params: params });
}

function getOrderReport(params) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/report-orders', { params: params });
}

function getOrderReportTotals(params) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/report-orders-totals', { params: params });
}

function getRefunds(params) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/refunds', { params: params });
}

function getRefund(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/refunds/' + id, { params: params });
}

function getHourRegistrations(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/hour-registrations/' + id, { params: params });
}

function getOrderLists(params) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/order-list', { params: params });
}

function getOrderList(id, params) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/order-list/' + id, { params: params });
}

function getOrderNumbers(params) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/orders', { params: params }).then(function (orders) {
    return orders.data.data.map(function (o) {
      return o.number;
    });
  });
}

function changeOrderStatus(orderNumbers, status) {
  var params = {
    'filter[number]': orderNumbers
  };

  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch('/orders', { status: status }, { params: params });
}

function createShipment(data) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/shipments', data);
}

function getShippingCosts() {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/shipping-costs');
}

function getBarcodeScanners() {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/barcode-scanners');
}

function getSalesChannelCommissions() {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/sales-channels-commission');
}

function printLabel(id) {
  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/shipments/' + id + '/print');
}

function printInvoices(orderNumbers) {
  var params = {
    'orders': orderNumbers
  };

  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/invoices/print', null, { params: params });
}

function getJobs() {
  var params = {
    'filter[status]': 'executing,queued,finished',
    'filter[finished_after]': __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(8, 's').format()
  };

  return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/jobs', { params: params }).then(function (response) {
    return response.data;
  });
}

/***/ }),
/* 305 */,
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */,
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(709),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'Society of lifestyle',
  type: 'society_of_lifestyle',
  syncs: true,
  sync_interval: 'daily',
  sync_time: '01:00'
}, {
  name: 'Present time',
  type: 'present_time',
  syncs: false,
  sync_interval: 'none'
}, {
  name: 'De eekhoorn',
  type: 'de_eekhoorn',
  syncs: true,
  sync_interval: 'daily',
  sync_time: '20:00'
}]);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if (!value && value !== 0) return '';
  return '€ ' + value.toFixed(2);
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_auth__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_api__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_filters__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_moment__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment_locale_nl__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment_locale_nl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment_locale_nl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_swiper_dist_css_swiper_css__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_swiper_dist_css_swiper_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














// CSS




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_3__utils_http__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$auth = __WEBPACK_IMPORTED_MODULE_4__utils_auth__;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api = __WEBPACK_IMPORTED_MODULE_5__utils_api__;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$swal = __WEBPACK_IMPORTED_MODULE_7_sweetalert___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__global_components__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__global_filters__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_moment___default.a, { moment: __WEBPACK_IMPORTED_MODULE_11_moment___default.a });

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  maintainAspectRatio: false,
  legend: {
    position: 'right',
    labels: {
      fontFamily: 'monospace',
      fontSize: 16
    }
  },
  scales: {
    xAxes: [{
      ticks: {
        fontSize: 16,
        minRotation: 45
      }
    }],
    yAxes: [{
      ticks: {
        fontSize: 16,
        callback: function callback(value, index, values) {
          return '€' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        }
      }
    }]
  },
  tooltips: {
    callbacks: {
      label: function label(tooltipItem) {
        var label = tooltipItem.yLabel;
        return '€' + label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChartOptions_js__ = __webpack_require__(332);


/* harmony default export */ __webpack_exports__["a"] = ({
  // stepSize: null,
  // maxSize: null,
  // isFixedScale: true,
  mode: 'channels',
  keySalesStatsArray: [],
  isOnlyCompleted: false,
  isUpToToday: true,
  isIncVat: false,
  isLast: false,
  correction: 1,
  period: 'Dit kwartaal',
  periodArray: {
    'Dit jaar': 'this-year',
    'Dit kwartaal': 'this-quarter',
    'Deze maand': 'this-month',
    'Deze week': 'this-week',
    'Vandaag': 'this-day',
    '--------------': '',
    'Vorig jaar': 'last-year',
    'Vorig kwartaal': 'last-quarter',
    'Vorige maand': 'last-month',
    'Vorige week': 'last-week',
    'Gisteren': 'last-day'
  },
  amount: 10,
  amountArray: [1, 4, 7, 10],
  totals: {},
  revenueArrays: {},
  labelArray: {},
  maxItemLength: 0,
  totalRevenue: [0, 0],
  totalOrders: [0, 0],
  revenuePerOrder: [0, 0],
  totalProducts: [0, 0],
  productsPerOrder: [0, 0],
  dataCollection: [{}, {}],
  index: [0, 1],
  fields: {
    name: {
      label: 'Product',
      thStyle: 'width: 40%;',
      sortable: true
    },
    total_revenue: {
      label: 'Omzet',
      thStyle: 'width: 15%;',
      sortable: true
    },
    total_revenue_last_year: {
      label: '(vorig jaar)',
      thStyle: 'width: 15%;',
      sortable: false
    },
    total_sold: {
      label: 'Aantal',
      thStyle: 'width: 15%;',
      sortable: true
    },
    total_sold_last_year: {
      label: '(vorig jaar)',
      thStyle: 'width: 15%;',
      sortable: false
    }
  },
  allProducts: {},
  detailModalProductId: null,
  chartOptions: __WEBPACK_IMPORTED_MODULE_0__ChartOptions_js__["a" /* default */]
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(289);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      alert: false,
      remember: false,
      loading: false
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.loading = true;
      this.$auth.login(this.username, this.password).then(function () {
        _this.loading = false;
        _this.$router.push({ name: 'dashboard' });
      }).catch(function (error) {
        _this.loading = false;
        if (error.response && error.response.status === 401) {
          _this.alert = { variant: 'danger', message: 'Onjuiste inloggegevens.' };
        } else {
          _this.alert = { variant: 'danger', message: 'Er is een fout opgetreden.' };
        }
      });
    }
  },
  mounted: function mounted() {
    if (this.$route.query.session_expired) {
      this.$swal('Sessie verlopen 😴', 'Log opnieuw in.', 'warning');
      this.$router.replace({ name: 'login' });
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BarcodeScannerType_vue__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BarcodeScannerType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BarcodeScannerType_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__socket__ = __webpack_require__(21);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BarcodeScannerType: __WEBPACK_IMPORTED_MODULE_1__BarcodeScannerType_vue___default.a
  },
  data: function data() {
    return {
      barcodeScanners: null
    };
  },

  methods: {
    loadBarcodeScanners: function loadBarcodeScanners() {
      var _this = this;

      this.$api.getBarcodeScanners().then(function (result) {
        _this.barcodeScanners = result.data;
      }).catch(function () {
        _this.$swal('Ehmm...', 'We konden geen barcode scanners vinden. Probeer het opnieuw.', 'warning');
      });
    },
    connectToBarcodeScanner: function connectToBarcodeScanner(usbDevice) {
      var sendMessage = __WEBPACK_IMPORTED_MODULE_2__socket__["a" /* default */].send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        usb_device: usbDevice
      }));

      if (sendMessage) {
        __WEBPACK_IMPORTED_MODULE_2__socket__["a" /* default */].connectedToBarcodeScanner = true;
        this.$swal('Hoera 😊', 'Succesvol verbonden met de barcode scanner.', 'success');
        this.$refs.modal.hide();
      } else {
        this.$swal('Ehmm...', 'Er is iets misgegaan met het verbinden naar de barcode scanner. Probeer het opnieuw.', 'warning');
        this.$refs.modal.hide();
      }
    }
  },
  created: function created() {
    this.loadBarcodeScanners();
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    icon: String
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('click', e);
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BarcodeScannerDetailModal_vue__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BarcodeScannerDetailModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BarcodeScannerDetailModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__socket__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BarcodeScannerDetailModal: __WEBPACK_IMPORTED_MODULE_0__BarcodeScannerDetailModal_vue___default.a
  },
  data: function data() {
    return {
      showBarcodeScannerModal: null,
      isConnectedToScanner: false
    };
  },

  methods: {
    openBarcodeScannerModal: function openBarcodeScannerModal() {
      this.showBarcodeScannerModal = true;
    },
    isConnectedToBarcodeScanner: function isConnectedToBarcodeScanner() {
      if (__WEBPACK_IMPORTED_MODULE_1__socket__["a" /* default */].connectedToBarcodeScanner) {
        this.isConnectedToScanner = true;
      }
    },
    disconnectFromBarcodeScanner: function disconnectFromBarcodeScanner() {
      __WEBPACK_IMPORTED_MODULE_1__socket__["a" /* default */].close();
      this.$swal('Hoera 😊', 'Succesvol ontkoppeld met de barcode scanner.', 'success');
      this.isConnectedToScanner = false;
      __WEBPACK_IMPORTED_MODULE_1__socket__["a" /* default */].connectedToBarcodeScanner = false;
    }
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_1__socket__["a" /* default */].connectedToBarcodeScanner) {
      this.isConnectedToScanner = true;
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    fields: { type: Object, required: true },
    items: { type: Function, required: true },
    defaultSortBy: { type: String, required: true },
    itemLabelSingular: { type: String, default: 'item' },
    itemLabelPlural: { type: String, default: 'items' },
    hideSearchBar: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      totalRows: null,
      perPage: 10,
      currentPage: 1,
      filter: '',
      sortBy: null,
      sortDesc: false
    };
  },

  computed: {
    totalPages: function totalPages() {
      return this.totalRows / this.perPage;
    },
    currentStart: function currentStart() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    currentEnd: function currentEnd() {
      var end = (this.currentPage - 1) * this.perPage + this.perPage;
      if (end > this.totalRows) {
        return this.totalRows;
      }

      return end;
    },
    table: function table() {
      return this.$refs.table;
    },
    searchInput: function searchInput() {
      return this.$refs.searchInput;
    },
    editableFields: function editableFields() {
      return this.fields.filter(function (field) {
        return field.editable === true;
      });
    }
  },
  methods: {
    getItems: function getItems(ctx) {
      var _this = this;

      var params = {};
      // Limit results per page
      params.per_page = ctx.perPage;

      // Add sort param
      if (ctx.sortBy) {
        params['sort'] = ctx.sortDesc ? ctx.sortBy : '-' + ctx.sortBy;
      } else {
        params['sort'] = '-' + this.defaultSortBy;
      }

      // Add search filter params
      if (ctx.filter) {
        var q = ctx.filter.trim();
        params['filter[search]'] = q;
      }
      // Skip pages
      if (ctx.currentPage > 1) {
        params.page = ctx.currentPage;
      }

      // Run request
      return this.items(params).then(function (response) {
        _this.totalRows = response.data.total;
        return response.data.data;
      }).catch(function () {
        _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het ophalen van de ' + _this.itemLabelPlural + '. Probeer het opnieuw.', 'error');
        return [];
      });
    },
    next: function next() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    previous: function previous() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    refresh: function refresh() {
      this.table.refresh();
    },

    search: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (e) {
      this.filter = this.searchInput.value;
      this.currentPage = 1;
    }, 300),
    clearFilter: function clearFilter() {
      this.filter = '';
      this.searchInput.value = '';
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.barcode = '';
    this.timeoutHandler = null;
  },
  mounted: function mounted() {
    document.addEventListener('keypress', this.onKeypress);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keypress', this.onKeypress);
  },

  methods: {
    onKeypress: function onKeypress(e) {
      var _this = this;

      this.barcode += e.key;

      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler);
      }

      this.timeoutHandler = setTimeout(function () {
        if (_this.barcode.length <= 5) {
          _this.barcode = '';
          return;
        }

        if (_this.barcode.endsWith('Enter')) {
          _this.barcode = _this.barcode.slice(0, -5);
        }

        _this.$emit('scan', _this.barcode);
        _this.barcode = '';
      }, 10);
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'route', 'icon', 'iconClass']
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alert_mixin__ = __webpack_require__(97);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__alert_mixin__["a" /* default */]]
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alert_mixin__ = __webpack_require__(97);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__alert_mixin__["a" /* default */]]
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Tile__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Tile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_Tile__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Tile: __WEBPACK_IMPORTED_MODULE_0__common_Tile___default.a }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Tile__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Tile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_Tile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdminDashboard_vue__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdminDashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AdminDashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderPickerDashboard_vue__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderPickerDashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OrderPickerDashboard_vue__);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Tile: __WEBPACK_IMPORTED_MODULE_0__common_Tile___default.a, AdminDashboard: __WEBPACK_IMPORTED_MODULE_1__AdminDashboard_vue___default.a, OrderPickerDashboard: __WEBPACK_IMPORTED_MODULE_2__OrderPickerDashboard_vue___default.a },
  data: function data() {
    return {
      user: this.$auth.getUser()
    };
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Tile__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Tile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_Tile__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Tile: __WEBPACK_IMPORTED_MODULE_0__common_Tile___default.a }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendors__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DropshipmentWidget__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DropshipmentWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DropshipmentWidget__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DropshipmentWidget: __WEBPACK_IMPORTED_MODULE_1__DropshipmentWidget___default.a },
  data: function data() {
    return {
      vendors: __WEBPACK_IMPORTED_MODULE_0__vendors__["a" /* default */]
    };
  },

  methods: {}
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__products_LocationEditable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__products_LocationEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__products_LocationEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_FieldEditable__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_FieldEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__products_FieldEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__products_StockEditable__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__products_StockEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__products_StockEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__products_PriceEditable__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__products_PriceEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__products_PriceEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__products_SalePriceEditable__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__products_SalePriceEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__products_SalePriceEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ApiTableBlock__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ApiTableBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_ApiTableBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__products_ProductDetailModal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__products_ProductDetailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__products_ProductDetailModal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LocationEditable: __WEBPACK_IMPORTED_MODULE_1__products_LocationEditable___default.a,
    FieldEditable: __WEBPACK_IMPORTED_MODULE_2__products_FieldEditable___default.a,
    StockEditable: __WEBPACK_IMPORTED_MODULE_3__products_StockEditable___default.a,
    PriceEditable: __WEBPACK_IMPORTED_MODULE_4__products_PriceEditable___default.a,
    SalePriceEditable: __WEBPACK_IMPORTED_MODULE_5__products_SalePriceEditable___default.a,
    ApiTableBlock: __WEBPACK_IMPORTED_MODULE_6__common_ApiTableBlock___default.a,
    ProductDetailModal: __WEBPACK_IMPORTED_MODULE_7__products_ProductDetailModal___default.a
  },
  props: {
    vendor: Object
  },
  data: function data() {
    return {
      fields: {
        name: {
          label: 'Product',
          thStyle: 'width: 30%;',
          sortable: true
        },
        price: {
          label: 'Prijs',
          thStyle: 'width: 20%;',
          sortable: true
        },
        stock_quantity: {
          label: 'Voorraad',
          thStyle: 'width: 20%;',
          sortable: true
        },
        location: {
          label: 'Locaties',
          thStyle: 'width: 20%;',
          sortable: true
        }
      },
      detailModalProductId: null
    };
  },

  methods: {
    findAllProducts: function findAllProducts(params) {
      params['filter[dropship]'] = this.vendor.type;

      return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/products', { params: params });
    },
    details: function details(product) {
      this.detailModalProductId = product.id;
    },
    refresh: function refresh() {
      this.$refs.productsTable.refresh();
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropshipmentProductsTable__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropshipmentProductsTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DropshipmentProductsTable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DropshipmentProductsTable: __WEBPACK_IMPORTED_MODULE_0__DropshipmentProductsTable___default.a
  },
  props: {
    vendor: Object
  },
  data: function data() {
    return {
      products: {},
      showProductsTable: false
    };
  },

  methods: {
    loadProducts: function loadProducts() {
      var _this = this;

      var params = {};

      params['filter[dropship]'] = this.vendor.type;

      this.$http.get('/products', { params: params }).then(function (result) {
        _this.products = result.data;
      }).catch(function () {
        _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het ophalen van de dropshipment producten. Probeer het opnieuw.', 'error');
      });
    },
    openProductsTable: function openProductsTable() {
      this.showProductsTable = true;
    }
  },
  created: function created() {
    this.loadProducts();
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HourRegistrationTable_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HourRegistrationTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HourRegistrationTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HourRegistrationTable: __WEBPACK_IMPORTED_MODULE_0__HourRegistrationTable_vue___default.a
  },
  data: function data() {
    return {
      hourRegistrationStarted: false
    };
  },

  methods: {
    refresh: function refresh() {
      this.$refs.registrationTable.refresh();
    },
    startHourRegistration: function startHourRegistration() {
      var _this = this;

      this.$http.get('/hour-registration/start').then(function (response) {
        _this.refresh();
        _this.hourRegistrationStarted = true;
      }).catch(function () {
        _this.$swal('Oeps! 😳', 'Er is iets fout bij het starten van de uren registratie Probeer het opnieuw.', 'error');
      });
    },
    stopHourRegistartion: function stopHourRegistartion() {
      var _this2 = this;

      this.$http.get('/hour-registration/stop').then(function (response) {
        _this2.refresh();
        _this2.hourRegistrationStarted = false;
      }).catch(function () {
        _this2.$swal('Oeps! 😳', 'Er is iets fout bij het stoppen van de uren registratie Probeer het opnieuw.', 'error');
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.get('/hour-registration/latest').then(function (response) {
      if (!response.data.data.stopped_at) {
        _this3.hourRegistrationStarted = true;
      }
    });
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ApiTableBlock: __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock___default.a
  },
  props: {
    userId: Number,
    role: String
  },
  data: function data() {
    return {
      fields: {
        created_at: {
          label: 'Datum',
          thStyle: 'width: 20%;'
        },
        display_start: {
          label: 'Start',
          thStyle: 'width: 20%;',
          editable: true
        },
        display_stop: {
          label: 'Stop',
          thStyle: 'width: 20%;',
          editable: true
        },
        hours_worked: {
          label: 'Aantal uur gewerkt',
          thStyle: 'width: 20%;'
        },
        actions: {
          label: 'Acties',
          thStyle: 'width: 20%;'
        }
      }
    };
  },

  computed: {
    registrationTable: function registrationTable() {
      return this.$refs.registrationTable;
    }
  },
  methods: {
    loadHourRegistrations: function loadHourRegistrations(params) {
      return this.$api.getHourRegistrations(this.userId, params);
    },
    refresh: function refresh() {
      this.registrationTable.refresh();
    },
    doEdit: function doEdit(item) {
      this.$set(item, 'temp', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item)));
      this.$set(item, 'editing', true);
    },
    doSave: function doSave(item) {
      var _this = this;

      var data = {
        'started_at': item.temp['display_start'],
        'stopped_at': item.temp['display_stop'],
        'created_at': item.temp['created_at']
      };

      this.$http.patch('/hour-registrations/' + item.id, data).then(function (result) {
        _this.$swal('Hoera 😊', 'De uren registratie is succesvol bijgewerkt.', 'success');
        _this.$set(item, 'editing', false);
        _this.refresh();
      }).catch(function () {
        _this.$swal('Ehmm...', 'Er is iets misgegaan bij het bijwerken van deze uren registratie. Probeer het opnieuw.', 'warning');
      });
    },
    doCancel: function doCancel(item) {
      this.$set(item, 'editing', false);
      this.$delete(item, 'temp');
    },
    deleteEntry: function deleteEntry(id) {
      var _this2 = this;

      this.$http.delete('/hour-registration/' + id).then(function (response) {
        _this2.refresh();
      }).catch(function () {
        _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het verwijderen Probeer het opnieuw.', 'error');
      });
    }
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JobListItem__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JobListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__JobListItem__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { JobListItem: __WEBPACK_IMPORTED_MODULE_0__JobListItem___default.a },
  data: function data() {
    return {
      jobs: []
    };
  },

  watch: {
    jobs: function jobs(val) {
      if (val.length) {
        this.startPoller();
      } else {
        this.stopPoller();
      }
    }
  },
  methods: {
    load: function load() {
      var _this = this;

      this.$api.getJobs().then(function (result) {
        _this.jobs = result.data;
      });
    },
    startPoller: function startPoller() {
      var _this2 = this;

      this.stopPoller();
      this.poller = setInterval(function () {
        _this2.load();
      }, 5000); // poll every 5 seconds
    },
    stopPoller: function stopPoller() {
      clearInterval(this.poller);
    }
  },
  created: function created() {
    this.load();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopPoller();
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var types = {
  'VMControl\\SalesChannel\\Jobs\\ImportProducts': 'Producten importeren',
  'VMControl\\SalesChannel\\Jobs\\ImportNewOrders': 'Bestellingen importeren'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    job: Object
  },
  computed: {
    name: function name() {
      return types[this.job.type];
    },
    progress: function progress() {
      var step = 100 / this.job.progress_max;
      return step * this.job.progress_now;
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_Sidebar__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_Header__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Footer__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_Footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'vmc-sidebar': __WEBPACK_IMPORTED_MODULE_0__partials_Sidebar___default.a,
    'vmc-header': __WEBPACK_IMPORTED_MODULE_1__partials_Header___default.a,
    'vmc-footer': __WEBPACK_IMPORTED_MODULE_2__partials_Footer___default.a
  },
  data: function data() {
    return {
      sidebarOpen: true
    };
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      amountUnknownProducts: null
    };
  },

  methods: {
    loadUnknownProducts: function loadUnknownProducts() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/products-unknown-count').then(function (result) {
        if (result.data > 0) {
          _this.amountUnknownProducts = result.data;
        }
      }).catch(function () {});
    }
  },
  created: function created() {
    this.loadUnknownProducts();
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: this.$auth.getUser()
    };
  },

  methods: {
    logout: function logout() {
      this.$auth.logout();
      this.$router.push({ name: 'login' });
    },
    toggleSidebar: function toggleSidebar() {
      this.$emit('toggle-sidebar');
    }
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdminSidebar_vue__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdminSidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AdminSidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderPickerSidebar_vue__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderPickerSidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__OrderPickerSidebar_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AdminSidebar: __WEBPACK_IMPORTED_MODULE_0__AdminSidebar_vue___default.a, OrderPickerSidebar: __WEBPACK_IMPORTED_MODULE_1__OrderPickerSidebar_vue___default.a },
  data: function data() {
    return {
      user: this.$auth.getUser()
    };
  },

  methods: {
    logout: function logout() {
      this.$auth.logout();
      this.$router.push({ name: 'login' });
    },
    closeSidebar: function closeSidebar() {
      this.$emit('close-sidebar');
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__barcode_scanner_socket__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_UnkownProductModal_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_UnkownProductModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__products_UnkownProductModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__products_LocationEditable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__products_LocationEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__products_LocationEditable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UnkownProductModal: __WEBPACK_IMPORTED_MODULE_2__products_UnkownProductModal_vue___default.a,
    LocationEditable: __WEBPACK_IMPORTED_MODULE_3__products_LocationEditable___default.a
  },
  props: {
    orderListId: Number
  },
  data: function data() {
    return {
      unkownProductScanned: null,
      scannedBarcode: null,
      scannedProduct: null,
      deliveredAmount: null,
      orderList: null
    };
  },

  methods: {
    loadOrderList: function loadOrderList() {
      var _this = this;

      var params = {
        include: 'lines'
      };
      this.$api.getOrderList(this.orderListId, params).then(function (result) {
        _this.orderList = result.data.data;
      }).catch(function () {
        _this.$swal('Ehmm...', 'Er is iets fout gegaan. Probeer het opnieuw.', 'warning');
        _this.$refs.modal.hide();
      });
    },
    handleMessage: function handleMessage(event) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/product-scanned/' + event).then(function (result) {
        if (result.data.data === 'unknown_product') {
          _this2.unkownProductScanned = true;
          _this2.scannedBarcode = event;
          return;
        }
        var product = result.data.data;
        if (!_this2.isProductInOrderList(product.sku)) {
          _this2.$swal('Ehmm...', 'Dit product is geen onderdeel van de te controleren inkooporder. Probeer het opnieuw.', 'warning');
          return;
        }
        _this2.scannedProduct = product;
      }).catch(function () {
        _this2.$swal('Ehmm...', 'Deze product konden we niet vinden. Probeer het opnieuw.', 'warning');
      });
    },
    isProductInOrderList: function isProductInOrderList(sku) {
      return this.orderList.lines.filter(function (e) {
        return e.product_sku === sku;
      }).length > 0;
    },
    completeOrderList: function completeOrderList() {
      var _this3 = this;

      var status = 'completed';
      if (this.orderList.lines.filter(function (e) {
        return e.delivered_quantity !== e.ordered_quantity;
      }).length > 0) {
        status = 'incomplete';
      }
      var data = {
        status: status
      };
      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].patch('/order-list/' + this.orderList.id, data).then(function (response) {
        _this3.$swal('Hoera 😊', 'De inkooporder is sucessvol bijgeboekt.', 'success');
        _this3.$refs.modal.hide();
      }).catch(function () {
        _this3.$swal('Ehmm...', 'Er is iets misgegaan bij het verwerken van deze inkooporder. Probeer het opnieuw.', 'warning');
      });
    },
    handleUnkownProductCreated: function handleUnkownProductCreated(event) {
      var _this4 = this;

      var data = {
        order_list_id: this.orderListId,
        product_sku: event.product.sku
      };

      this.$http.post('/order-list-line', data).then(function (response) {
        _this4.scannedProduct = event.product;
      }).catch(function () {
        _this4.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het toevoegen van het onbekende product aan de inkooporder.  Probeer het opnieuw.', 'error');
      });
    },
    bookProduct: function bookProduct() {
      var _this5 = this;

      var data = {
        product_sku: this.scannedProduct.sku,
        delivered_quantity: this.deliveredAmount
      };
      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].patch('/book-order-list-line/' + this.orderListId, data).then(function (result) {
        _this5.$swal('Hoera 😊', 'Het product is succesvol bijgeboekt.', 'success');
        _this5.scannedProduct = null;
        _this5.deliveredAmount = null;
        _this5.loadOrderList();
      }).catch(function () {
        _this5.$swal('Ehmm...', 'Er is iets misgegaan bij het bijboeken van dit product. Probeer het opnieuw.', 'warning');
      });
    }
  },
  created: function created() {
    this.loadOrderList();
    __WEBPACK_IMPORTED_MODULE_1__barcode_scanner_socket__["a" /* default */].$on('message', this.handleMessage);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__barcode_scanner_socket__["a" /* default */].$off('message', this.handleMessage);
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__barcode_scanner_socket__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_UnkownProductModal_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_UnkownProductModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__products_UnkownProductModal_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UnkownProductModal: __WEBPACK_IMPORTED_MODULE_2__products_UnkownProductModal_vue___default.a
  },
  props: {
    productIds: Array,
    fromScratch: Boolean
  },
  data: function data() {
    return {
      orderListName: null,
      supplier: null,
      productName: null,
      products: null,
      orderListProducts: {},
      brands: [],
      showUnknownProductModal: null,
      unknownProductBarcode: null
    };
  },

  methods: {
    createOrderList: function createOrderList() {
      var _this = this;

      var validData = true;
      if (!this.orderListName) {
        validData = false;
      }
      if (!this.supplier) {
        validData = false;
      }
      if (this.productIds.length === 0) {
        validData = false;
      }
      if (validData) {
        var data = {
          product_ids: this.productIds,
          supplier: this.supplier,
          name: this.orderListName
        };

        this.$http.post('/order-list', data).then(function (response) {
          _this.$swal('Hoera 😊', 'De inkooporder is succesvol aangemaakt.', 'success');
          _this.$refs.modal.hide();
        }).catch(function () {
          _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het aanmaken van de inkooporder. Probeer het opnieuw.', 'error');
        });
      } else {
        this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het aanmaken van de inkooporder. Probeer het opnieuw.', 'error');
      }
    },
    getProducts: function getProducts() {
      var _this2 = this;

      var params = {};
      params['filter[search]'] = this.productName;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/products', { params: params }).then(function (response) {
        _this2.products = response.data.data;
      }).catch(function () {
        _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het ophalen van de producten. Probeer het opnieuw.', 'error');
      });
    },
    addProductToOrderList: function addProductToOrderList() {
      if (this.products.length > 1) {
        this.$swal('Oeps! 😳', 'Selecteer 1 product SVP. Probeer het opnieuw.', 'error');
      } else {
        this.$set(this.orderListProducts, this.products[0].sku, this.products[0]);
        if (!this.productIds.includes(this.orderListProducts[this.products[0].sku].id)) {
          this.productIds.push(this.orderListProducts[this.products[0].sku].id);
        }
      }
    },
    loadBrands: function loadBrands() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('brands').then(function (result) {
        _this3.brands = result.data.data;
      });
    },
    handleMessage: function handleMessage(event) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/product-scanned/' + event).then(function (result) {
        if (result.data.data === 'unknown_product') {
          _this4.openUnknownProductModal();
          return;
        }
        _this4.$set(_this4.orderListProducts, result.data.data.sku, result.data.data);
        if (!_this4.productIds.includes(_this4.orderListProducts[result.data.data.sku].id)) {
          _this4.productIds.push(_this4.orderListProducts[result.data.data.sku].id);
        }
      }).catch(function () {
        _this4.$swal('Ehmm...', 'Deze product konden we niet vinden. Probeer het opnieuw.', 'warning');
      });
    },
    handleUnkownProductCreated: function handleUnkownProductCreated(event) {
      this.$set(this.orderListProducts, event.product.sku, event.product);
      if (!this.productIds.includes(this.orderListProducts[event.product.sku].id)) {
        this.productIds.push(this.orderListProducts[event.product.sku].id);
      }
    },
    openUnknownProductModal: function openUnknownProductModal() {
      this.showUnknownProductModal = true;
      this.unknownProductBarcode = this.productName;
    }
  },
  created: function created() {
    this.loadBrands();
    __WEBPACK_IMPORTED_MODULE_1__barcode_scanner_socket__["a" /* default */].$on('message', this.handleMessage);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__barcode_scanner_socket__["a" /* default */].$off('message', this.handleMessage);
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderListStatusBadge_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderListStatusBadge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OrderListStatusBadge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__barcode_scanner_socket__ = __webpack_require__(21);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    OrderListStatusBadge: __WEBPACK_IMPORTED_MODULE_3__OrderListStatusBadge_vue___default.a
  },
  props: {
    orderListId: Number
  },
  data: function data() {
    return {
      products: [],
      orderList: null,
      selectedDate: null,
      predictedProductSales: {},
      toOrderAmountProducts: {},
      toPredictSalesDate: null,
      productName: null
    };
  },

  methods: {
    loadOrderList: function loadOrderList() {
      var _this = this;

      var params = {
        include: 'lines,lines.product,lines.product.saleForecasts'
      };
      this.$api.getOrderList(this.orderListId, params).then(function (result) {
        _this.orderList = result.data.data;
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.predictedProductSales).length === 0 || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.toOrderAmountProducts).length === 0) {
          _this.fillArrays(_this.orderList.lines);
        }
      }).catch(function () {
        _this.$swal('Ehmm...', 'Deze bestellijst konden we niet vinden. Probeer het opnieuw.', 'warning');
        _this.$refs.modal.hide();
      });
    },
    getProducts: function getProducts() {
      var _this2 = this;

      var params = {};
      params['filter[search]'] = this.productName;

      __WEBPACK_IMPORTED_MODULE_2__utils_http__["a" /* default */].get('/products', { params: params }).then(function (response) {
        _this2.products = response.data.data;
      }).catch(function () {
        _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het ophalen van de producten }. Probeer het opnieuw.', 'error');
      });
    },
    addProductToOrderList: function addProductToOrderList() {
      var _this3 = this;

      if (this.products.length > 1) {
        this.$swal('Oeps! 😳', 'Selecteer 1 product SVP. Probeer het opnieuw.', 'error');
        return;
      }
      if (this.predictedProductSales[this.products[0].sku] !== undefined) {
        this.$swal('Oeps! 😳', 'Dit product bestaat al in de bestellijst. Probeer het opnieuw.', 'error');
        return;
      }
      var data = {
        order_list_id: this.orderListId,
        product_sku: this.products[0].sku
      };

      this.$http.post('/order-list-line', data).then(function (response) {
        _this3.$set(_this3.predictedProductSales, _this3.products[0].sku, 0);
        _this3.$set(_this3.toOrderAmountProducts, _this3.products[0].sku, 0);
        _this3.loadOrderList();
      }).catch(function () {
        _this3.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het aanmaken van de bestellijst. Probeer het opnieuw.', 'error');
      });
    },
    predictSalesPerProduct: function predictSalesPerProduct(period, product) {
      var date = new Date(period.target.value);

      var newSalesForecastArray = product.sale_forecasts.filter(function (saleForecast) {
        return new Date(saleForecast.ds) <= date;
      });

      var predictedSales = 0;

      newSalesForecastArray.forEach(function (element) {
        predictedSales += parseFloat(element.yhat);
      });

      this.$set(this.predictedProductSales, product.sku, Math.round(predictedSales));
      this.toOrderAmountProducts[product.sku] = Math.round(predictedSales);
    },
    predictSalesForAllProducts: function predictSalesForAllProducts() {
      var date = new Date(this.toPredictSalesDate);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.orderList.lines), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var line = _step.value;

          var newSalesForecastArray = line.product.sale_forecasts.filter(function (saleForecast) {
            return new Date(saleForecast.ds) <= date;
          });

          var predictedSales = 0;

          newSalesForecastArray.forEach(function (element) {
            predictedSales += parseFloat(element.yhat);
          });

          this.$set(this.predictedProductSales, line.product.sku, Math.round(predictedSales));
          this.toOrderAmountProducts[line.product.sku] = Math.round(predictedSales);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    fillArrays: function fillArrays(lines) {
      var _this4 = this;

      lines.forEach(function (element) {
        _this4.$set(_this4.predictedProductSales, element.product.sku, 0);
        _this4.$set(_this4.toOrderAmountProducts, element.product.sku, 0);
      });
    },
    deleteOrderListLine: function deleteOrderListLine(line) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_http__["a" /* default */].delete('/order-list-line/' + line.id).then(function (result) {
        _this5.loadOrderList();
        delete _this5.predictedProductSales[line.product_sku];
        delete _this5.toOrderAmountProducts[line.product_sku];
      }).catch(function () {
        _this5.$swal('Ehmm...', 'Er is iets misgegaan bij het verwijderen van de nieuwe order notificatie', 'warning');
      });
    },
    updateOrderListLines: function updateOrderListLines(id) {
      var _this6 = this;

      var validData = true;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.orderList.lines), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var line = _step2.value;

          if (this.toOrderAmountProducts[line.product_sku] <= 0 || this.toOrderAmountProducts[line.product_sku] === '') {
            validData = false;
            this.$swal('Ehmm...', 'Alle producten moeten een geldige waarde hebben. Probeer het opnieuw.', 'warning');
            break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (validData) {
        var data = {
          orderListArray: this.toOrderAmountProducts
        };
        __WEBPACK_IMPORTED_MODULE_2__utils_http__["a" /* default */].patch('/order-orderlist-lines/' + id, data).then(function (result) {
          var statusData = {
            status: 'ordered'
          };
          __WEBPACK_IMPORTED_MODULE_2__utils_http__["a" /* default */].patch('/order-list/' + id, statusData).then(function (response) {
            _this6.$swal('Hoera 😊', 'De bestellijst is sucessvol besteld.', 'success');
            _this6.$refs.modal.hide();
          }).catch(function () {
            _this6.$swal('Ehmm...', 'Er is iets misgegaan bij het bestellen van deze bestellijst. Probeer het opnieuw.', 'warning');
          });
        }).catch(function () {
          _this6.$swal('Ehmm...', 'Er is iets misgegaan bij het bestellen van deze bestellijst. Probeer het opnieuw.', 'warning');
        });
      }
    },
    handleMessage: function handleMessage(event) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_http__["a" /* default */].get('/product-scanned/' + event).then(function (result) {
        if (_this7.predictedProductSales[result.data.data.sku] !== undefined) {
          _this7.$swal('Oeps! 😳', 'Dit product bestaat al in de bestellijst. Probeer het opnieuw.', 'error');
          return;
        }
        var data = {
          order_list_id: _this7.orderListId,
          product_sku: result.data.data.sku
        };

        _this7.$http.post('/order-list-line', data).then(function (response) {
          _this7.$set(_this7.predictedProductSales, result.data.data.sku, 0);
          _this7.$set(_this7.toOrderAmountProducts, result.data.data.sku, 0);
          _this7.loadOrderList();
        });
      }).catch(function () {
        _this7.$swal('Ehmm...', 'Deze product konden we niet vinden. Probeer het opnieuw.', 'warning');
      });
    }
  },
  created: function created() {
    this.loadOrderList();
    __WEBPACK_IMPORTED_MODULE_4__barcode_scanner_socket__["a" /* default */].$on('message', this.handleMessage);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4__barcode_scanner_socket__["a" /* default */].$off('message', this.handleMessage);
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ApiTableBlock__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ApiTableBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_ApiTableBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderListDetailModal_vue__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderListDetailModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__OrderListDetailModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderedOrderListModal_vue__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderedOrderListModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OrderedOrderListModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderListStatusBadge_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderListStatusBadge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OrderListStatusBadge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckOrderListModal_vue__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckOrderListModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CheckOrderListModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateOrderListModal_vue__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateOrderListModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CreateOrderListModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__barcode_scanner_SelectBarcodeScannerWidget_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__barcode_scanner_SelectBarcodeScannerWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__barcode_scanner_SelectBarcodeScannerWidget_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ApiTableBlock: __WEBPACK_IMPORTED_MODULE_0__common_ApiTableBlock___default.a,
    OrderListDetailModal: __WEBPACK_IMPORTED_MODULE_1__OrderListDetailModal_vue___default.a,
    OrderListStatusBadge: __WEBPACK_IMPORTED_MODULE_3__OrderListStatusBadge_vue___default.a,
    OrderedOrderListModal: __WEBPACK_IMPORTED_MODULE_2__OrderedOrderListModal_vue___default.a,
    CreateOrderListModal: __WEBPACK_IMPORTED_MODULE_5__CreateOrderListModal_vue___default.a,
    SelectBarcodeScannerWidget: __WEBPACK_IMPORTED_MODULE_6__barcode_scanner_SelectBarcodeScannerWidget_vue___default.a,
    CheckOrderListModal: __WEBPACK_IMPORTED_MODULE_4__CheckOrderListModal_vue___default.a
  },
  data: function data() {
    return {
      fields: {
        name: {
          label: 'Naam',
          sortable: true,
          thStyle: 'width: 30%;'
        },
        supplier: {
          label: 'Leverancier',
          sortable: true,
          thStyle: 'width: 25%;'
        },
        created_at: {
          label: 'Datum',
          sortable: true
        },
        status: {
          label: 'Status',
          sortable: true
        },
        actions: {
          label: 'Acties',
          thStyle: 'width: 150px;'
        }
      },
      selectedOrders: [],
      detailModalOrderListId: null,
      orderedOrderModalListId: null,
      currentStatus: null,
      showCreateOrderListModal: null,
      checkOrderListModalId: null
    };
  },

  computed: {
    orderListsTable: function orderListsTable() {
      return this.$refs.orderListsTable;
    }
  },
  methods: {
    findAllOrders: function findAllOrders(params) {
      params['include'] = 'lines';

      return this.$api.getOrderLists(params);
    },
    refresh: function refresh() {
      this.orderListsTable.refresh();
    },
    openDetailModal: function openDetailModal(orderList) {
      if (orderList.status !== 'concept') {
        this.orderedOrderModalListId = orderList.id;
        this.currentStatus = orderList.status;
      } else {
        this.detailModalOrderListId = orderList.id;
      }
    },
    openCheckOrderListModal: function openCheckOrderListModal(id) {
      this.checkOrderListModalId = id;
    },
    createOrderListModal: function createOrderListModal() {
      this.showCreateOrderListModal = true;
    }
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    orderList: Object
  },
  data: function data() {
    return {
      saving: false,
      alert: false
    };
  },

  computed: {
    status: function status() {
      return this.orderList.status;
    },
    statuses: function statuses() {
      return [{ id: 'concept', label: 'Concept', color: 'danger' }, { id: 'ordered', label: 'Besteld', color: 'info' }, { id: 'delivered', label: 'Geleverd', color: 'info' }, { id: 'verify', label: 'Nog te controleren', color: 'danger' }, { id: 'incomplete', label: 'Incompleet', color: 'danger' }, { id: 'completed', label: 'Afgerond', color: 'success' }];
    },
    currentStatus: function currentStatus() {
      var _this = this;

      return this.statuses.find(function (s) {
        return s.id === _this.status;
      });
    },
    selectableStatuses: function selectableStatuses() {
      return this.statuses.filter(function (s) {
        return s.selectable !== false;
      });
    }
  },
  methods: {
    updateStatus: function updateStatus(newStatus) {
      var _this2 = this;

      var oldStatus = this.orderList.status;
      this.orderList.status = newStatus;

      var data = {
        status: newStatus
      };

      this.saving = true;
      this.$http.patch('/order-list/' + this.orderList.id, data).then(function (response) {
        _this2.saving = false;
        _this2.alert = { variant: 'success', message: 'Opgeslagen' };
      }).catch(function () {
        _this2.saving = false;
        _this2.orderList.status = oldStatus;
        _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het opslaan van de status. Probeer het opnieuw.', 'error');
      });
    }
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderListStatusBadge_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderListStatusBadge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OrderListStatusBadge_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    OrderListStatusBadge: __WEBPACK_IMPORTED_MODULE_2__OrderListStatusBadge_vue___default.a
  },
  props: {
    orderListId: Number,
    status: String
  },
  data: function data() {
    return {
      orderList: null,
      orderedAmounts: {},
      deliveredAmounts: {},
      user: this.$auth.getUser()
    };
  },

  methods: {
    loadOrderList: function loadOrderList() {
      var _this = this;

      var params = {
        include: 'lines,lines.product'
      };
      this.$api.getOrderList(this.orderListId, params).then(function (result) {
        _this.orderList = result.data.data;
        _this.fillArrays(_this.orderList.lines);
      }).catch(function () {
        _this.$swal('Ehmm...', 'Deze bestellijst konden we niet vinden. Probeer het opnieuw.', 'warning');
        _this.$refs.modal.hide();
      });
    },
    fillArrays: function fillArrays(lines) {
      var _this2 = this;

      lines.forEach(function (element) {
        _this2.$set(_this2.orderedAmounts, element.product_sku, element.ordered_quantity);
        _this2.$set(_this2.deliveredAmounts, element.product_sku, element.delivered_quantity);
      });
    },
    updateStockQuantity: function updateStockQuantity() {
      var _this3 = this;

      var validData = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.orderList.lines), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var line = _step.value;

          if (this.orderedAmounts[line.product_sku] < 0 || this.orderedAmounts[line.product_sku] === '') {
            validData = false;
            this.$swal('Ehmm...', 'Alle producten moeten een geldige waarde hebben. Probeer het opnieuw.', 'warning');
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (validData) {
        var data = {
          orderListArray: this.orderedAmounts
        };
        __WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */].patch('/complete-order-list-lines/' + this.orderList.id, data).then(function (result) {
          var statusData = {
            status: 'verify'
          };
          __WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */].patch('/order-list/' + _this3.orderList.id, statusData).then(function (response) {
            _this3.$swal('Hoera 😊', 'De bestellijst is sucessvol bijgeboekt.', 'success');
            _this3.$refs.modal.hide();
          }).catch(function () {
            _this3.$swal('Ehmm...', 'Er is iets misgegaan bij het verwerken van deze bestellijst. Probeer het opnieuw.', 'warning');
          });
        }).catch(function () {
          _this3.$swal('Ehmm...', 'Er is iets misgegaan bij het verwerken van deze bestellijst. Probeer het opnieuw.', 'warning');
        });
      }
    },
    updateDeliveredAmount: function updateDeliveredAmount(line) {
      var _this4 = this;

      var data = {
        delivered_quantity: this.deliveredAmounts[line.product_sku],
        quantity_difference: this.deliveredAmounts[line.product_sku] - line.delivered_quantity
      };
      __WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */].patch('/update-delivered-quantity/' + line.id, data).then(function (result) {
        _this4.$swal('Hoera 😊', 'Het product is sucessvol bijgeboekt.', 'success');
        _this4.loadOrderList();
      }).catch(function () {
        _this4.$swal('Ehmm...', 'Er is iets misgegaan bij het verwerken van deze bestellijst. Probeer het opnieuw.', 'warning');
      });
    }
  },
  created: function created() {
    this.loadOrderList();
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    order: Object
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderStatusBadge__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderStatusBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__OrderStatusBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PackageType__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PackageType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PackageType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderAddress_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderAddress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OrderAddress_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderTimeline_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderTimeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OrderTimeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PostageStampDetailModal_vue__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PostageStampDetailModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PostageStampDetailModal_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    OrderStatusBadge: __WEBPACK_IMPORTED_MODULE_1__OrderStatusBadge___default.a,
    PackageType: __WEBPACK_IMPORTED_MODULE_2__PackageType___default.a,
    OrderAddress: __WEBPACK_IMPORTED_MODULE_3__OrderAddress_vue___default.a,
    OrderTimeline: __WEBPACK_IMPORTED_MODULE_4__OrderTimeline_vue___default.a,
    PostageStampDetailModal: __WEBPACK_IMPORTED_MODULE_5__PostageStampDetailModal_vue___default.a
  },
  props: {
    orderId: Number
  },
  data: function data() {
    return {
      order: null,
      shipment: {
        package_type: 1,
        insurance: false,
        large_format: false
      },
      creatingShipment: false,
      customerPhonenumber: null,
      showPostageStampModal: false,
      orderNotifications: []
    };
  },

  computed: {
    showShipmentOptionToggles: function showShipmentOptionToggles() {
      return this.shipment.package_type === 1 && this.selectedProvider === 'postnl';
    },
    pickedAt: function pickedAt() {
      if (this.order.status === 'picked') {
        return this.order.updated_at;
      }

      if (this.order.status === 'completed') {
        return this.completedAt;
      }

      return null;
    },
    completedAt: function completedAt() {
      if (this.order.status === 'completed') {
        return this.order.shipment ? this.order.shipment.created_at : this.order.updated_at;
      }

      return null;
    },
    invoicePdfUrl: function invoicePdfUrl() {
      var url = "https://api.control.villamadelief.nl" + '/invoices/' + this.order.number + '.pdf';
      url += '?access_token=' + this.$auth.getAccessToken();

      return url;
    },
    invoiceOrderPdfUrl: function invoiceOrderPdfUrl() {
      var url = "https://api.control.villamadelief.nl" + '/invoices/order/' + this.order.number + '.pdf?key=' + this.order.hash;

      return url;
    },
    shipmentPdfUrl: function shipmentPdfUrl() {
      return this.order.shipment.label_url + '?access_token=' + this.$auth.getAccessToken();
    },
    shipmentOptions: function shipmentOptions() {
      return this.order.available_shipment_options || {};
    },
    selectedProvider: function selectedProvider() {
      return this.shipmentOptions[this.shipment.package_type] || null;
    },
    solProductsOrdered: function solProductsOrdered() {
      var solProductsOrdered = true;
      this.order.lines.forEach(function (element) {
        if (!element.dropshipment_completed_at) {
          solProductsOrdered = false;
        }
      });
      return solProductsOrdered;
    }
  },
  methods: {
    loadOrder: function loadOrder() {
      var _this = this;

      var params = {
        include: 'lines,lines.product,shipment,returnShipment'
      };
      this.$api.getOrder(this.orderId, params).then(function (result) {
        _this.order = result.data.data;
        _this.orderNotifications = result.data.notifications;
      }).catch(function () {
        _this.$swal('Ehmm...', 'Deze bestelling konden we niet vinden. Probeer het opnieuw.', 'warning');
        _this.$refs.modal.hide();
      });
    },
    selectPackageType: function selectPackageType(type) {
      this.shipment.package_type = type;
      this.shipment.insurance = false;
      this.shipment.large_format = false;
    },
    createShipment: function createShipment() {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.shipment, {
        order_number: this.order.number
      });

      this.creatingShipment = true;
      this.$api.createShipment(data).then(function (result) {
        return _this2.$api.printLabel(result.data.data.id);
      }).then(function () {
        _this2.creatingShipment = false;
        _this2.loadOrder();
      }).catch(function (error) {
        _this2.creatingShipment = false;

        if (error.response && error.response.data && error.response.data.message) {
          _this2.$swal('Oeps! 😳', 'Het verzend adres bevat geen huisnummer.', 'error');
        } else {
          _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het printen van het verzendetiket. Probeer het opnieuw.', 'error');
        }
      });
    },
    completeOrder: function completeOrder() {
      this.$refs.orderStatus.updateStatus('completed');
    },
    orderSolProducts: function orderSolProducts() {
      var _this3 = this;

      if (this.order.contains_sol_product && !this.order.shipping_phone) {
        this.$swal('Oeps! 😳', 'De producten van sol kunnen niet bestelt worden totdat de bestelling een telefoonnummer heeft. Probeer het opnieuw wanneer een telefoonnummer is ingevoerd.', 'error');
        return;
      }

      this.$http.get('/orders/solProduct/' + this.order.id).then(function (response) {
        _this3.$swal('Hoera 😊', 'Sol product is succesvol besteld.', 'success');
      }).catch(function () {
        _this3.$swal('Er is iets fout gegaan bij het bestellen de sol producten. Probeer het opnieuw.', 'error');
      });
    },
    printLabel: function printLabel() {
      this.$api.printLabel(this.order.shipment.id);
    },
    setPhonenumber: function setPhonenumber() {
      this.customerPhonenumber = '0857920170';
    },
    updatePhonenumber: function updatePhonenumber() {
      var _this4 = this;

      if (!this.customerPhonenumber) {
        this.$swal('Oeps! 😳', 'Je moet \xF3f het telefoonnummer van de klant opgeven \xF3f het standaard telefoonnummer van Villa Madelief aanvinken.', 'error');
        return;
      }

      var data = {
        shipping_phone: this.customerPhonenumber
      };

      this.$http.patch('/orders/' + this.order.id, data).then(function (response) {
        _this4.$swal('Hoera 😊', 'Telefoonnummer succesvol geupdate.', 'success');
      }).catch(function () {
        _this4.$swal('Er is iets fout gegaan bij het opslaan van de telefoonnummer. Probeer het opnieuw.', 'error');
      });
    },
    openPostageStampDetailModal: function openPostageStampDetailModal() {
      this.showPostageStampModal = true;
    }
  },
  created: function created() {
    this.loadOrder();
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    order: Object
  },
  data: function data() {
    return {
      saving: false,
      alert: false
    };
  },

  computed: {
    status: function status() {
      return this.order.status;
    },
    statuses: function statuses() {
      return [{ id: 'processing', label: 'Klaar om te picken', color: 'danger' }, { id: 'picked', label: 'Gepickt', color: 'info' }, { id: 'completed', label: 'Voltooid', color: 'success' }, { id: 'on-hold', label: 'On hold', color: 'warning' }, { id: 'cancelled', label: 'Geannuleerd', color: 'secondary' }, { id: 'pending-payment', label: 'Wachten op betaling', color: 'secondary', selectable: false }, { id: 'refunded', label: 'Geretourneerd', color: 'secondary', selectable: false }, { id: 'failed', label: 'Mislukt', color: 'secondary', selectable: false }];
    },
    currentStatus: function currentStatus() {
      var _this = this;

      return this.statuses.find(function (s) {
        return s.id === _this.status;
      });
    },
    selectableStatuses: function selectableStatuses() {
      return this.statuses.filter(function (s) {
        return s.selectable !== false;
      });
    }
  },
  methods: {
    updateStatus: function updateStatus(newStatus) {
      var _this2 = this;

      var oldStatus = this.order.status;
      this.order.status = newStatus;

      var data = {
        status: newStatus
      };

      this.saving = true;
      this.$http.patch('/orders/' + this.order.id, data).then(function (response) {
        _this2.saving = false;
        _this2.alert = { variant: 'success', message: 'Opgeslagen' };
      }).catch(function () {
        _this2.saving = false;
        _this2.order.status = oldStatus;
        _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het opslaan van de status. Probeer het opnieuw.', 'error');
      });
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    order: Object
  },
  data: function data() {
    return {
      solTrackAndTraceUrl: null,
      loading: false
    };
  },

  computed: {
    pickedAt: function pickedAt() {
      if (this.order.status === 'picked') {
        return this.order.updated_at;
      }

      if (this.order.status === 'completed') {
        return this.completedAt;
      }

      return null;
    },
    completedAt: function completedAt() {
      if (this.order.status === 'completed') {
        return this.order.shipment ? this.order.shipment.created_at : this.order.updated_at;
      }

      return null;
    }
  },
  methods: {
    getSolTrackAndTraceUrl: function getSolTrackAndTraceUrl() {
      var _this = this;

      this.loading = true;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/sol-order/' + this.order.id).then(function (result) {
        _this.solTrackAndTraceUrl = result.data.data;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
        _this.$swal('Ehmm...', 'Er is iets misgegaan met het ophalen van de track en trace url voor deze bestelling. Probeer het opnieuw.', 'warning');
      });
    },
    printLabel: function printLabel() {
      this.$emit('print:label');
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ApiTableBlock__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ApiTableBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_ApiTableBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderDetailModal__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderDetailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OrderDetailModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrderStatusBadge__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrderStatusBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__OrderStatusBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BarcodeScanner__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BarcodeScanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_BarcodeScanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__refunds_RefundDetailModal_vue__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__refunds_RefundDetailModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__refunds_RefundDetailModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__barcode_scanner_SelectBarcodeScannerWidget_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__barcode_scanner_SelectBarcodeScannerWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__barcode_scanner_SelectBarcodeScannerWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__barcode_scanner_socket__ = __webpack_require__(21);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ApiTableBlock: __WEBPACK_IMPORTED_MODULE_3__common_ApiTableBlock___default.a,
    OrderDetailModal: __WEBPACK_IMPORTED_MODULE_4__OrderDetailModal___default.a,
    OrderStatusBadge: __WEBPACK_IMPORTED_MODULE_5__OrderStatusBadge___default.a,
    BarcodeScanner: __WEBPACK_IMPORTED_MODULE_6__common_BarcodeScanner___default.a,
    RefundDetailModal: __WEBPACK_IMPORTED_MODULE_7__refunds_RefundDetailModal_vue___default.a,
    SelectBarcodeScannerWidget: __WEBPACK_IMPORTED_MODULE_8__barcode_scanner_SelectBarcodeScannerWidget_vue___default.a
  },
  data: function data() {
    return {
      fields: {
        check: {
          label: '',
          class: 'text-center',
          thStyle: 'width: 70px;'
        },
        number: {
          label: 'Bestelling',
          sortable: true,
          thStyle: 'width: 140px;'
        },
        billing_person: {
          label: 'Klant',
          sortable: true,
          thStyle: 'width: 30%;'
        },
        placed_at: {
          label: 'Datum',
          sortable: true
        },
        status: {
          label: 'Status',
          sortable: true
        },
        actions: {
          label: 'Acties',
          thStyle: 'width: 150px;'
        }
      },
      selectedOrders: [],
      refundDetailModalShow: false,
      detailModalOrderId: null,
      refundDetailModalOrderId: null,
      refund: null,
      showOnlyProcessing: true,
      showOnlyDropship: false,
      showOnlyBolOrders: false,
      showOnlyNLOrders: false
    };
  },

  computed: {
    ordersTable: function ordersTable() {
      return this.$refs.ordersTable;
    }
  },
  methods: {
    findAllOrders: function findAllOrders(params) {
      params['include'] = 'refund';

      if (this.showOnlyProcessing) {
        params['filter[status]'] = 'processing,picked';
      }

      if (this.showOnlyDropship) {
        params['filter[lines.product.dropship]'] = 'society_of_lifestyle,present_time,de_eekhoorn';
      }

      if (this.showOnlyBolOrders) {
        params['filter[specific_orders]'] = 'BOL-';
      }

      if (this.showOnlyNLOrders) {
        params['filter[specific_orders]'] = 'NL-';
      }

      return this.$api.getOrders(params);
    },
    refresh: function refresh() {
      this.ordersTable.refresh();
    },
    selectOrder: function selectOrder(number, e) {
      if (e.target.checked) {
        this.selectedOrders.push(number);
      } else {
        var index = this.selectedOrders.indexOf(number);
        if (index > -1) {
          this.selectedOrders.splice(index, 1);
        }
      }
    },
    pickSelected: function pickSelected() {
      if (this.selectedOrders.length === 0) {
        this.$swal('Niks geselecteerd 🙄', 'Selecteer welke bestellingen je wilt picken.', 'warning');
        return;
      } else if (this.selectedOrders.length > 10) {
        this.$swal('Te veel geselecteerd 🤔', 'Je kunt maximaal 10 bestellingen per keer picken.', 'warning');
        return;
      }

      this.$router.push({ name: 'pick-orders', query: { orders: this.selectedOrders, singleBin: false } });
    },
    pick: function pick(pickType) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, singleBin, orderNumbers;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  'filter[status]': 'processing',
                  'per_page': 10,
                  'sort': 'placed_at'
                };
                singleBin = false;


                if (pickType === 'single') {
                  params['filter[linesCount]'] = pickType;
                  params['per_page'] = 20;
                  singleBin = true;
                }

                if (pickType === 'multi') {
                  params['filter[linesCount]'] = pickType;
                }

                _context.next = 6;
                return _this.$api.getOrderNumbers(params);

              case 6:
                orderNumbers = _context.sent;

                if (!(orderNumbers.length === 0)) {
                  _context.next = 10;
                  break;
                }

                _this.$swal('Geen openstaande bestellingen 😎', 'Dat scheelt weer.', 'warning');
                return _context.abrupt('return');

              case 10:

                _this.$router.push({ name: 'pick-orders', query: { orders: orderNumbers, singleBin: singleBin } });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createRefund: function createRefund(orderId) {
      var _this2 = this;

      var data = {
        order_number: orderId
      };

      this.$http.post('/refunds', data).then(function (response) {
        _this2.saving = false;
        _this2.alert = { variant: 'success', message: 'Opgeslagen' };
        _this2.refund = response.data.data;
      }).catch(function () {
        _this2.saving = false;
        _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het aanmaken van de retour. Probeer het opnieuw.', 'error');
      });
    },
    openDetailModal: function openDetailModal(orderId) {
      this.detailModalOrderId = orderId;
    },
    openManualRefundModal: function openManualRefundModal(order) {
      this.createRefund(order.number);

      this.refundDetailModalShow = true;
      this.refundDetailModalOrderId = order.id;
    },
    handleMessage: function handleMessage(event) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_http__["a" /* default */].get('/order-barcode-scanned/' + event).then(function (result) {
        _this3.detailModalOrderId = result.data.data.id;
      }).catch(function () {
        _this3.$swal('Ehmm...', 'Deze product konden we niet vinden in één van de gepickte bestellingen. Controleer de bestellingen goed.', 'warning');
      });
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_9__barcode_scanner_socket__["a" /* default */].$on('message', this.handleMessage);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_9__barcode_scanner_socket__["a" /* default */].$off('message', this.handleMessage);
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    icon: String,
    selected: Boolean,
    provider: String
  },
  methods: {
    onClick: function onClick(e) {
      if (!this.provider) {
        this.$swal('', 'Dit pakkettype is niet beschikbaar voor deze bestelling.', 'warning');
        return;
      }

      this.$emit('click', e);
    }
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__products_ProductDetailModal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__products_ProductDetailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__products_ProductDetailModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderDetailModal__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderDetailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__OrderDetailModal__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"],
    ProductDetailModal: __WEBPACK_IMPORTED_MODULE_5__products_ProductDetailModal___default.a,
    OrderDetailModal: __WEBPACK_IMPORTED_MODULE_6__OrderDetailModal___default.a
  },
  data: function data() {
    return {
      orders: [],
      products: [],
      currentProductIndex: 0,
      showModal: false,
      loading: false,
      printing: false,
      detailModalOrderId: null,
      detailModalProductId: null
    };
  },

  computed: {
    currentProduct: function currentProduct() {
      return this.products[this.currentProductIndex] || {};
    },
    isFirstProduct: function isFirstProduct() {
      return this.currentProductIndex === 0;
    },
    isLastProduct: function isLastProduct() {
      return this.currentProductIndex + 1 === this.products.length;
    },
    swiper: function swiper() {
      return this.$refs.imageSwiper.swiper;
    },
    totalQuantity: function totalQuantity() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["sum"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["values"])(this.currentProduct.quantities));
    },
    orderNumbers: function orderNumbers() {
      return this.$route.query.orders;
    },
    singleBin: function singleBin() {
      return this.$route.query.singleBin;
    },
    invoicesPdfUrl: function invoicesPdfUrl() {
      return this.$http.getUri({
        url: "https://api.control.villamadelief.nl" + '/invoices/pdf',
        params: {
          orders: this.orderNumbers,
          access_token: this.$auth.getAccessToken()
        }
      });
    },
    lastPickForProduct: function lastPickForProduct() {
      return this.currentProduct.unpicked_quantity === this.totalQuantity;
    }
  },
  methods: {
    next: function next() {
      var i = this.currentProductIndex + 1;
      if (i < this.products.length) {
        this.currentProductIndex = i;
        this.swiper.slideTo(0);
      }
    },
    previous: function previous() {
      var i = this.currentProductIndex - 1;
      if (i >= 0) {
        this.currentProductIndex = i;
        this.swiper.slideTo(0);
      }
    },
    finish: function finish() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var yes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.$swal({
                  title: 'Afronden',
                  text: 'Heb je alle producten gepickt?',
                  icon: 'info',
                  buttons: {
                    cancel: {
                      text: 'Nee, terug',
                      visible: true
                    },
                    confirm: {
                      text: 'Ja, afronden',
                      className: 'swal-button--success'
                    }
                  }
                });

              case 2:
                yes = _context2.sent;


                if (yes) {
                  _this.$api.changeOrderStatus(_this.orderNumbers, 'picked').then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this.$swal('Afgerond 😀', 'Succes met inpakken!', 'success');

                          case 2:
                            _this.$router.push({ name: 'orders' });

                          case 3:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }))).catch(function () {
                    _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het afronden. Probeer het opnieuw.', 'error');
                  });
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    findOrderByNumber: function findOrderByNumber(orderNumber) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(this.orders, function (o) {
        return o.number === orderNumber;
      });
    },
    printInvoices: function printInvoices() {
      var _this2 = this;

      this.printing = true;

      this.$api.printInvoices(this.orderNumbers).then(function () {
        _this2.printing = false;
      }).catch(function () {
        _this2.printing = false;
        _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het printen van de pakbonnen. Probeer het opnieuw.', 'error');
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.loading = true;

    var params = {
      numbers: this.orderNumbers,
      single_bin: this.singleBin
    };

    __WEBPACK_IMPORTED_MODULE_2__utils_http__["a" /* default */].get('/orders/pick', { params: params }).then(function (response) {
      _this3.orders = response.data.data.orders;
      _this3.products = response.data.data.products;
      _this3.loading = false;
    }).catch(function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(error.response && error.response.data && error.response.data.message)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return _this3.$swal('Oeps! 😳', error.response.data.message, 'error');

              case 3:
                _context3.next = 7;
                break;

              case 5:
                _context3.next = 7;
                return _this3.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het ophalen van de bestellingen. Probeer het opnieuw.', 'error');

              case 7:

                _this3.$router.push({ name: 'orders' });

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PostageStampType__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PostageStampType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PostageStampType__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PostageStampType: __WEBPACK_IMPORTED_MODULE_1__PostageStampType___default.a
  },
  props: {
    order: Object,
    shipment: Object
  },
  data: function data() {
    return {
      postageStampType: null
    };
  },

  methods: {
    createShipment: function createShipment(weight) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.shipment, {
        order_number: this.order.number,
        weight: weight
      });

      this.$api.createShipment(data).then(function (result) {
        return _this.$api.printLabel(result.data.data.id);
      }).then(function () {
        _this.$refs.modal.hide();
      }).catch(function () {
        _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het printen van het verzendeticket. Probeer het opnieuw.', 'error');
      });
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    icon: String
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('click', e);
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      brands: [],

      product: {
        gtin: null,
        name: null,
        brand: null,
        location: null,
        stock_quantity: 0,
        price: 0
      }
    };
  },

  methods: {
    loadBrands: function loadBrands() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('brands').then(function (result) {
        _this.brands = result.data.data;
      });
    },
    createProduct: function createProduct() {
      var _this2 = this;

      this.$http.post('/product', this.product).then(function (response) {
        var product = response.data.data;
        _this2.$swal('Hoera 😊', 'Het product is succesvol aangemaakt.', 'success');
        _this2.$emit('created', { product: product });
        _this2.$refs.modal.hide();
      }).catch(function () {
        _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het aanmaken van het product. Probeer het opnieuw.', 'error');
      });
    }
  },
  created: function created() {
    this.loadBrands();
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    externallyAvailable: Boolean,
    productId: Number
  },
  data: function data() {
    return {
      currentValue: this.externallyAvailable,
      alert: false
    };
  },
  created: function created() {
    this.$root.$on('product-externally-available-updated', this.onUpdate);
  },
  destroy: function destroy() {
    this.$root.$off('product-externally-available-updated', this.onUpdate);
  },

  methods: {
    save: function save(e) {
      var _this = this;

      this.currentValue = e.target.checked;
      var data = {
        externally_available: this.currentValue
      };

      this.$root.$emit('product-externally-available-updated', {
        product_id: this.productId,
        value: this.currentValue
      });

      return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].patch('/products/' + this.productId, data).then(function () {
        _this.alert = { variant: 'success', message: 'Opgeslagen' };
      }).catch(function () {
        _this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' };
      });
    },
    onUpdate: function onUpdate(e) {
      if (this.productId === e.product_id) {
        this.currentValue = e.value;
      }
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__["mixin"]],
  props: ['field', 'value', 'productId'],
  data: function data() {
    return {
      isEdditing: false,
      currentValue: this.value,
      newValue: this.value,
      loading: false,
      alert: false
    };
  },
  created: function created() {
    this.$root.$on('product-' + this.field + '-updated', this.onUpdate);
  },
  destroy: function destroy() {
    this.$root.$off('product-' + this.field + '-updated', this.onUpdate);
  },

  methods: {
    edit: function edit() {
      var _this = this;

      this.newValue = this.currentValue;

      this.isEdditing = true;
      this.alert = false;

      this.$nextTick(function () {
        var el = _this.$refs.input;
        el.focus();
      });
    },
    cancel: function cancel() {
      this.isEdditing = false;
      this.alert = false;
    },
    save: function save() {
      var _this2 = this;

      this.loading = true;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.field, this.newValue);

      return __WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */].patch('/products/' + this.productId, data).then(function () {
        _this2.currentValue = _this2.newValue;

        _this2.isEdditing = false;
        _this2.loading = false;
        _this2.alert = { variant: 'success', message: 'Opgeslagen' };

        _this2.$root.$emit('product-' + _this2.field + '-updated', {
          product_id: _this2.productId,
          value: _this2.newValue
        });
      }).catch(function () {
        _this2.loading = false;
        _this2.alert = { variant: 'danger', message: 'Er is iets fout gegaan' };
      });
    },
    onUpdate: function onUpdate(e) {
      if (this.productId === e.product_id) {
        this.currentValue = e.value;
        this.newValue = e.value;
      }
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    inStore: Boolean,
    productId: Number
  },
  data: function data() {
    return {
      currentValue: this.inStore,
      alert: false
    };
  },
  created: function created() {
    this.$root.$on('product-in-store-updated', this.onUpdate);
  },
  destroy: function destroy() {
    this.$root.$off('product-in-store-updated', this.onUpdate);
  },

  methods: {
    save: function save(e) {
      var _this = this;

      this.currentValue = e.target.checked;
      var data = {
        in_store: this.currentValue
      };

      this.$root.$emit('product-in-store-updated', {
        product_id: this.productId,
        value: this.currentValue
      });

      return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].patch('/products/' + this.productId, data).then(function () {
        _this.alert = { variant: 'success', message: 'Opgeslagen' };
      }).catch(function () {
        _this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' };
      });
    },
    onUpdate: function onUpdate(e) {
      if (this.productId === e.product_id) {
        this.currentValue = e.value;
      }
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_masked_input__ = __webpack_require__(768);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__["mixin"]],
  components: {
    MaskedInput: __WEBPACK_IMPORTED_MODULE_3_vue_masked_input__["a" /* default */]
  },
  props: ['field', 'value', 'productId'],
  data: function data() {
    return {
      isEdditing: false,
      location: this.value,
      inputLocation: '',
      loading: false,
      alert: false
    };
  },
  created: function created() {
    this.$root.$on('product-location-updated', this.onUpdate);
  },
  destroy: function destroy() {
    this.$root.$off('product-location-updated', this.onUpdate);
  },

  methods: {
    edit: function edit() {
      var _this = this;

      if (this.location) {
        this.inputLocation = this.location;
      } else {
        var lastLocation = localStorage.getItem('last_assigned_location');
        if (lastLocation) {
          this.inputLocation = lastLocation.slice(0, -2);
        }
      }

      this.alert = false;
      this.isEdditing = true;

      var cursorPosition = this.inputLocation.length;
      this.$nextTick(function () {
        var el = _this.$refs.locationInput.$el;
        el.focus();
        el.setSelectionRange(cursorPosition, cursorPosition);
      });
    },
    cancel: function cancel() {
      this.isEdditing = false;
      this.alert = false;
      this.inputLocation = '';
    },
    save: function save() {
      var _this2 = this;

      var value = void 0;
      if (this.inputLocation === '') {
        value = null;
      } else if (this.inputLocation.endsWith('.__')) {
        value = this.inputLocation.slice(0, -3); // remove '.__'
      } else {
        value = this.inputLocation;
      }

      this.loading = true;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.field, value);

      return __WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */].patch('/products/' + this.productId, data).then(function (response) {
        _this2.location = value;
        _this2.inputLocation = '';
        _this2.isEdditing = false;
        _this2.loading = false;

        _this2.alert = { variant: 'success', message: 'Opgeslagen' };

        _this2.$root.$emit('product-location-updated', {
          product_id: _this2.productId,
          location: value
        });

        if (_this2.location !== null) {
          localStorage.setItem('last_assigned_location', _this2.location);
        }
      }).catch(function (error) {
        _this2.loading = false;
        if (error.response.data.code === 'location_occupied') {
          _this2.alert = { variant: 'danger', message: 'Deze locatie is al bezet' };
        } else {
          _this2.alert = { variant: 'danger', message: 'Er is iets fout gegaan' };
        }
      });
    },
    onUpdate: function onUpdate(e) {
      if (this.productId === e.product_id) {
        this.location = e.location;
        this.inputLocation = e.location;
      }
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductDetailModal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductDetailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductDetailModal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ProductDetailModal: __WEBPACK_IMPORTED_MODULE_0__ProductDetailModal___default.a
  },
  props: {
    products: Array
  },
  data: function data() {
    return {
      detailModalProductId: null
    };
  },

  methods: {
    select: function select(product) {
      this.$emit('select', product);
      this.$refs.modal.hide();
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    totalStickersToBePrinted: function totalStickersToBePrinted() {
      return (this.racksTill - this.racksFrom + 1) * (this.planksTill - this.planksFrom + 1) * (this.locationsTill - this.locationsFrom + 1);
    }
  },
  data: function data() {
    return {
      letter: null,
      rowNumber: null,
      racksFrom: null,
      racksTill: null,
      planksFrom: null,
      planksTill: null,
      locationsFrom: null,
      locationsTill: null
    };
  },

  methods: {
    generateLocationStickerPdf: function generateLocationStickerPdf() {
      var _this = this;

      var data = {
        letter: this.letter,
        rowNumber: this.rowNumber,
        racksFrom: this.racksFrom,
        racksTill: this.racksTill,
        planksFrom: this.planksFrom,
        planksTill: this.planksTill,
        locationsFrom: this.locationsFrom,
        locationsTill: this.locationsTill
      };
      this.$http.post('/encode-location-data', data).then(function (response) {
        window.open("https://api.control.villamadelief.nl" + '/location-stickers/' + response.data.data);
        _this.$refs.modal.hide();
      }).catch(function () {
        _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het aanmaken van de PDF. Probeer het opnieuw.', 'error');
      });
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  props: ['price', 'productId'],
  data: function data() {
    return {
      currentPrice: this.price,
      newPrice: this.price,
      isEdditing: false,
      isLoading: false,
      alert: false
    };
  },
  created: function created() {
    this.$root.$on('product-price-updated', this.onUpdate);
  },
  destroy: function destroy() {
    this.$root.$off('product-price-updated', this.onUpdate);
  },

  methods: {
    edit: function edit() {
      this.isEdditing = true;
      this.newPrice = this.currentPrice;
    },
    cancel: function cancel() {
      this.isEdditing = false;
    },
    save: function save() {
      var _this = this;

      this.isLoading = true;

      var data = {
        price: this.newPrice
      };

      return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].patch('/products/' + this.productId, data).then(function (response) {
        _this.currentPrice = _this.newPrice;
        _this.isEdditing = false;
        _this.isLoading = false;

        _this.alert = { variant: 'success', message: 'Opgeslagen' };

        _this.$root.$emit('product-price-updated', {
          product_id: _this.productId,
          price: _this.newPrice
        });
      }).catch(function () {
        _this.isLoading = false;
        _this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' };
      });
    },
    onUpdate: function onUpdate(e) {
      if (this.productId === e.product_id) {
        this.currentPrice = e.price;
        this.newPrice = e.price;
      }
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StockEditable__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StockEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StockEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationEditable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LocationEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FieldEditable__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FieldEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FieldEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InStoreEditable__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InStoreEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InStoreEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SalePriceEditable_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SalePriceEditable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SalePriceEditable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PriceEditable_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PriceEditable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__PriceEditable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchasePriceEditable__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchasePriceEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__PurchasePriceEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExternallyAvailableEditable__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExternallyAvailableEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ExternallyAvailableEditable__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { StockEditable: __WEBPACK_IMPORTED_MODULE_2__StockEditable___default.a, LocationEditable: __WEBPACK_IMPORTED_MODULE_3__LocationEditable___default.a, FieldEditable: __WEBPACK_IMPORTED_MODULE_4__FieldEditable___default.a, InStoreEditable: __WEBPACK_IMPORTED_MODULE_5__InStoreEditable___default.a, SalePriceEditable: __WEBPACK_IMPORTED_MODULE_6__SalePriceEditable_vue___default.a, PriceEditable: __WEBPACK_IMPORTED_MODULE_7__PriceEditable_vue___default.a, ExternallyAvailableEditable: __WEBPACK_IMPORTED_MODULE_9__ExternallyAvailableEditable___default.a, PurchasePriceEditable: __WEBPACK_IMPORTED_MODULE_8__PurchasePriceEditable___default.a },
  props: {
    productId: Number
  },
  data: function data() {
    return {
      product: null
    };
  },

  methods: {
    loadProduct: function loadProduct() {
      var _this = this;

      var params = {
        include: 'stockMutations'
      };
      this.$api.getProduct(this.productId, params).then(function (result) {
        _this.product = result.data.data;
      }).catch(function () {
        _this.$swal('Ehmm...', 'Dit product konden we niet vinden. Probeer het opnieuw.', 'warning');
        _this.$refs.modal.hide();
      });
    },
    removeProduct: function removeProduct() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var yes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$swal({
                  title: 'Verwijderen?',
                  text: 'Weet je zeker dat je dit product wilt verwijderen?',
                  icon: 'error',
                  buttons: {
                    cancel: {
                      text: 'Nee, terug',
                      visible: true
                    },
                    confirm: {
                      text: 'Ja, verwijderen',
                      className: 'swal-button--danger'
                    }
                  }
                });

              case 2:
                yes = _context.sent;


                if (yes) {
                  _this2.$api.removeProduct(_this2.productId).then(function (result) {
                    _this2.$swal('Verwijderd', 'Het product is succesvol verwijderd uit VM Control.', 'success');
                    _this2.$emit('remove', _this2.productId);
                    _this2.$refs.modal.hide();
                  }).catch(function () {
                    _this2.$swal('Ehmm...', 'Er is iets fout gegaan. Probeer het opnieuw.', 'warning');
                  });
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    show: function show() {
      this.$refs.modal.show();
    }
  },
  filters: {
    origin: function origin(key) {
      var origins = {
        manual: 'Handmatig',
        order_placed: 'Bestelling geplaatst',
        order_canceled: 'Bestelling geannuleerd',
        society_of_lifestyle: 'Society of Lifestyle',
        present_time: 'Present Time',
        product_import: 'Productimport'
      };

      return origins[key] || 'Onbekend';
    }
  },
  created: function created() {
    this.loadProduct();
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationEditable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LocationEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldEditable__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FieldEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StockEditable__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StockEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StockEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InStoreEditable__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InStoreEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InStoreEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PriceEditable_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PriceEditable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PriceEditable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SalePriceEditable_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SalePriceEditable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SalePriceEditable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ApiTableBlock__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ApiTableBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_ApiTableBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProductDetailModal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProductDetailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ProductDetailModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__barcode_scanner_SelectBarcodeScannerWidget_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__barcode_scanner_SelectBarcodeScannerWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__barcode_scanner_SelectBarcodeScannerWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__barcode_scanner_socket__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UnkownProductModal_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UnkownProductModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__UnkownProductModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LocationStickerGenerator_vue__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LocationStickerGenerator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__LocationStickerGenerator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UpdateLocationModal_vue__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UpdateLocationModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__UpdateLocationModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LocationScannedModal__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LocationScannedModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__LocationScannedModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CreateProductModal__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CreateProductModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__CreateProductModal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LocationEditable: __WEBPACK_IMPORTED_MODULE_1__LocationEditable___default.a,
    FieldEditable: __WEBPACK_IMPORTED_MODULE_2__FieldEditable___default.a,
    StockEditable: __WEBPACK_IMPORTED_MODULE_3__StockEditable___default.a,
    InStoreEditable: __WEBPACK_IMPORTED_MODULE_4__InStoreEditable___default.a,
    ApiTableBlock: __WEBPACK_IMPORTED_MODULE_7__common_ApiTableBlock___default.a,
    ProductDetailModal: __WEBPACK_IMPORTED_MODULE_8__ProductDetailModal___default.a,
    PriceEditable: __WEBPACK_IMPORTED_MODULE_5__PriceEditable_vue___default.a,
    SalePriceEditable: __WEBPACK_IMPORTED_MODULE_6__SalePriceEditable_vue___default.a,
    SelectBarcodeScannerWidget: __WEBPACK_IMPORTED_MODULE_9__barcode_scanner_SelectBarcodeScannerWidget_vue___default.a,
    UnkownProductModal: __WEBPACK_IMPORTED_MODULE_11__UnkownProductModal_vue___default.a,
    LocationStickerGenerator: __WEBPACK_IMPORTED_MODULE_12__LocationStickerGenerator_vue___default.a,
    UpdateLocationModal: __WEBPACK_IMPORTED_MODULE_13__UpdateLocationModal_vue___default.a,
    LocationScannedModal: __WEBPACK_IMPORTED_MODULE_14__LocationScannedModal___default.a,
    CreateProductModal: __WEBPACK_IMPORTED_MODULE_15__CreateProductModal___default.a
  },
  data: function data() {
    return {
      fields: {
        image: {
          label: '',
          class: 'text-center',
          thStyle: 'width: 8%;'
        },
        name: {
          label: 'Product',
          thStyle: 'width: 40%;',
          sortable: true
        },
        price: {
          label: 'Prijs',
          thStyle: 'width: 12%;',
          sortable: true
        },
        location: {
          label: 'Locaties',
          thStyle: 'width: 20%;',
          sortable: true
        },
        in_store: {
          label: 'In winkel',
          thStyle: 'width: 10%;',
          sortable: true
        },
        stock_quantity: {
          label: 'Voorraad',
          thStyle: 'width: 10%;',
          sortable: true
        }
      },
      detailModalProductId: null,
      unkownProductScanned: null,
      scannedBarcode: null,
      showStickerGeneratorModal: null,
      scannedLocation: null,
      productsOnScannedLocation: null,
      locationScanned: null,
      showCreateProductModal: false
    };
  },

  methods: {
    findAllProducts: function findAllProducts(params) {
      return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/products', { params: params });
    },
    details: function details(product) {
      this.detailModalProductId = product.id;
    },
    refresh: function refresh() {
      this.$refs.productsTable.refresh();
    },
    handleMessage: function handleMessage(event) {
      var _this = this;

      var endpoint = event.includes('.') ? 'location-scanned' : 'product-scanned';

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/' + endpoint + '/' + event).then(function (result) {
        if (result.data.data === 'unknown_product') {
          _this.unkownProductScanned = true;
          _this.scannedBarcode = event;

          return;
        } else if (result.data.data === 'unknown_location' && _this.detailModalProductId) {
          _this.scannedLocation = event;
          _this.locationScanned = true;

          return;
        } else if (endpoint === 'location-scanned') {
          if (result.data.data.length === 1) {
            _this.detailModalProductId = result.data.data[0].id;

            return;
          }

          _this.productsOnScannedLocation = result.data.data;
          return;
        }
        _this.detailModalProductId = result.data.data.id;
      }).catch(function () {
        _this.$swal('Ehmm...', 'Deze product konden we niet vinden. Probeer het opnieuw.', 'warning');
      });
    },
    handleUnkownProductCreated: function handleUnkownProductCreated(event) {
      this.detailModalProductId = event.product.id;
    },
    showStickerGenerator: function showStickerGenerator() {
      this.showStickerGeneratorModal = true;
    },
    openCreateProductModal: function openCreateProductModal() {
      this.showCreateProductModal = true;
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_10__barcode_scanner_socket__["a" /* default */].$on('message', this.handleMessage);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_10__barcode_scanner_socket__["a" /* default */].$off('message', this.handleMessage);
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  props: ['purchasePrice', 'productId'],
  data: function data() {
    return {
      currentPurchasePrice: this.purchasePrice,
      newPurchasePrice: this.purchasePrice,
      isEdditing: false,
      isLoading: false,
      alert: false
    };
  },
  created: function created() {
    this.$root.$on('product-purchase-price-updated', this.onUpdate);
  },
  destroy: function destroy() {
    this.$root.$off('product-purchase-price-updated', this.onUpdate);
  },

  methods: {
    edit: function edit() {
      this.isEdditing = true;
      this.newPurchasePrice = this.currentPurchasePrice;
    },
    cancel: function cancel() {
      this.isEdditing = false;
    },
    save: function save() {
      var _this = this;

      this.isLoading = true;

      var data = {
        purchase_price: this.newPurchasePrice
      };

      return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].patch('/products/' + this.productId, data).then(function (response) {
        _this.currentPurchasePrice = _this.newPurchasePrice;
        _this.isEdditing = false;
        _this.isLoading = false;

        _this.alert = { variant: 'success', message: 'Opgeslagen' };

        _this.$root.$emit('product-price-updated', {
          product_id: _this.productId,
          purchasePrice: _this.newPurchasePrice
        });
      }).catch(function () {
        _this.isLoading = false;
        _this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' };
      });
    },
    onUpdate: function onUpdate(e) {
      if (this.productId === e.product_id) {
        this.currentPurchasePrice = e.price;
        this.newPurchasePrice = e.price;
      }
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  props: ['price', 'sale_price', 'productId'],
  data: function data() {
    return {
      productPrice: this.price,
      newSalePrice: this.sale_price,
      salePrice: this.sale_price,
      isEdditing: false,
      isLoading: false,
      alert: false
    };
  },
  created: function created() {
    this.$root.$on('product-price-updated', this.onUpdate);
  },
  destroy: function destroy() {
    this.$root.$off('product-price-updated', this.onUpdate);
  },

  methods: {
    edit: function edit() {
      this.isEdditing = true;
      this.newSalePrice = this.salePrice;
    },
    cancel: function cancel() {
      this.isEdditing = false;
    },
    save: function save() {
      var _this = this;

      this.isLoading = true;

      if (parseInt(this.newSalePrice) === 0 || !this.newSalePrice) {
        this.newSalePrice = null;
      }

      var data = {
        sale_price: this.newSalePrice
      };

      return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].patch('/products/' + this.productId, data).then(function (response) {
        _this.salePrice = _this.newSalePrice;
        _this.isEdditing = false;
        _this.isLoading = false;

        _this.alert = { variant: 'success', message: 'Opgeslagen' };

        _this.$root.$emit('product-sale_price-updated', {
          product_id: _this.productId,
          sale_price: _this.newSalePrice
        });
      }).catch(function () {
        _this.isLoading = false;
        _this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' };
      });
    },
    onUpdate: function onUpdate(e) {
      if (this.productId === e.product_id) {
        this.salePrice = e.quantity;
        this.newSalePrice = e.quantity;
      }
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  props: ['quantity', 'productId'],
  data: function data() {
    return {
      currentQuantity: this.quantity,
      newQuantity: this.quantity,
      isEdditing: false,
      isLoading: false,
      alert: false
    };
  },
  created: function created() {
    this.$root.$on('product-stock-updated', this.onUpdate);
  },
  destroy: function destroy() {
    this.$root.$off('product-stock-updated', this.onUpdate);
  },

  methods: {
    edit: function edit() {
      this.isEdditing = true;
      this.newQuantity = this.currentQuantity;
    },
    cancel: function cancel() {
      this.isEdditing = false;
    },
    save: function save() {
      var _this = this;

      this.isLoading = true;

      var data = {
        stock_quantity: this.newQuantity
      };

      return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].patch('/products/' + this.productId, data).then(function (response) {
        _this.currentQuantity = _this.newQuantity;
        _this.isEdditing = false;
        _this.isLoading = false;

        _this.alert = { variant: 'success', message: 'Opgeslagen' };

        _this.$root.$emit('product-stock-updated', {
          product_id: _this.productId,
          quantity: _this.newQuantity
        });
      }).catch(function () {
        _this.isLoading = false;
        _this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' };
      });
    },
    onUpdate: function onUpdate(e) {
      if (this.productId === e.product_id) {
        this.currentQuantity = e.quantity;
        this.newQuantity = e.quantity;
      }
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationEditable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LocationEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldEditable__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FieldEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StockEditable__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StockEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StockEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InStoreEditable__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InStoreEditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InStoreEditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_ApiTableBlock__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_ApiTableBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_ApiTableBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductDetailModal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductDetailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ProductDetailModal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LocationEditable: __WEBPACK_IMPORTED_MODULE_1__LocationEditable___default.a,
    FieldEditable: __WEBPACK_IMPORTED_MODULE_2__FieldEditable___default.a,
    StockEditable: __WEBPACK_IMPORTED_MODULE_3__StockEditable___default.a,
    InStoreEditable: __WEBPACK_IMPORTED_MODULE_4__InStoreEditable___default.a,
    ApiTableBlock: __WEBPACK_IMPORTED_MODULE_5__common_ApiTableBlock___default.a,
    ProductDetailModal: __WEBPACK_IMPORTED_MODULE_6__ProductDetailModal___default.a
  },
  data: function data() {
    return {
      fields: {
        name: {
          label: 'Product',
          thStyle: 'width: 30%;',
          sortable: true
        },
        location: {
          label: 'Locaties',
          thStyle: 'width: 20%;',
          sortable: true
        },
        brand: {
          label: 'Merk',
          thStyle: 'width: 20%;',
          sortable: true
        },
        stock_quantity: {
          label: 'Voorraad',
          thStyle: 'width: 20%;',
          sortable: true
        }
      },
      detailModalProductId: null
    };
  },

  methods: {
    findAllProducts: function findAllProducts(params) {
      return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/products-unknown', { params: params });
    },
    details: function details(product) {
      this.detailModalProductId = product.id;
    },
    refresh: function refresh() {
      this.$refs.productsTable.refresh();
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: {
    barcode: String
  },
  data: function data() {
    return {
      brands: [],

      productBrand: null,
      productTitle: null,
      productLocation: null,
      productQuantity: null,
      newBrand: null
    };
  },

  methods: {
    loadBrands: function loadBrands() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('brands').then(function (result) {
        _this.brands = result.data.data;
      });
    },
    createProduct: function createProduct() {
      var _this2 = this;

      var validData = true;
      if (this.productBrand === null) {
        if (this.newBrand === null) {
          validData = false;
        } else {
          this.productBrand = this.newBrand;
        }
      }
      if (this.productTitle === null) {
        validData = false;
      }
      if (this.productQuantity === null) {
        validData = false;
      }

      if (validData) {
        var data = {
          brand: this.productBrand,
          gtin: this.barcode,
          stock_quantity: this.productQuantity,
          location: this.productLocation,
          name: this.productTitle,
          unknown: true,
          sku: this.barcode
        };

        this.$http.post('/product', data).then(function (response) {
          var product = response.data.data;
          _this2.$swal('Hoera 😊', 'Het product is succesvol aangemaakt.', 'success');
          _this2.$emit('unkownProductCreated', { product: product });
          _this2.$refs.modal.hide();
        }).catch(function () {
          _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het aanmaken van het product. Probeer het opnieuw.', 'error');
        });
      } else {
        this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het aanmaken van het product. Probeer het opnieuw.', 'error');
      }
    }
  },
  created: function created() {
    this.loadBrands();
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    location: String,
    productId: Number
  },
  methods: {
    update: function update(field) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, field, this.location);
      return __WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */].patch('/products/' + this.productId, data).then(function (result) {
        _this.closeModal();
        _this.$swal('Hoera 😊', 'De locatie van het product is succevol bijgewerkt.', 'success');
      }).catch(function () {
        _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het updaten van de locatie. Probeer het opnieuw.', 'error');
      });
    },
    closeModal: function closeModal() {
      this.$refs.modal.hide();
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RefundForm_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RefundForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__RefundForm_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RefundForm: __WEBPACK_IMPORTED_MODULE_0__RefundForm_vue___default.a
  },
  data: function data() {
    return {
      OrderNumber: null,
      order: null,
      orders: [],
      refund: null
    };
  },

  methods: {
    loadOrder: function loadOrder() {
      var _this = this;

      var params = {
        include: 'lines,lines.product,shipment,returnShipment,refund'
      };
      params['filter[search]'] = this.OrderNumber;

      return this.$api.getOrders(params).then(function (result) {
        _this.order = result.data.data[0];
        _this.lines = _this.order.lines;
        _this.createRefund();
      }).catch(function () {
        _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het ophalen van de ' + _this.itemLabelPlural + '. Probeer het opnieuw.', 'error');
        return [];
      });
    },
    getOrders: function getOrders() {
      var _this2 = this;

      var params = {};
      params['filter[search]'] = this.OrderNumber;

      return this.$api.getOrders(params).then(function (response) {
        _this2.orders = response.data.data;
        return response.data.data;
      }).catch(function () {
        _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het ophalen van de ' + _this2.itemLabelPlural + '. Probeer het opnieuw.', 'error');
        return [];
      });
    },
    createRefund: function createRefund() {
      var _this3 = this;

      var data = {
        order_number: this.OrderNumber
      };

      this.$http.post('/refunds', data).then(function (response) {
        _this3.saving = false;
        _this3.alert = { variant: 'success', message: 'Opgeslagen' };
        _this3.refund = response.data.data;
      }).catch(function () {
        _this3.saving = false;
        _this3.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het aanmaken van de retour. Probeer het opnieuw.', 'error');
      });
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RefundForm_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RefundForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__RefundForm_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RefundForm: __WEBPACK_IMPORTED_MODULE_0__RefundForm_vue___default.a
  },
  props: {
    orderId: Number,
    refundId: Number,
    includeRefundShipmentCosts: Boolean
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RefundStatusBadge_vue__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RefundStatusBadge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__RefundStatusBadge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orders_OrderAddress_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orders_OrderAddress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__orders_OrderAddress_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orders_OrderTimeline_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orders_OrderTimeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__orders_OrderTimeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ExcludeToggle_vue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ExcludeToggle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_ExcludeToggle_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RefundStatusBadge: __WEBPACK_IMPORTED_MODULE_0__RefundStatusBadge_vue___default.a,
    OrderAddress: __WEBPACK_IMPORTED_MODULE_1__orders_OrderAddress_vue___default.a,
    OrderTimeline: __WEBPACK_IMPORTED_MODULE_2__orders_OrderTimeline_vue___default.a,
    ExcludeToggle: __WEBPACK_IMPORTED_MODULE_3__common_ExcludeToggle_vue___default.a
  },
  props: {
    orderId: Number,
    refundId: Number,
    includeRefundShipmentCosts: Boolean
  },
  data: function data() {
    return {
      order: null,
      refund: null,
      lines: {},
      shipment: {
        package_type: 1,
        insurance: false,
        large_format: false
      },
      totalRefundPrice: 0,
      manualRefundPrice: 0,
      orderShippingCost: null,
      calculateRefundShipmentCosts: true,
      includeOrderShipmentCosts: false,
      incrementOrderShimentCosts: false,
      orderStatus: false,
      sendRefundConformationMail: true
    };
  },

  computed: {
    calculateTotalRefundCost: function calculateTotalRefundCost() {
      var total = 0;

      total += Math.round(this.totalRefundPrice * 100) / 100;

      this.validateShipmentCosts();
      if (this.incrementOrderShimentCosts) {
        total += Math.round(this.orderShippingCost * 100) / 100;
      } else {
        total -= Math.round(this.orderShippingCost * 100) / 100;
      }

      if (this.calculateRefundShipmentCosts) {
        total -= this.refundShippingCost;
      }

      this.validateManualRefundPrice(total);
      total += Math.round(this.manualRefundPrice * 100) / 100;

      return Math.round(total * 100) / 100;
    },
    pickedAt: function pickedAt() {
      if (this.order.status === 'picked') {
        return this.order.updated_at;
      }

      if (this.order.status === 'completed') {
        return this.completedAt;
      }

      return null;
    },
    orderLines: function orderLines() {
      var _this = this;

      if (this.order.number.substring(0, 3) === 'BOL') {
        return this.order.lines.filter(function (line) {
          return line.product_sku === _this.refund.sales_channel_product_sku;
        });
      } else {
        return this.order.lines.filter(function (line) {
          return line.product != null;
        });
      }
    },
    refundShippingCost: function refundShippingCost() {
      if (this.includeRefundShipmentCosts) {
        if (this.order.return_shipment !== null) {
          if (this.order.return_shipment.provider === 'homerr') {
            return 3.95;
          }
          if (this.order.return_shipment.provider === 'dpd') {
            return 5.95;
          }
        } else {
          return 0.00;
        }
      } else {
        return 0.00;
      }
    },
    completedAt: function completedAt() {
      if (this.order.status === 'completed') {
        return this.order.shipment ? this.order.shipment.created_at : this.order.updated_at;
      }

      return null;
    },
    isFromMarketPlace: function isFromMarketPlace() {
      var marketplacesAbbreviated = ['BOL', 'AMZ', 'FON', 'VTW'];
      if (marketplacesAbbreviated.includes(this.order.number.substring(0, 3))) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    loadData: function loadData() {
      var _this2 = this;

      var params = {
        include: 'lines,lines.product,shipment,returnShipment,refund'
      };
      this.$api.getOrder(this.orderId, params).then(function (result) {
        _this2.order = result.data.data;
        _this2.lines = _this2.order.lines;
      }).catch(function () {
        _this2.$swal('Ehmm...', 'Deze bestelling konden we niet vinden. Probeer het opnieuw.', 'warning');
      });

      this.$api.getRefund(this.refundId, []).then(function (result) {
        _this2.refund = result.data.data;
      }).catch(function () {
        _this2.$swal('Ehmm...', 'Deze retour konden we niet vinden. Probeer het opnieuw.', 'warning');
      });
    },
    setShippingCosts: function setShippingCosts() {
      if (this.order.billing_country === 'NL') {
        this.orderShippingCost = 5.50;
      } else {
        this.orderShippingCost = 5.95;
      }
    },
    amountRefundedValue: function amountRefundedValue(value) {
      if (!this.refund.refund_products) {
        return 0;
      }
      return this.refund.refund_products.find(function (x) {
        return x.product_id === value;
      }) ? this.refund.refund_products.find(function (x) {
        return x.product_id === value;
      }).amount_refunded : 0;
    },
    stockIncreaseValue: function stockIncreaseValue(value) {
      if (!this.refund.refund_products) {
        return 0;
      }
      return this.refund.refund_products.find(function (x) {
        return x.product_id === value;
      }) ? this.refund.refund_products.find(function (x) {
        return x.product_id === value;
      }).new_quantity : 0;
    },
    discountValue: function discountValue(value) {
      if (!this.refund.refund_products) {
        return 0;
      }
      return this.refund.refund_products.find(function (x) {
        return x.product_id === value;
      }) ? this.refund.refund_products.find(function (x) {
        return x.product_id === value;
      }).discount : 0;
    },
    getRefundedProducts: function getRefundedProducts() {
      var _this3 = this;

      var data = [];
      var count = 0;
      for (var item in this.$refs.quantityInput) {
        var line = this.lines.filter(function (x) {
          return x.id === parseInt(_this3.$refs.quantityInput[item].id);
        })[0];
        var amountReturned = this.$refs.quantityInput[item].value;

        if (amountReturned > 0 && !this.isFromMarketPlace) {
          data[count] = {
            'product_id': line.product.id,
            'new_quantity': amountReturned,
            'amount_refunded': this.$refs.input[item].value,
            'discount': this.$refs.priceInput[item].value
          };
        }
        count++;
      }
      return data;
    },
    validateShipmentCosts: function validateShipmentCosts() {
      if (!this.includeOrderShipmentCosts) {
        this.orderShippingCost = 0;
      } else {
        this.setShippingCosts();
      }
    },
    validateManualRefundPrice: function validateManualRefundPrice(total) {
      if (total + this.manualRefundPrice > this.order.total) {
        this.manualRefundPrice = 0;
      } else if (total + this.manualRefundPrice < 0) {
        this.manualRefundPrice = 0;
      }
    },
    updateOrderStatus: function updateOrderStatus() {
      var _this4 = this;

      if (this.orderStatus) {
        var data = {
          status: 'completed'
        };

        this.saving = true;
        this.$http.patch('/orders/' + this.order.id, data).then(function (response) {
          _this4.saving = false;
          _this4.alert = { variant: 'success', message: 'Opgeslagen' };
        }).catch(function () {
          _this4.saving = false;
          _this4.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het opslaan van de status. Probeer het opnieuw.', 'error');
        });
      }
    },
    updateRefundPrice: function updateRefundPrice() {
      var _this5 = this;

      if (this.calculateTotalRefundCost > this.order.total) {
        this.$swal('Oeps! 😳', 'Het bedrag dat geretourneerd moet worden mag niet groter zijn dan de totale bedrag van de bestelling', 'error');
        return;
      }
      var data = {
        refund_cost: this.calculateTotalRefundCost,
        status: 'completed',
        sendRefundConformationMail: this.sendRefundConformationMail,
        returned_products: this.getRefundedProducts()
      };
      this.saving = true;
      this.$http.post('/refunds/complete/' + this.refund.id, data).then(function (response) {
        _this5.saving = false;
        _this5.alert = { variant: 'success', message: 'Opgeslagen' };
        _this5.updateOrderStatus();
        _this5.$swal('Retour betaling is geslaagd 😎', 'Dat scheelt weer.', 'warning');
      }).catch(function () {
        _this5.saving = false;
        _this5.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het verwerken van de retour. Probeer het opnieuw.', 'error');
      });
    },
    calculateRefundPrice: function calculateRefundPrice() {
      var _this6 = this;

      this.totalRefundPrice = 0;
      for (var priceItem in this.$refs.priceInput) {
        if (isNaN(parseFloat(this.$refs.priceInput[priceItem].value)) === false) {
          var amount = this.$refs.input.filter(function (x) {
            return x.id === _this6.$refs.priceInput[priceItem].id;
          })[0];
          var lineId = parseInt(this.$refs.priceInput[priceItem].id);
          var line = this.lines.filter(function (x) {
            return x.id === lineId;
          })[0];
          var discount = parseFloat(this.$refs.priceInput[priceItem].value) / 100;
          if (discount === 0) {
            discount = 1;
          }
          var value = 0;
          if (parseInt(amount.value) !== 0) {
            value = discount * (line.product_price * amount.value);
          } else {
            value = discount * (line.product_price * line.quantity);
          }
          this.totalRefundPrice += value;
        }
      }
    },
    updateProductPrice: function updateProductPrice(line) {
      for (var priceItem in this.$refs.priceInput) {
        if (parseInt(this.$refs.priceInput[priceItem].id) === line.id) {
          var value = parseFloat(this.$refs.priceInput[priceItem].value);
          if (value > 100) {
            this.$swal('Oeps! 😳', 'Korting\'s percentage is te groot', 'error');
          } else if (value < 0) {
            this.$swal('Oeps! 😳', 'Korting\'s percentage is te klein', 'error');
          } else {
            this.calculateRefundPrice();
          }
        }
      }
    },
    updateShippingCost: function updateShippingCost() {
      var amount = parseInt(this.$refs.shippingInput.value);
      if (amount === 1) {
        this.orderShippingCost = this.order.shipping_cost;
      } else {
        this.orderShippingCost = 0;
      }
    },
    updateAmountOfProductRefunded: function updateAmountOfProductRefunded(line) {
      for (var item in this.$refs.input) {
        if (parseInt(this.$refs.input[item].id) === line.id) {
          var amount = parseInt(this.$refs.input[item].value);
          for (var priceItem in this.$refs.priceInput) {
            if (parseInt(this.$refs.priceInput[priceItem].id) === line.id) {
              this.$refs.priceInput[priceItem].value = 0;
              if (amount <= 0) {
                this.$refs.priceInput[priceItem].value = NaN;
              } else {
                this.$refs.priceInput[priceItem].value = 0;
              }
              if (amount > line.quantity) {
                this.$swal('Oeps! 😳', 'Geleverde aantal is te groot', 'error');
              } else if (amount < 0) {
                this.$swal('Oeps! 😳', 'Geleverde aantal is te klein', 'error');
              } else {
                this.calculateRefundPrice();
              }
            }
          }
          for (var quantityItem in this.$refs.quantityInput) {
            if (parseInt(this.$refs.quantityInput[quantityItem].id) === line.id) {
              this.$refs.quantityInput[quantityItem].value = amount;
            }
          }
        }
      }
    }
  },
  created: function created() {
    this.loadData();
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    refund: Object
  },
  data: function data() {
    return {
      saving: false,
      alert: false
    };
  },

  computed: {
    status: function status() {
      return this.refund.status;
    },
    statuses: function statuses() {
      return [{ id: 'completed', label: 'Retour Verwerkt', color: 'success' }, { id: 'in-process', label: 'In behandeling', color: 'info' }, { id: 'cancelled', label: 'Geannuleerd', color: 'danger' }];
    },
    currentStatus: function currentStatus() {
      var _this = this;

      return this.statuses.find(function (s) {
        return s.id === _this.status;
      });
    },
    selectableStatuses: function selectableStatuses() {
      return this.statuses.filter(function (s) {
        return s.selectable !== false;
      });
    }
  },
  methods: {
    updateStatus: function updateStatus(newStatus) {
      var _this2 = this;

      var oldStatus = this.refund.status;
      this.refund.status = newStatus;

      var data = {
        status: newStatus
      };

      this.saving = true;
      this.$http.patch('/refunds/' + this.refund.id, data).then(function (response) {
        _this2.saving = false;
        _this2.alert = { variant: 'success', message: 'Opgeslagen' };
      }).catch(function () {
        _this2.saving = false;
        _this2.order.status = oldStatus;
        _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het opslaan van de status. Probeer het opnieuw.', 'error');
      });
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ApiTableBlock__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ApiTableBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_ApiTableBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RefundDetailModal__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RefundDetailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__RefundDetailModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RefundStatusBadge_vue__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RefundStatusBadge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RefundStatusBadge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BarcodeScanner__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BarcodeScanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_BarcodeScanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ManualRefundModal_vue__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ManualRefundModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ManualRefundModal_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ApiTableBlock: __WEBPACK_IMPORTED_MODULE_0__common_ApiTableBlock___default.a,
    RefundDetailModal: __WEBPACK_IMPORTED_MODULE_1__RefundDetailModal___default.a,
    BarcodeScanner: __WEBPACK_IMPORTED_MODULE_3__common_BarcodeScanner___default.a,
    RefundStatusBadge: __WEBPACK_IMPORTED_MODULE_2__RefundStatusBadge_vue___default.a,
    ManualRefundModal: __WEBPACK_IMPORTED_MODULE_4__ManualRefundModal_vue___default.a
  },
  data: function data() {
    return {
      fields: {
        check: {
          label: '',
          class: 'text-center',
          thStyle: 'width: 70px;'
        },
        number: {
          label: 'Bestelling',
          sortable: true,
          thStyle: 'width: 140px;'
        },
        billing_person: {
          label: 'Klant',
          sortable: true,
          thStyle: 'width: 30%;'
        },
        placed_at: {
          label: 'Datum',
          sortable: true
        },
        status: {
          label: 'Status',
          sortable: true
        },
        actions: {
          label: 'Acties',
          thStyle: 'width: 150px;'
        }
      },
      selectedOrders: [],
      detailModalOrderId: null,
      detailModalRefundId: null,
      ManualDetailModalShow: false,
      showOnlyProcessing: true,
      showOnlyDropship: false
    };
  },

  computed: {
    ordersTable: function ordersTable() {
      return this.$refs.ordersTable;
    }
  },
  methods: {
    findAllRefunds: function findAllRefunds(params) {
      params['include'] = 'order';

      if (this.showOnlyProcessing) {
        params['filter[status]'] = 'in-process';
      } else {
        params['filter[status]'] = 'in-process,completed';
      }

      return this.$api.getRefunds(params);
    },
    refresh: function refresh() {
      this.ordersTable.refresh();
    },
    openDetailModal: function openDetailModal(orderId, refundId) {
      this.detailModalOrderId = orderId;
      this.detailModalRefundId = refundId;
    },
    openManualRefundModal: function openManualRefundModal() {
      this.ManualDetailModalShow = true;
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orders_OrderDetailModal__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orders_OrderDetailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__orders_OrderDetailModal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ApiTableBlock: __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock___default.a,
    OrderDetailModal: __WEBPACK_IMPORTED_MODULE_2__orders_OrderDetailModal___default.a
  },
  data: function data() {
    return {
      fields: {
        order_number: {
          label: 'Bestelling',
          sortable: true,
          thStyle: 'width: 20%;'
        },
        total_sale_price: {
          label: 'Totaalbedrag',
          sortable: true,
          thStyle: 'width: 20%;'
        },
        purchase_price: {
          label: 'Inkoopwaarde',
          sortable: true,
          thStyle: 'width: 20%;'
        },
        sales_channel_commision: {
          label: 'Commisie',
          sortable: true,
          thStyle: 'width: 20%;'
        },
        shipping_cost: {
          label: 'Verzend kosten',
          thStyle: 'width: 20%;'
        },
        profit: {
          label: 'Winstbedrag',
          sortable: true,
          thStyle: 'width: 20%;'
        },
        profit_percentage: {
          label: 'Winstpercentage',
          sortable: true,
          thStyle: 'width: 20%;'
        }
      },
      detailModalOrderId: null,
      orderReportTotals: [],
      countries: [],
      marketplaces: [],
      selectedCountry: null,
      selectedSalesChannel: null,
      selectedPeriodFrom: null,
      selectedPeriodTo: null,

      total_purchase_price: 0,
      total_commission: 0,
      total_shipping_cost: 0,
      totaL_costs: 0,

      total_revenue: 0,
      average_profit_percentage: 0,
      total_profit: 0

    };
  },

  computed: {
    ordersTable: function ordersTable() {
      return this.$refs.ordersTable;
    }
  },
  methods: {
    findAllOrders: function findAllOrders(params) {
      var _this = this;

      if (this.selectedCountry) {
        params['filter[order.billing_country]'] = this.selectedCountry;
      }

      if (this.selectedSalesChannel) {
        params['filter[specific_orders]'] = this.selectedSalesChannel;
      }

      if (this.selectedPeriodFrom) {
        params['filter[period_from]'] = this.selectedPeriodFrom;
      }

      if (this.selectedPeriodTo) {
        params['filter[period_to]'] = this.selectedPeriodTo;
      }

      this.$api.getOrderReportTotals(params).then(function (result) {
        _this.orderReportTotals = result.data.data;
        _this.total_purchase_price = _this.orderReportTotals[0].total_purchase_price;
        _this.total_commission = _this.orderReportTotals[0].total_commission;
        _this.total_shipping_cost = _this.orderReportTotals[0].total_shipping_cost;
        _this.total_costs = _this.orderReportTotals[0].total_costs;

        _this.total_revenue = _this.orderReportTotals[0].total_revenue;
        _this.average_profit_percentage = _this.orderReportTotals[0].average_profit_percentage;
        _this.total_profit = _this.orderReportTotals[0].total_profit;
      }).catch(function () {
        _this.$swal('Ehmm...', 'Deze bestelling konden we niet vinden. Probeer het opnieuw.', 'warning');
      });

      return this.$api.getOrderReport(params);
    },
    refresh: function refresh() {
      this.ordersTable.refresh();
    },
    openDetailModal: function openDetailModal(orderId) {
      this.detailModalOrderId = orderId;
    },
    loadContries: function loadContries() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('order-countries').then(function (result) {
        _this2.countries = result.data.data;
      });
    },
    loadMarketplaces: function loadMarketplaces() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('order-marketplaces').then(function (result) {
        _this3.marketplaces = result.data.data;
      });
    }
  },
  created: function created() {
    this.loadContries();
    this.loadMarketplaces();
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dataBlock_js__ = __webpack_require__(333);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ApiTableBlock: __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock___default.a
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_2__dataBlock_js__["a" /* default */];
  },

  methods: {
    findAllProducts: function findAllProducts(params) {
      return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/report-products/' + this.periodArray[this.period] + '/' + this.isUpToToday + '/' + this.isOnlyCompleted, { params: params }).catch(function (error) {
        console.log(error);
      }).then(function (result) {
        console.log(result);
        return result;
      });
    },
    setVat: function setVat() {
      if (this.isIncVat === false) {
        this.correction = 1 / 1.21;
      } else {
        this.correction = 1;
      }
    },
    refresh: function refresh() {
      this.$refs.productsTable.refresh();
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ApiTableBlock: __WEBPACK_IMPORTED_MODULE_1__common_ApiTableBlock___default.a
  },
  data: function data() {
    return {
      fields: {
        name: {
          label: 'Product',
          thStyle: 'width: 40%;',
          sortable: false
        },
        marketplace: {
          label: 'Marketplace',
          thStyle: 'width: 15%;',
          sortable: true
        },
        purchase_price: {
          label: 'Inkoopprijs',
          thStyle: 'width: 15%;',
          sortable: true
        },
        price: {
          label: 'Verkoopprijs',
          thStyle: 'width: 15%;',
          sortable: true
        },
        profit_margin: {
          label: 'Winst marge',
          thStyle: 'width: 15%;',
          sortable: true
        }
      },
      minProfitMargin: 0,
      maxProfitMargin: 10000,
      selectedBrand: null,
      selectedMarketplace: null,
      showPricesInclVat: false,
      showPricesExclVat: false,
      brands: [],
      marketplaces: []
    };
  },

  methods: {
    findAllProducts: function findAllProducts(params) {
      params['include'] = 'product';
      if (this.selectedBrand) {
        params['filter[product.brand]'] = this.selectedBrand;
      }
      if (this.selectedMarketplace) {
        params['filter[marketplace]'] = this.selectedMarketplace;
      }
      if (this.minProfitMargin) {
        params['filter[min_profit_margin]'] = this.minProfitMargin;
      }
      if (this.maxProfitMargin) {
        params['filter[max_profit_margin]'] = this.maxProfitMargin;
      }
      return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/products-marketplaces-prices', { params: params });
    },
    refresh: function refresh() {
      this.$refs.productsTable.refresh();
    },
    loadBrands: function loadBrands() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('brands').then(function (result) {
        _this.brands = result.data.data;
      });
    },
    loadMarketplaces: function loadMarketplaces() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('products-marketplaces').then(function (result) {
        _this2.marketplaces = result.data.data;
      });
    }
  },
  created: function created() {
    this.loadBrands();
    this.loadMarketplaces();
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LineChart__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_LineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dayjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { LineChart: __WEBPACK_IMPORTED_MODULE_0__components_LineChart___default.a },
  data: function data() {
    return {
      result: null,
      dateFrom: __WEBPACK_IMPORTED_MODULE_2_dayjs___default()().format('YYYY-MM-DD'),
      dateTo: __WEBPACK_IMPORTED_MODULE_2_dayjs___default()().format('YYYY-MM-DD'),
      marketplaces: ['vm_nl', 'vm_de', 'vm_fr', 'vm_en', 'vm_sr', 'channable_nl', 'channable_de', 'channelengine'],
      selectedMarketplaces: ['vm_nl'],
      selectAllMarketplaces: false,
      includeShipping: true,
      includeVat: false
    };
  },
  created: function created() {
    this.load();
  },

  methods: {
    load: function load() {
      var _this = this;

      var params = {
        'dateFrom': this.dateFrom,
        'dateTo': this.dateTo,
        'marketplaces': this.selectedMarketplaces,
        'shipping': this.includeShipping,
        'vat': this.includeVat
      };

      __WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */].get('/report-revenue', { params: params }).then(function (result) {
        _this.result = result.data;
      });
    },
    reload: function reload() {
      this.selectedMarketplaces = this.selectAllMarketplaces ? this.marketplaces : ['vm_nl'];
      this.result = null;
      this.load();
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chartjs__ = __webpack_require__(625);





/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_2_vue_chartjs__["a" /* Line */],
  props: {
    result: Object
  },
  mounted: function mounted() {
    this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
    this.gradient3 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(1, 'rgba(30,112,179,0.4)');
    // this.gradient2.addColorStop(1, 'rgba(32,84,141,0.25)')
    this.gradient2.addColorStop(1, 'rgba(14,121,129,0.25)');
    this.gradient3.addColorStop(1, 'rgba(56,109,157,0.35)');

    var date = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.result.revenue);

    var revenue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.result.revenue);
    var historicalRevenue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.result.historical_revenue);

    this.renderChart({
      labels: date,
      datasets: [{
        label: 'Omzet',
        // borderColor: '#6fccdd',
        borderColor: '#1e70b3',
        borderWidth: 2,
        backgroundColor: this.gradient,
        data: revenue,
        fill: false
      }, {
        label: 'Omzet vorig jaar',
        // borderColor: '#6fccdd',
        borderColor: '#1e7033',
        borderWidth: 2,
        backgroundColor: this.gradient2,
        data: historicalRevenue,
        fill: false
      }]
    }, {
      scales: {
        yAxes: [{
          // stacked: true,
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: 'Omzet',
            fontColor: '#74788d',
            fontSize: 13,
            fontWeight: 400
          }
        }],
        xAxes: [{
          gridLines: {
            display: false
          },
          type: 'time',
          time: {
            unit: 'day',
            displayFormats: {
              day: 'DD MMM'
            }
          },
          ticks: {
            autoSkip: true,
            minRotation: 30
          }
        }]
      },
      legend: {
        display: true,
        labels: {
          fontColor: '#74788d',
          fontSize: 13,
          fontWeight: 400
        }
      },
      elements: {
        point: {
          radius: 0
        }
      },
      responsive: true,
      maintainAspectRatio: false
    });
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['salesChannel'],
  data: function data() {
    return {
      syncing: false
    };
  },

  computed: {
    isImportChannel: function isImportChannel() {
      return this.salesChannel.type === 'woocommerce' || this.salesChannel.type === 'channable' || this.salesChannel.type === 'channelengine';
    }
  },
  methods: {
    syncProducts: function syncProducts() {
      var _this = this;

      this.syncing = true;

      this.$api.syncProducts(this.salesChannel.key).then(function (response) {
        _this.$emit('sync');
        _this.syncing = false;
      }).catch(function () {
        _this.syncing = false;
        _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het importeren van de producten. Probeer het opnieuw.', 'error');
      });
    },
    syncOrders: function syncOrders() {
      var _this2 = this;

      this.syncing = true;
      this.$api.syncOrders(this.salesChannel.key).then(function (response) {
        _this2.$emit('sync');
        _this2.syncing = false;
      }).catch(function () {
        _this2.syncing = false;
        _this2.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het importeren van de bestellingen. Probeer het opnieuw.', 'error');
      });
    },
    syncRefunds: function syncRefunds() {
      var _this3 = this;

      this.syncing = true;
      this.$api.syncRefunds(this.salesChannel.key).then(function (response) {
        _this3.$emit('sync');
        _this3.syncing = false;
      }).catch(function () {
        _this3.syncing = false;
        _this3.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het importeren van de bestellingen. Probeer het opnieuw.', 'error');
      });
    },
    syncStocks: function syncStocks() {
      var _this4 = this;

      this.syncing = true;
      this.$api.syncStocks(this.salesChannel.key).then(function (response) {
        _this4.$emit('sync');
        _this4.syncing = false;
      }).catch(function () {
        _this4.syncing = false;
        _this4.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het sycen van de voorraad. Probeer het opnieuw.', 'error');
      });
    }
  },
  filters: {
    type: function type(_type) {
      switch (_type) {
        case 'woocommerce':
          return 'Woocommerce Webshop';
        case 'physical':
          return 'Fysieke Winkel';
        case 'channelengine':
          return 'ChannelEngine Kanaal';
        case 'channable':
          return 'Channable Kanaal';
      }
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SalesChannelWidget__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SalesChannelWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SalesChannelWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jobs_JobList__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jobs_JobList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__jobs_JobList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { SalesChannelWidget: __WEBPACK_IMPORTED_MODULE_1__SalesChannelWidget___default.a, JobList: __WEBPACK_IMPORTED_MODULE_2__jobs_JobList___default.a },
  data: function data() {
    return {
      salesChannels: []
    };
  },

  methods: {
    loadJobList: function loadJobList() {
      this.$refs.jobList.load();
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/sales-channels').then(function (response) {
      _this.salesChannels = response.data.data;
    }).catch(function () {
      _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het ophalen van de verkoopkanalen. Probeer het opnieuw.', 'error');
    });
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      paymentTransactions: null,
      file: null,
      loading: false
    };
  },

  methods: {
    loadData: function loadData() {
      var _this = this;

      this.loading = true;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/amazon/settlement-references').then(function (result) {
        _this.paymentTransactions = result.data.data;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
        _this.$swal('Ehmm...', 'Er is iets misgegaan bij het ophalen van de amazon settlements. Probeer het opnieuw.', 'warning');
      });
    },
    onFileChange: function onFileChange(e) {
      this.file = e.target.files[0];
    },
    uploadFile: function uploadFile(paymentTransaction) {
      var _this2 = this;

      var config = {
        headers: { 'content-type': 'multipart/form-data' }
      };

      var formData = new FormData();
      formData.append('file', this.file);

      formData.append('name', paymentTransaction.reference);

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].post('/amazon/upload-xml', formData, config).then(function (result) {
        _this2.file = null;
        _this2.$swal('Hoera 😊', 'Bestand is succesvol geupload.', 'success');
        _this2.loadData();
      }).catch(function () {
        _this2.$swal('Ehmm...', 'Er is iets misgegaan met het uploaden van de amazon xml. Probeer het opnieuw.', 'warning');
      });
    },
    deleteFiles: function deleteFiles() {
      var _this3 = this;

      this.$http.delete('/amazon/delete-all-xmls').then(function (response) {
        _this3.$swal('Hoera 😊', 'De bestanden zijn succesvol verwijderen.', 'success');
        _this3.loadData();
      }).catch(function () {
        _this3.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het verwijderen van de bestanden. Probeer het opnieuw.', 'error');
      });
    }
  },
  created: function created() {
    this.loadData();
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      brand_delivery_times: null,
      delivery_times: []
    };
  },

  methods: {
    loadData: function loadData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/brand-delivery-times').then(function (result) {
        _this.brand_delivery_times = result.data;
        _this.fillArrays();
      }).catch(function () {
        _this.$swal('Ehmm...', 'Deze bestelling konden we niet vinden. Probeer het opnieuw.', 'warning');
      });
    },
    updateBrandDeliveryTimeField: function updateBrandDeliveryTimeField(id) {
      var _this2 = this;

      var data = {
        'delivery_time': this.delivery_times[id]
      };

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].patch('/brand-delivery-times/' + id, data).then(function (result) {
        _this2.$swal('Hoera 😊', 'De commissie is succesvol bijgewerkt.', 'success');
      }).catch(function () {
        _this2.$swal('Ehmm...', 'Er is iets misgegaan bij het bijwerken van deze commissie. Probeer het opnieuw.', 'warning');
      });
    },
    fillArrays: function fillArrays() {
      var _this3 = this;

      this.brand_delivery_times.forEach(function (element) {
        _this3.delivery_times[element.id] = element.delivery_time;
      });
    }
  },
  created: function created() {
    this.loadData();
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sales_channel_commissions: null,
      commission_percentages: []
    };
  },

  methods: {
    loadData: function loadData() {
      var _this = this;

      this.$api.getSalesChannelCommissions().then(function (result) {
        _this.sales_channel_commissions = result.data;
        _this.fillArrays();
      }).catch(function () {
        _this.$swal('Ehmm...', 'Deze bestelling konden we niet vinden. Probeer het opnieuw.', 'warning');
      });
    },
    updateSalesChannelCommissionField: function updateSalesChannelCommissionField(id) {
      var _this2 = this;

      var data = {
        'commission_percentage': this.commission_percentages[id]
      };

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].patch('/sales-channels-commission/' + id, data).then(function (result) {
        _this2.$swal('Hoera 😊', 'De commissie is succesvol bijgewerkt.', 'success');
      }).catch(function () {
        _this2.$swal('Ehmm...', 'Er is iets misgegaan bij het bijwerken van deze commissie. Probeer het opnieuw.', 'warning');
      });
    },
    fillArrays: function fillArrays() {
      var _this3 = this;

      this.sales_channel_commissions.forEach(function (element) {
        _this3.commission_percentages[element.id] = element.commission_percentage;
      });
    }
  },
  created: function created() {
    this.loadData();
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    orderNotification: Object
  },
  data: function data() {
    return {
      brands: []
    };
  },

  methods: {
    loadBrands: function loadBrands() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('brands').then(function (result) {
        _this.brands = result.data.data;
      });
    },
    save: function save() {
      var _this2 = this;

      if (!this.orderNotification.id) {
        __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].post('/order-notification', this.orderNotification).then(function (result) {
          _this2.$swal('Hoera 😊', 'Nieuwe order notificatie is succesvol aangemaakt.', 'success');
          _this2.$refs.modal.hide();
        }).catch(function () {
          _this2.$swal('Ehmm...', 'Er is iets misgegaan bij het aanmaken van een nieuwe order notificatie', 'warning');
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].patch('/order-notification/' + this.orderNotification.id, this.orderNotification).then(function (result) {
          _this2.$swal('Hoera 😊', 'Order notificatie is succescol geupdate.', 'success');
          _this2.$refs.modal.hide();
        }).catch(function () {
          _this2.$swal('Ehmm...', 'Er is iets misgegaan bij het updaten van de order notificatie', 'warning');
        });
      }
    }
  },
  created: function created() {
    this.loadBrands();
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderNotificationEditModal__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderNotificationEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__OrderNotificationEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { OrderNotificationEditModal: __WEBPACK_IMPORTED_MODULE_0__OrderNotificationEditModal___default.a },
  data: function data() {
    return {
      orderNotifications: null,
      showEditModal: false,
      loading: false,
      selected: {
        status: true,
        settings: {
          brands: [],
          exclude_sale_products: false
        }
      }
    };
  },

  methods: {
    load: function load() {
      var _this = this;

      this.loading = true;
      this.$api.getOrderNotification().then(function (result) {
        _this.orderNotifications = result.data;
        _this.selected = {
          status: true,
          settings: {
            brands: [],
            exclude_sale_products: false
          }
        };

        _this.loading = false;
      }).catch(function () {
        _this.$swal('Ehmm...', 'Er is iets misgegaan met het ophalen van de order notificaties. Probeer het opnieuw.', 'warning');
      });
    },
    refresh: function refresh() {
      this.showEditModal = false;
      this.selected = {
        settings: {}
      };
      this.load();
    },
    openEditModal: function openEditModal() {
      this.showEditModal = true;
    },
    select: function select(orderNotification) {
      this.selected = orderNotification;

      this.openEditModal();
    },
    deleteNotification: function deleteNotification(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */].delete('/order-notification/' + id).then(function (result) {
        _this2.$swal('Hoera 😊', 'Order notificatie is verwijderd.', 'success');
        _this2.load();
      }).catch(function () {
        _this2.$swal('Ehmm...', 'Er is iets misgegaan bij het verwijderen van de nieuwe order notificatie', 'warning');
      });
    }
  },
  created: function created() {
    this.load();
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShippingCostTab_vue__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShippingCostTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ShippingCostTab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommissionTab_vue__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommissionTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CommissionTab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderNotificationTab_vue__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderNotificationTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OrderNotificationTab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BrandDeliveryTimeTab_vue__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BrandDeliveryTimeTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BrandDeliveryTimeTab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AmazonXmlUploadTab_vue__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AmazonXmlUploadTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AmazonXmlUploadTab_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ShippingCostTab: __WEBPACK_IMPORTED_MODULE_0__ShippingCostTab_vue___default.a, CommissionTab: __WEBPACK_IMPORTED_MODULE_1__CommissionTab_vue___default.a, OrderNotificationTab: __WEBPACK_IMPORTED_MODULE_2__OrderNotificationTab_vue___default.a, BrandDeliveryTimeTab: __WEBPACK_IMPORTED_MODULE_3__BrandDeliveryTimeTab_vue___default.a, AmazonXmlUploadTab: __WEBPACK_IMPORTED_MODULE_4__AmazonXmlUploadTab_vue___default.a }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      shipping_costs: null,

      letterboxPackages: [],
      parcelPosts: [],
      smallPackages: []
    };
  },

  methods: {
    loadData: function loadData() {
      var _this = this;

      this.$api.getShippingCosts().then(function (result) {
        _this.shipping_costs = result.data;
        _this.fillArrays();
      }).catch(function () {
        _this.$swal('Ehmm...', 'Deze bestelling konden we niet vinden. Probeer het opnieuw.', 'warning');
      });
    },
    updateShippingCostField: function updateShippingCostField(id, field, salesChannel) {
      var _data,
          _this2 = this;

      var value = null;
      if (field === 'letterbox_package') {
        value = this.letterboxPackages[id];
      } else if (field === 'small_package') {
        value = this.smallPackages[id];
      } else {
        value = this.parcelPosts[id];
      }

      var data = (_data = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data, field, value), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data, 'sales_channel', salesChannel), _data);

      __WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */].patch('/shipping-costs/' + id, data).then(function (result) {
        _this2.$swal('Hoera 😊', 'De verzendkosten zijn succesvol bijgewerkt.', 'success');
      }).catch(function () {
        _this2.$swal('Ehmm...', 'Er is iets misgegaan met het bijwerken van de verzendkosten. Probeer het opnieuw.', 'warning');
      });
    },
    fillArrays: function fillArrays() {
      var _this3 = this;

      this.shipping_costs.forEach(function (element) {
        _this3.letterboxPackages[element.id] = element.letterbox_package;
        _this3.parcelPosts[element.id] = element.parcel_post;
        _this3.smallPackages[element.id] = element.small_package;
      });
    }
  },
  created: function created() {
    this.loadData();
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      form: {
        username: '',
        password: ''
      }
    };
  },

  methods: {
    onSubmit: function onSubmit(event) {
      var _this = this;

      event.preventDefault();
      var data = {
        username: this.form.username,
        password: this.form.password
      };

      this.$http.post('/users', data).then(function (response) {
        _this.$swal('Hoera 😊', 'De gebruiker is succesvol aangemaakt.', 'success');
        _this.$emit('userCreated');
        _this.$refs.modal.hide();
      }).catch(function () {
        _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het opslaan van de status. Probeer het opnieuw.', 'error');
      });
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__employees_HourRegistrationTable_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__employees_HourRegistrationTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__employees_HourRegistrationTable_vue__);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HourRegistrationTable: __WEBPACK_IMPORTED_MODULE_0__employees_HourRegistrationTable_vue___default.a
  },
  props: {
    userId: Number
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateNewUserModal__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateNewUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CreateNewUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HourRegistrationModal_vue__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HourRegistrationModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HourRegistrationModal_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CreateNewUserModal: __WEBPACK_IMPORTED_MODULE_1__CreateNewUserModal___default.a,
    HourRegistrationModal: __WEBPACK_IMPORTED_MODULE_2__HourRegistrationModal_vue___default.a
  },
  data: function data() {
    return {
      users: [],
      showCreateUserModal: false,
      showHourRegistrationModal: false,
      selectedUserId: null
    };
  },

  methods: {
    loadUsers: function loadUsers() {
      var _this = this;

      var params = {
        'filter[role]': 'orderpicker'
      };

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].get('/users', { params: params }).then(function (response) {
        _this.users = response.data.data;
      }).catch(function () {
        _this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het ophalen van de gebruikers. Probeer het opnieuw.', 'error');
      });
    },
    openCreateUserModal: function openCreateUserModal() {
      this.showCreateUserModal = true;
    },
    openHourRegistrationModal: function openHourRegistrationModal(id) {
      this.selectedUserId = id;
      this.showHourRegistrationModal = true;
    },
    deleteUser: function deleteUser(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */].delete('/users/' + id).then(function (result) {
        _this2.$swal('Hoera 😊', 'Gebruiker is verwijderd.', 'success');
        _this2.loadUsers();
      }).catch(function () {
        _this2.$swal('Ehmm...', 'Er is iets misgegaan bij het verwijderen van de gebruiker', 'warning');
      });
    }
  },
  created: function created() {
    this.loadUsers();
  }
});

/***/ }),
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 165,
	"./af.js": 165,
	"./ar": 172,
	"./ar-dz": 166,
	"./ar-dz.js": 166,
	"./ar-kw": 167,
	"./ar-kw.js": 167,
	"./ar-ly": 168,
	"./ar-ly.js": 168,
	"./ar-ma": 169,
	"./ar-ma.js": 169,
	"./ar-sa": 170,
	"./ar-sa.js": 170,
	"./ar-tn": 171,
	"./ar-tn.js": 171,
	"./ar.js": 172,
	"./az": 173,
	"./az.js": 173,
	"./be": 174,
	"./be.js": 174,
	"./bg": 175,
	"./bg.js": 175,
	"./bm": 176,
	"./bm.js": 176,
	"./bn": 177,
	"./bn.js": 177,
	"./bo": 178,
	"./bo.js": 178,
	"./br": 179,
	"./br.js": 179,
	"./bs": 180,
	"./bs.js": 180,
	"./ca": 181,
	"./ca.js": 181,
	"./cs": 182,
	"./cs.js": 182,
	"./cv": 183,
	"./cv.js": 183,
	"./cy": 184,
	"./cy.js": 184,
	"./da": 185,
	"./da.js": 185,
	"./de": 188,
	"./de-at": 186,
	"./de-at.js": 186,
	"./de-ch": 187,
	"./de-ch.js": 187,
	"./de.js": 188,
	"./dv": 189,
	"./dv.js": 189,
	"./el": 190,
	"./el.js": 190,
	"./en-au": 191,
	"./en-au.js": 191,
	"./en-ca": 192,
	"./en-ca.js": 192,
	"./en-gb": 193,
	"./en-gb.js": 193,
	"./en-ie": 194,
	"./en-ie.js": 194,
	"./en-il": 195,
	"./en-il.js": 195,
	"./en-nz": 196,
	"./en-nz.js": 196,
	"./eo": 197,
	"./eo.js": 197,
	"./es": 200,
	"./es-do": 198,
	"./es-do.js": 198,
	"./es-us": 199,
	"./es-us.js": 199,
	"./es.js": 200,
	"./et": 201,
	"./et.js": 201,
	"./eu": 202,
	"./eu.js": 202,
	"./fa": 203,
	"./fa.js": 203,
	"./fi": 204,
	"./fi.js": 204,
	"./fo": 205,
	"./fo.js": 205,
	"./fr": 208,
	"./fr-ca": 206,
	"./fr-ca.js": 206,
	"./fr-ch": 207,
	"./fr-ch.js": 207,
	"./fr.js": 208,
	"./fy": 209,
	"./fy.js": 209,
	"./gd": 210,
	"./gd.js": 210,
	"./gl": 211,
	"./gl.js": 211,
	"./gom-latn": 212,
	"./gom-latn.js": 212,
	"./gu": 213,
	"./gu.js": 213,
	"./he": 214,
	"./he.js": 214,
	"./hi": 215,
	"./hi.js": 215,
	"./hr": 216,
	"./hr.js": 216,
	"./hu": 217,
	"./hu.js": 217,
	"./hy-am": 218,
	"./hy-am.js": 218,
	"./id": 219,
	"./id.js": 219,
	"./is": 220,
	"./is.js": 220,
	"./it": 221,
	"./it.js": 221,
	"./ja": 222,
	"./ja.js": 222,
	"./jv": 223,
	"./jv.js": 223,
	"./ka": 224,
	"./ka.js": 224,
	"./kk": 225,
	"./kk.js": 225,
	"./km": 226,
	"./km.js": 226,
	"./kn": 227,
	"./kn.js": 227,
	"./ko": 228,
	"./ko.js": 228,
	"./ku": 229,
	"./ku.js": 229,
	"./ky": 230,
	"./ky.js": 230,
	"./lb": 231,
	"./lb.js": 231,
	"./lo": 232,
	"./lo.js": 232,
	"./lt": 233,
	"./lt.js": 233,
	"./lv": 234,
	"./lv.js": 234,
	"./me": 235,
	"./me.js": 235,
	"./mi": 236,
	"./mi.js": 236,
	"./mk": 237,
	"./mk.js": 237,
	"./ml": 238,
	"./ml.js": 238,
	"./mn": 239,
	"./mn.js": 239,
	"./mr": 240,
	"./mr.js": 240,
	"./ms": 242,
	"./ms-my": 241,
	"./ms-my.js": 241,
	"./ms.js": 242,
	"./mt": 243,
	"./mt.js": 243,
	"./my": 244,
	"./my.js": 244,
	"./nb": 245,
	"./nb.js": 245,
	"./ne": 246,
	"./ne.js": 246,
	"./nl": 55,
	"./nl-be": 247,
	"./nl-be.js": 247,
	"./nl.js": 55,
	"./nn": 248,
	"./nn.js": 248,
	"./pa-in": 249,
	"./pa-in.js": 249,
	"./pl": 250,
	"./pl.js": 250,
	"./pt": 252,
	"./pt-br": 251,
	"./pt-br.js": 251,
	"./pt.js": 252,
	"./ro": 253,
	"./ro.js": 253,
	"./ru": 254,
	"./ru.js": 254,
	"./sd": 255,
	"./sd.js": 255,
	"./se": 256,
	"./se.js": 256,
	"./si": 257,
	"./si.js": 257,
	"./sk": 258,
	"./sk.js": 258,
	"./sl": 259,
	"./sl.js": 259,
	"./sq": 260,
	"./sq.js": 260,
	"./sr": 262,
	"./sr-cyrl": 261,
	"./sr-cyrl.js": 261,
	"./sr.js": 262,
	"./ss": 263,
	"./ss.js": 263,
	"./sv": 264,
	"./sv.js": 264,
	"./sw": 265,
	"./sw.js": 265,
	"./ta": 266,
	"./ta.js": 266,
	"./te": 267,
	"./te.js": 267,
	"./tet": 268,
	"./tet.js": 268,
	"./tg": 269,
	"./tg.js": 269,
	"./th": 270,
	"./th.js": 270,
	"./tl-ph": 271,
	"./tl-ph.js": 271,
	"./tlh": 272,
	"./tlh.js": 272,
	"./tr": 273,
	"./tr.js": 273,
	"./tzl": 274,
	"./tzl.js": 274,
	"./tzm": 276,
	"./tzm-latn": 275,
	"./tzm-latn.js": 275,
	"./tzm.js": 276,
	"./ug-cn": 277,
	"./ug-cn.js": 277,
	"./uk": 278,
	"./uk.js": 278,
	"./ur": 279,
	"./ur.js": 279,
	"./uz": 281,
	"./uz-latn": 280,
	"./uz-latn.js": 280,
	"./uz.js": 281,
	"./vi": 282,
	"./vi.js": 282,
	"./x-pseudo": 283,
	"./x-pseudo.js": 283,
	"./yo": 284,
	"./yo.js": 284,
	"./zh-cn": 285,
	"./zh-cn.js": 285,
	"./zh-hk": 286,
	"./zh-hk.js": 286,
	"./zh-tw": 287,
	"./zh-tw.js": 287
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 618;

/***/ }),
/* 619 */,
/* 620 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAB+UExURUxpcQAApQAApQAApQAApQAApQAApRAQqQAApQAApQAApAAApQAApQAApi0ttwAApQAApgAApbS05tLS75WV2gAApgAApf///87O7pCQ2ExMwRERrurq+D4+vNvb8gUFqyMjs7+/6X5+0qKi3qys4vf3/Gtry15ex3R0zoyM13fOIHcAAAAWdFJOUwCSJizpy94P+Z8a8r2C+VldXNTyjK61TPmEAAAACXBIWXMAAADsAAAA7AF5KHG9AAABQElEQVQ4y42TiZKDIAyGsR6g1navSagVb2v7/i+4RJFtvbr/DDMZ/o8QjjBmxT9C34tjzw8/OVvKDQVYifAws7nzZA+I85LlEMBCfvSU3oMVBa5dv+prwuTgAWzIH+twYFPJsIHYBmLaJIQdOboCAXcp24V1lVIqEJydAS6I+RJAxBTgTDsQUCpVjE6hVPkHOMwfAFJ30fNlRWF2mwCfeRZAbOCamfBmAI+JAejahqwTsRWFWTkCwgC6yGuHWOeI+kAnSjEBnj2FXvfQo9Z1arMeAHUyReZQ0ExfUXJ4kEmjwm9zzFFZkU6hpCLviF/mokb1Ns5LAvoOfxiP6apJraJ7Uo2UVV2MV51W/M1jhW+eWxz+82EYO275R7b/KQPbGm6w/+11jpVdjq8NmsSz+pN580avzRut9PfQ/kLM2v8XECFGtzi7GrEAAABXelRYdFJhdyBwcm9maWxlIHR5cGUgaXB0YwAAeJzj8gwIcVYoKMpPy8xJ5VIAAyMLLmMLEyMTS5MUAxMgRIA0w2QDI7NUIMvY1MjEzMQcxAfLgEigSi4A6hcRdPJCNZUAAAAASUVORK5CYII="

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAEg0lEQVRYhZ2XX2gdRRTGf2d2E0OtCjVUn4JISNvc3AWtUESof6BFivRJsAGfilj/PVRDH0IJIVQJIhGUPogtPimU0peCtD5JfBST2u7NbYOKlOJTGmKVEtObvXN8uDv3zm5205sOLLN3Z+Y73/nOmTl3hAdo16maHjgicApAYWIdzg1Ts1vFkq1MrhOZXvQVgWlBnvPHFJ1TGG8gP1aIuybSFYF6y+PIwCfAofJlCnDJwsl1iCtdKLIpgYWWxwMCU4K8CRhxZkrA0jEL+q2FyQZya2QTRQoJ1KmaAHYEcELgA0G2tf0rMZon1vqtqwqnLXyWwEqRIhkCC0TGQF+AvmNgXJD+nGddNwfcWqfLCtMJ8lUT1nxF2gRiIhOgRwycMsjTApgSb8sMFimRbfqnwsR/yLkoJdG2EbS6ZQurmoI4mllvskbFG5f7fKeFvRLkMDLtOlEf6NsGJgXZUaaEI+R7XEYUdEVhKkG+3kO8tgGrTmQSeFVgNiJerRMZg/YbmALeMkgouUX3y4k0CROFbyxMJMhyhdjeINoWoC+tIz9UiG3buQQZs3CtRnQ4AfZQW1qH9xX2WXRWPZO+x77UnscoOmth3z14dxe1pQT4nerhHvSaQcbcTNNZAk1ksIlcFLi8QDQiwG5qV5rIAQujit7Mmuk8HSJ6S2G0gRwYonZFgN+ojjyMXha4KMigj2HyYLb1HLQwr8hMnahfUZsg55tI1aIfg65ulBsUXUmQagM5r6hdJOrvhRkD8yAHQTaErk2gCSiC7fS9CscVrQNHFcxu4rsNZLIJFdAL7V3ewQtBQwXTC0dDtC7IcZDesnDlQuD34vqdipwR9OcbVPeDsovazTV4w8LLoHEHVB4Nod6H/irIGUF2+jvDPYUEUulppjI1U3Fte6E8q/BTAN8tUh0QhCFqs2vIXkUXvIA8CTLiG92s5ULg8kAySrgDqfVdjgD1EH1vgcgIWEX+pUDe/NYtKjyZM6bpKaElJFI1tisyWnY2lBkrIumdAxvzwClh03cXDkfSb24rbmawKByZHMgmYdZ7RyJfJ6CYTN5YWS5sCIELQxEJZ7gILP89Xy/K6kRYBFRQxQgQml75MQWgZWEoMuxavtB58fcTEv+AyiSlI+3Wasl73iHXQm9Cw59cpoSkBP2a7ub63rh3v2R75WxNU1TjQHtgXNA5HzS7I7KJaHP++GrlT72s/Dpn4aRbbQAqxPZFrl19HH0+RI+BLuVJOHB/e7Yhc3PyuyStkkuKHkuQF4aoXa3k/5IBPEOcPIGefQiqBv0SNCnaGflzwDfs5tCeo4mipxOoNJCzu4kbvs3Se0GdyNxGogS+UGR/mLIN0t6gi49h9wLcQ34RGHY7Ix1HYFbhwyYSl92W7nszmicK/0Fet/BpiAyYDBG9mRp9KqRV7YNW/5fACeDCMLVkM/wur2aRuQPbG8i4wEcG6e0oAUHLWwJoGPRzgWkDd7u5I27xclo1dzCDFmYUXguQNgED3/egYyH6Rzd3wgci4BP5G3NIYSZVYuwR7KWtGHbtfxjHHAo7Itq7AAAAAElFTkSuQmCC"

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(697),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(757),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(705),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(738),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(743),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(724),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(716),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(691),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(746),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(577)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(701),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(755),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(758),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(756),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(741),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(575)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(693),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(742),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(713),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(732),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(729),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(583)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(733),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6df4526c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(751),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(727),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(712),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-49e62593",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(703),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(584)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(735),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79014e0a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(736),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(585)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(748),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aeede300",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(582)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(723),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ce399e5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(719),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(588)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(760),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e1221564",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(725),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(763),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(754),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c2a875ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(747),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(730),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(745),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(720),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(731),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(581)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(715),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4dbea381",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(734),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(590)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(765),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fe7d8de4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(695),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(710),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(762),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eb933a16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(696),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(744),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(764),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(700),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(702),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(761),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(726),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(694),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(699),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(704),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(749),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(739),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(717),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(688),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('api-table-block', {
    ref: "registrationTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.loadHourRegistrations,
      "default-sort-by": "placed_at",
      "item-label-singular": "urenregistratie",
      "item-label-plural": "Urenregistraties",
      "hideSearchBar": true
    },
    scopedSlots: _vm._u([{
      key: "created_at",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("capitalize")(_vm._f("moment")(data.value, 'calendar'))) + "\n    ")]
      }
    }, {
      key: "display_start",
      fn: function(data) {
        return [(data.item.editing) ? _c('span', [_c('b-input', {
          model: {
            value: (data.item.temp['display_start']),
            callback: function($$v) {
              _vm.$set(data.item.temp, 'display_start', $$v)
            },
            expression: "data.item.temp['display_start']"
          }
        })], 1) : _c('span', [_vm._v("\n        " + _vm._s(data.value) + "\n      ")])]
      }
    }, {
      key: "display_stop",
      fn: function(data) {
        return [(data.item.editing) ? _c('span', [_c('b-input', {
          model: {
            value: (data.item.temp['display_stop']),
            callback: function($$v) {
              _vm.$set(data.item.temp, 'display_stop', $$v)
            },
            expression: "data.item.temp['display_stop']"
          }
        })], 1) : _c('span', [_vm._v("\n        " + _vm._s(data.value) + "\n      ")])]
      }
    }, {
      key: "hours_worked",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value) + "\n    ")]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [(!data.item.editing) ? _c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group"
          }
        }, [_c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.deleteEntry(data.item.id)
            }
          }
        }, [_vm._v("Verwijderen")]), _vm._v(" "), (_vm.role === 'admin') ? _c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.doEdit(data.item)
            }
          }
        }, [_vm._v("Edit")]) : _vm._e()]) : _c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group"
          }
        }, [_c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.doCancel(data.item)
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.doSave(data.item)
            }
          }
        }, [_vm._v("Save")])])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-form-radio-group', {
    staticClass: "exclude-toggle",
    attrs: {
      "checked": _vm.value,
      "size": "sm",
      "buttons": ""
    },
    on: {
      "change": function($event) {
        _vm.$emit('input', $event)
      }
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": false,
      "button-variant": !_vm.value ? 'success' : null
    }
  }, [_vm._v("aftrekken van")]), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "value": true,
      "button-variant": _vm.value ? 'success' : null
    }
  }, [_vm._v("optellen bij")])], 1)
},staticRenderFns: []}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Retour details"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('refund-form', {
    attrs: {
      "order-id": _vm.orderId,
      "refundId": _vm.refundId,
      "includeRefundShipmentCosts": _vm.includeRefundShipmentCosts
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "css-control css-control-primary css-checkbox"
  }, [_c('input', {
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.currentValue
    },
    on: {
      "change": _vm.save
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row gutters-tiny"
  }, [_c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "orders",
      "label": "Bestellingen",
      "icon": "basket"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "products",
      "label": "Producten",
      "icon": "tag",
      "icon-class": "text-danger"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "hour_registration",
      "label": "Urenregistratie",
      "icon": "clock",
      "icon-class": "text-success"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b-dropdown', {
    attrs: {
      "size": "sm",
      "variant": _vm.currentStatus.color,
      "disabled": _vm.saving
    }
  }, [_c('template', {
    slot: "button-content"
  }, [(_vm.saving) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin mr-1"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.currentStatus.label) + "\n    ")]), _vm._v(" "), _vm._l((_vm.selectableStatuses), function(status) {
    return _c('b-dropdown-item', {
      key: status.id,
      class: ("bg-" + (status.color)),
      staticStyle: {
        "color": "#fff !important"
      },
      on: {
        "click": function($event) {
          _vm.updateStatus(status.id)
        }
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2), _vm._v(" "), _c('text-alert', {
    staticClass: "ml-1",
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-scroll page-header-modern main-content-narrow",
    class: {
      'sidebar-o': _vm.sidebarOpen, 'sidebar-o-xs': _vm.sidebarOpen
    },
    attrs: {
      "id": "page-container"
    }
  }, [_c('vmc-sidebar', {
    on: {
      "close-sidebar": function($event) {
        _vm.sidebarOpen = false
      }
    }
  }), _vm._v(" "), _c('vmc-header', {
    on: {
      "toggle-sidebar": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }), _vm._v(" "), _c('main', {
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), _c('vmc-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "card": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Verzendkosten",
      "active": ""
    }
  }, [_c('shipping-cost-tab')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Commisies"
    }
  }, [_c('commission-tab')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Order meldingen",
      "active": ""
    }
  }, [_c('order-notification-tab')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Merk levertijden",
      "active": ""
    }
  }, [_c('brand-delivery-time-tab')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Amazon xml",
      "active": ""
    }
  }, [_c('amazon-xml-upload-tab')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isIncVat),
      expression: "isIncVat"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isIncVat"
    },
    domProps: {
      "checked": Array.isArray(_vm.isIncVat) ? _vm._i(_vm.isIncVat, null) > -1 : (_vm.isIncVat)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isIncVat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isIncVat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isIncVat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isIncVat = $$c
        }
      }, function($event) {
        _vm.setVat(), _vm.refresh()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isIncVat"
    }
  }, [_vm._v("inclusief b.t.w.")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period),
      expression: "period"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.period = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.refresh()
      }]
    }
  }, _vm._l((_vm.periodArray), function(months, period) {
    return _c('option', {
      key: period
    }, [_vm._v(_vm._s(period))])
  }), 0), _vm._v(" "), (!_vm.period.includes('Vorig')) ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isUpToToday),
      expression: "isUpToToday"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isUpToToday"
    },
    domProps: {
      "checked": Array.isArray(_vm.isUpToToday) ? _vm._i(_vm.isUpToToday, null) > -1 : (_vm.isUpToToday)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isUpToToday,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isUpToToday = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isUpToToday = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isUpToToday = $$c
        }
      }, function($event) {
        _vm.refresh()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isUpToToday"
    }
  }, [_vm._v("tot vandaag")])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-tag mr-5"
  }), _vm._v(" Producten " + _vm._s((_vm.period === "Dit jaar" ? "in dit jaar t.o.v. vorig jaar" : "in " + _vm.period.toLowerCase() + " van dit jaar t.o.v. van vorig jaar")) + "\n  ")]), _vm._v(" "), _c('api-table-block', {
    ref: "productsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllProducts,
      "default-sort-by": "total_revenue",
      "item-label-singular": "product",
      "item-label-plural": "producten"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value) + "\n    ")]
      }
    }, {
      key: "total_revenue",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(_vm.correction * Number(data.value))) + "\n      "), _c('b', [_c('small', {
          class: data.item.improvement_revenue >= 0 ? 'text-success' : 'text-danger'
        }, [_vm._v(_vm._s(data.item.improvement_revenue) + _vm._s(data.item.improvement_revenue ? '%' : ''))])])]
      }
    }, {
      key: "total_revenue_last_year",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")((data.value ? _vm.correction * Number(data.value) : ''))) + "\n    ")]
      }
    }, {
      key: "total_sold",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(Number(data.value)) + "\n      "), _c('b', [_c('small', {
          class: data.item.improvement_sold >= 0 ? 'text-success' : 'text-danger'
        }, [_vm._v(_vm._s(data.item.improvement_sold) + _vm._s(data.item.improvement_sold ? '%' : ''))])])]
      }
    }, {
      key: "total_sold_last_year",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value ? Number(data.value) : '') + "\n    ")]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-link-shadow text-center"
  }, [_c('div', {
    staticClass: "block-content block-content-full block-sticky-options pt-30"
  }, [_c('div', {
    staticClass: "block-options"
  }, [_c('b-dropdown', {
    staticClass: "dropdown-no-btn",
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ellipsis-v"
  })]), _vm._v(" "), (_vm.isImportChannel) ? _c('b-dropdown-item', {
    attrs: {
      "disabled": _vm.syncing
    },
    on: {
      "click": _vm.syncProducts
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tag mr-5"
  }), _vm._v("Importeer Producten\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isImportChannel && _vm.salesChannel.key.includes('vm')) ? _c('b-dropdown-item', {
    attrs: {
      "disabled": _vm.syncing
    },
    on: {
      "click": _vm.syncStocks
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tag mr-5"
  }), _vm._v("Synchroniseer voorraad\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isImportChannel) ? _c('b-dropdown-item', {
    attrs: {
      "disabled": _vm.syncing
    },
    on: {
      "click": _vm.syncOrders
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-shopping-cart mr-5"
  }), _vm._v("Importeer Bestellingen\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isImportChannel) ? _c('b-dropdown-item', {
    attrs: {
      "disabled": _vm.syncing
    },
    on: {
      "click": _vm.syncRefunds
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-shopping-cart mr-5"
  }), _vm._v("Importeer Retours\n        ")]) : _vm._e()], 2)], 1), _vm._v(" "), _c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": '/static/img/sales-channels/' + _vm.salesChannel.type + '.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full block-content-sm bg-body-light"
  }, [_c('div', {
    staticClass: "font-w600 mb-5"
  }, [_vm._v(_vm._s(_vm.salesChannel.name))]), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v(_vm._s(_vm._f("type")(_vm.salesChannel.type)))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row items-push text-center"
  }, [(_vm.isImportChannel) ? _c('div', {
    staticClass: "col-12"
  }, [(_vm.syncing) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v("Import starten...")])]) : _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v("Laatste import: " + _vm._s(_vm._f("moment")(_vm.salesChannel.date_last_synced, 'calendar')))])])]) : _c('div', {
    staticClass: "col-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v("Import n.v.t.")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-like fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-like fa-2x"
  })])
}]}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content-boxed",
    attrs: {
      "id": "page-container"
    }
  }, [_c('main', {
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    staticClass: "bg-grey"
  }, [_c('div', {
    staticClass: "hero-static content content-full bg-grey"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center px-5"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6"
  }, [_c('div', {
    staticClass: "block"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-12",
    attrs: {
      "for": "login-username"
    }
  }, [_vm._v("Gebruikersnaam")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "login-username",
      "placeholder": "Vul je gebruikersnaam in...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-12",
    attrs: {
      "for": "login-password"
    }
  }, [_vm._v("Wachtwoord")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "login-password",
      "placeholder": "Vul je wachtwoord in...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember),
      expression: "remember"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.remember) ? _vm._i(_vm.remember, null) > -1 : (_vm.remember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.remember = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.remember = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Ingelogd blijven\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-block btn-hero btn-noborder btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "si si-login mr-10"
  }), _vm._v("\n                        Log in\n                      ")])])])])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-30 px-5 text-center"
  }, [_c('a', {
    staticClass: "link-effect font-w700",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "si si-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-size-xl text-primary-dark"
  }, [_vm._v("VM")]), _c('span', {
    staticClass: "font-size-xl"
  }, [_vm._v("Control")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Inloggen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-content text-center"
  }, [_c('img', {
    staticClass: "img-avatar img-avatar96 img-avatar-thumb",
    attrs: {
      "src": "/static/img/avatar.jpg",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Productdetails"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(_vm.product.amount_sold_past_year > 25) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fa fa-info-circle mr-5"
  }), _vm._v(" Hardloper")])]) : _vm._e(), _vm._v(" "), (_vm.product === null) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Gegevens")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Naam")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.name))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("SKU")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.sku))])]), _vm._v(" "), (_vm.product.parent_sku) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("SKU Hoofdproduct")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.parent_sku))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("GTIN")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.gtin))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Prijs")]), _vm._v(" "), _c('td', [_c('price-editable', {
    key: _vm.product.id,
    attrs: {
      "price": _vm.product.price,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Sale prijs")]), _vm._v(" "), _c('td', [_c('sale-price-editable', {
    key: _vm.product.id,
    attrs: {
      "price": _vm.product.price,
      "sale_price": _vm.product.sale_price,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Inkoopprijs")]), _vm._v(" "), _c('td', [_c('purchase-price-editable', {
    key: _vm.product.id,
    attrs: {
      "purchase-price": _vm.product.purchase_price,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Locatie")]), _vm._v(" "), _c('td', [_c('location-editable', {
    key: _vm.product.id,
    attrs: {
      "field": "location",
      "value": _vm.product.location,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Locatie overvoorraad")]), _vm._v(" "), _c('td', [_c('field-editable', {
    key: _vm.product.id,
    attrs: {
      "field": "overstock_location",
      "value": _vm.product.overstock_location,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Ligt in de winkel")]), _vm._v(" "), _c('td', [_c('in-store-editable', {
    key: _vm.product.id,
    attrs: {
      "in-store": !!_vm.product.in_store,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Cadeaukoppeling")]), _vm._v(" "), _c('td', [_c('externally-available-editable', {
    key: _vm.product.id,
    attrs: {
      "externally-available": !!_vm.product.externally_available,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Voorraad")]), _vm._v(" "), _c('td', [_c('stock-editable', {
    key: _vm.product.id,
    attrs: {
      "quantity": _vm.product.stock_quantity,
      "product-id": _vm.product.id
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Maat")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.size))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Gemaakt op")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(_vm.product.created_at, 'calendar')))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Beschrijving")]), _vm._v(" "), _c('td', {
    staticClass: "reset-font-size",
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Afbeelding(en)")]), _vm._v(" "), _c('td', _vm._l((_vm.product.image_urls), function(imageUrl) {
    return _c('img', {
      key: imageUrl,
      staticClass: "img-thumbnail mr-10",
      attrs: {
        "width": "100",
        "src": imageUrl,
        "alt": ""
      }
    })
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Voorraadmutaties")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', [_vm._v("Mutatie")]), _vm._v(" "), _c('th', [_vm._v("Van")]), _vm._v(" "), _c('th', [_vm._v("Naar")]), _vm._v(" "), _c('th', [_vm._v("Oorzaak")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.product.stock_mutations), function(mutation) {
    return _c('tr', {
      key: mutation.id
    }, [_c('td', [_vm._v(_vm._s(_vm._f("moment")(mutation.created_at, 'DD-MM-YYYY HH:mm')))]), _vm._v(" "), _c('td', [((mutation.new_quantity - mutation.old_quantity) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(mutation.new_quantity - mutation.old_quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mutation.old_quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mutation.new_quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("origin")(mutation.origin)))])])
  }), 0)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger",
    on: {
      "click": _vm.removeProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-times mr-5"
  }), _vm._v("\n      Verwijder product\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.shipping_costs), function(shipping_cost) {
    return _c('tr', {
      key: shipping_cost.id
    }, [_c('td', [_c('a', [_vm._v(_vm._s(shipping_cost.country))])]), _vm._v(" "), _c('td', [_c('a', [_vm._v(_vm._s(shipping_cost.sales_channel))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.letterboxPackages[shipping_cost.id]),
        expression: "letterboxPackages[shipping_cost.id]"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.letterboxPackages[shipping_cost.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.letterboxPackages, shipping_cost.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateShippingCostField(shipping_cost.id, 'letterbox_package', shipping_cost.sales_channel)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.smallPackages[shipping_cost.id]),
        expression: "smallPackages[shipping_cost.id]"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.smallPackages[shipping_cost.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.smallPackages, shipping_cost.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateShippingCostField(shipping_cost.id, 'small_package', shipping_cost.sales_channel)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.parcelPosts[shipping_cost.id]),
        expression: "parcelPosts[shipping_cost.id]"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.parcelPosts[shipping_cost.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.parcelPosts, shipping_cost.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateShippingCostField(shipping_cost.id, 'parcel_post', shipping_cost.sales_channel)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Verzendkosten inkoopprijs (excl. btw)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Land")]), _vm._v(" "), _c('th', [_vm._v("Verkoopkanaal")]), _vm._v(" "), _c('th', [_vm._v("Brievenbuspakket")]), _vm._v(" "), _c('th', [_vm._v("Kleinpakket")]), _vm._v(" "), _c('th', [_vm._v("Pakketpost")])])])
}]}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.brand_delivery_times), function(brand_delivery_time) {
    return _c('tr', {
      key: brand_delivery_time.id
    }, [_c('td', [_c('a', [_vm._v(_vm._s(brand_delivery_time.brand))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_times[brand_delivery_time.id]),
        expression: "delivery_times[brand_delivery_time.id]"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.delivery_times[brand_delivery_time.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.delivery_times, brand_delivery_time.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateBrandDeliveryTimeField(brand_delivery_time.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Merk levertijd")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Merk")]), _vm._v(" "), _c('th', [_vm._v("Levertijd (in weken)")])])])
}]}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "centered": "",
      "visible": "",
      "size": "lg",
      "content-class": "dropshipment-products-modal",
      "hide-footer": true,
      "title": "Product overzicht"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', [_c('api-table-block', {
    ref: "productsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllProducts,
      "default-sort-by": "created_at",
      "item-label-singular": "product",
      "item-label-plural": "producten"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.details(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "price",
      fn: function(data) {
        return [(data.item.sale_price) ? _c('sale-price-editable', {
          key: data.item.id,
          attrs: {
            "price": data.item.price,
            "sale_price": data.item.sale_price,
            "product-id": data.item.id
          }
        }) : _c('price-editable', {
          key: data.item.id,
          attrs: {
            "price": data.item.price,
            "product-id": data.item.id
          }
        })]
      }
    }, {
      key: "stock_quantity",
      fn: function(data) {
        return [_c('stock-editable', {
          key: data.item.id,
          attrs: {
            "quantity": data.value,
            "product-id": data.item.id
          }
        })]
      }
    }, {
      key: "location",
      fn: function(data) {
        return [_c('div', [_c('location-editable', {
          key: data.item.id,
          attrs: {
            "field": "location",
            "value": data.item.location,
            "product-id": data.item.id
          }
        })], 1), _vm._v(" "), _c('div', [_c('small', [_vm._v("\n               Rest:\n               "), _c('field-editable', {
          key: data.item.id,
          attrs: {
            "field": "overstock_location",
            "value": data.item.overstock_location,
            "product-id": data.item.id
          }
        })], 1)])]
      }
    }])
  }), _vm._v(" "), (_vm.detailModalProductId) ? _c('product-detail-modal', {
    key: _vm.detailModalProductId,
    attrs: {
      "product-id": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.detailModalProductId = null
      },
      "remove": _vm.refresh
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.sales_channel_commissions), function(sales_channel_commission) {
    return _c('tr', {
      key: sales_channel_commission.id
    }, [_c('td', [_c('a', [_vm._v(_vm._s(sales_channel_commission.sales_channel_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.commission_percentages[sales_channel_commission.id]),
        expression: "commission_percentages[sales_channel_commission.id]"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.commission_percentages[sales_channel_commission.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.commission_percentages, sales_channel_commission.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateSalesChannelCommissionField(sales_channel_commission.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Commissies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Verkoopkanaal")]), _vm._v(" "), _c('th', [_vm._v("Commisiepercentage")])])])
}]}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-basket mr-5"
  }), _vm._v(" Inkooporder\n    "), _c('button', {
    staticClass: "btn btn-sm btn-success btn-noborder float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createOrderListModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-5"
  }), _vm._v("Nieuwe Inkooporder\n    ")])]), _vm._v(" "), _c('api-table-block', {
    ref: "orderListsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllOrders,
      "default-sort-by": "created_at",
      "item-label-singular": "bestelling",
      "item-label-plural": "bestellingen"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.openDetailModal(data.item.id)
            }
          }
        }, [_vm._v("#" + _vm._s(data.value))])]
      }
    }, {
      key: "supplier",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value) + " \n    ")]
      }
    }, {
      key: "created_at",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("capitalize")(_vm._f("moment")(data.value, 'calendar'))) + "\n    ")]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('order-list-status-badge', {
          ref: "orderListStatusBadge",
          attrs: {
            "orderList": data.item
          }
        })]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [_c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group"
          }
        }, [_c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.openDetailModal(data.item)
            }
          }
        }, [_vm._v("Details")]), _vm._v(" "), (data.item.status === 'delivered' || data.item.status === 'ordered') ? _c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.openCheckOrderListModal(data.item.id)
            }
          }
        }, [_vm._v("Controleren")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), (_vm.detailModalOrderListId) ? _c('order-list-detail-modal', {
    key: _vm.detailModalOrderListId,
    attrs: {
      "orderListId": _vm.detailModalOrderListId
    },
    on: {
      "close": function($event) {
        _vm.detailModalOrderListId = null, _vm.refresh()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkOrderListModalId) ? _c('check-order-list-modal', {
    attrs: {
      "orderListId": _vm.checkOrderListModalId
    },
    on: {
      "close": function($event) {
        _vm.checkOrderListModalId = null, _vm.refresh()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderedOrderModalListId) ? _c('ordered-order-list-modal', {
    key: _vm.orderedOrderModalListId,
    attrs: {
      "orderListId": _vm.orderedOrderModalListId,
      "status": _vm.currentStatus
    },
    on: {
      "close": function($event) {
        _vm.orderedOrderModalListId = null, _vm.currentStatus = null, _vm.refresh()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCreateOrderListModal) ? _c('create-order-list-modal', {
    attrs: {
      "productIds": [],
      "fromScratch": true
    },
    on: {
      "close": function($event) {
        _vm.showCreateOrderListModal = null, _vm.refresh()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('select-barcode-scanner-widget')], 1)
},staticRenderFns: []}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Nieuwe gebruiker aanmaken"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('b-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "input-group-1",
      "label": "Gebruikersnaam",
      "label-for": "input-1"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-1",
      "placeholder": "Vul gebruikersnaam in",
      "required": ""
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "id": "input-group-2",
      "label": "Wachtwoord",
      "label-for": "input-2"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-2",
      "type": "password",
      "placeholder": "Vul een wachtwoord in",
      "required": ""
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Submit")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "block block-link-shadow block-rounded block-bordered",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "py-5 text-center"
  }, [_c('div', {
    staticClass: "mb-15"
  }, [_c('i', {
    class: [("fa fa-" + _vm.icon + " fa-3x text-muted")]
  })]), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm font-w600 text-uppercase text-muted"
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isEdditing) ? _c('span', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cancel),
      expression: "cancel"
    }]
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newQuantity),
      expression: "newQuantity"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newQuantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newQuantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-check"
  })])])])])]) : _c('span', {
    on: {
      "click": _vm.edit
    }
  }, [(_vm.currentQuantity || _vm.currentQuantity === 0) ? _c('span', {
    staticClass: "editable text-primary"
  }, [_vm._v(_vm._s(_vm.currentQuantity))]) : _c('span', {
    staticClass: "editable text-danger"
  }, [_c('i', [_vm._v("n.n.b.")])])]), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Productdetails"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default",
    staticStyle: {
      "display": "block"
    }
  }, [_c('h6', [_vm._v("Voer onderstaande gegevens in om het product in te boeken of sluit dit scherm")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Barcode"
    }
  }, [_vm._v("Barcode:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barcode),
      expression: "barcode"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "Barcode"
    },
    domProps: {
      "value": (_vm.barcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.barcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Location"
    }
  }, [_vm._v("Locatie:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productLocation),
      expression: "productLocation"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "Location",
      "placeholder": "A.01.01.01.01"
    },
    domProps: {
      "value": (_vm.productLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productLocation = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "ProductTitle"
    }
  }, [_vm._v("ProductTitel:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productTitle),
      expression: "productTitle"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "ProductTitle",
      "placeholder": "Washandje rood"
    },
    domProps: {
      "value": (_vm.productTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productTitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Quantity"
    }
  }, [_vm._v("Aantal:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productQuantity),
      expression: "productQuantity"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "id": "Quantity",
      "placeholder": "6"
    },
    domProps: {
      "value": (_vm.productQuantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productQuantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Brand"
    }
  }, [_vm._v("Bestaande Merk:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.brands,
      "placeholder": "Selecteer een leverancier",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔",
      "allow-input": ""
    },
    model: {
      value: (_vm.productBrand),
      callback: function($$v) {
        _vm.productBrand = $$v
      },
      expression: "productBrand"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "newBrand"
    }
  }, [_vm._v("Nieuwe merk:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand),
      expression: "newBrand"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "newBrand",
      "placeholder": "Coca cola"
    },
    domProps: {
      "value": (_vm.newBrand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newBrand = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.createProduct
    }
  }, [_vm._v("Opslaan")])])])])])
},staticRenderFns: []}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-content"
  }, [_c('ul', {
    staticClass: "list list-activity"
  }, [(_vm.order.return_shipment) ? _c('li', [_c('i', {
    staticClass: "si si-action-undo text-danger"
  }), _vm._v(" "), _c('div', {
    staticClass: "font-w600"
  }, [_vm._v("Retourzending aangemaakt")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.order.return_shipment.track_and_trace_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v("\n          " + _vm._s(_vm.order.return_shipment.barcode) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "font-size-xs text-muted"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("moment")(_vm.order.return_shipment.created_at, 'calendar'))))])]) : _vm._e(), _vm._v(" "), (_vm.order.status === 'completed') ? _c('li', [_c('i', {
    staticClass: "si si-check text-success"
  }), _vm._v(" "), _c('div', {
    staticClass: "font-w600"
  }, [_vm._v("Bestelling afgerond")]), _vm._v(" "), _c('div', {
    staticClass: "font-size-xs text-muted"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("moment")(_vm.completedAt, 'calendar'))))]), _vm._v(" "), (_vm.order.weshipp_id) ? _c('div', [(!_vm.solTrackAndTraceUrl) ? _c('button', {
    staticClass: "btn btn-alt-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.getSolTrackAndTraceUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }, [_vm._v(" SOL Track & trace ophalen ")]), _vm._v(" "), (_vm.loading) ? _c('i', {
    staticClass: "fa fa-spin fa-8x fa-spinner"
  }) : _vm._e()]) : _c('a', {
    attrs: {
      "href": _vm.solTrackAndTraceUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v("\n          SOL Track & trace\n        ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.order.shipment) ? _c('li', [_c('i', {
    staticClass: "si si-paper-plane text-warning"
  }), _vm._v(" "), _c('div', {
    staticClass: "font-w600"
  }, [_vm._v("Verzending aangemaakt")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.printLabel($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.order.shipment.track_and_trace_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v("\n          " + _vm._s(_vm.order.shipment.barcode) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "font-size-xs text-muted"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("moment")(_vm.order.shipment.created_at, 'calendar'))))])]) : _vm._e(), _vm._v(" "), (_vm.pickedAt) ? _c('li', [_c('i', {
    staticClass: "si si-directions text-info"
  }), _vm._v(" "), _c('div', {
    staticClass: "font-w600"
  }, [_vm._v("Producten gepickt")]), _vm._v(" "), _c('div', {
    staticClass: "font-size-xs text-muted"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("moment")(_vm.pickedAt, 'calendar'))))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "si si-basket text-danger"
  }), _vm._v(" "), _c('div', {
    staticClass: "font-w600"
  }, [_vm._v("Bestelling geplaatst")]), _vm._v(" "), _c('div', {
    staticClass: "font-size-xs text-muted"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("moment")(_vm.order.placed_at, 'calendar'))))])])])])
},staticRenderFns: []}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "width": "600px",
      "display": "flex",
      "margin-bottom": "10px"
    }
  }, [_c('multiselect', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "options": _vm.brands,
      "multiple": "true",
      "placeholder": "Selecteer een merk",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    on: {
      "input": function($event) {
        _vm.refresh()
      }
    },
    model: {
      value: (_vm.selectedBrand),
      callback: function($$v) {
        _vm.selectedBrand = $$v
      },
      expression: "selectedBrand"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "options": _vm.marketplaces,
      "multiple": "true",
      "placeholder": "Selecteer een marktplaats",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    on: {
      "input": function($event) {
        _vm.refresh()
      }
    },
    model: {
      value: (_vm.selectedMarketplace),
      callback: function($$v) {
        _vm.selectedMarketplace = $$v
      },
      expression: "selectedMarketplace"
    }
  })], 1)]), _vm._v(" "), _c('api-table-block', {
    ref: "productsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllProducts,
      "default-sort-by": "profit_margin",
      "item-label-singular": "product",
      "item-label-plural": "producten"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.details(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "marketplace",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value) + "\n    ")]
      }
    }, {
      key: "purchase_price",
      fn: function(data) {
        return [(_vm.showPricesInclVat) ? _c('span', [_vm._v(_vm._s(Math.round((data.value * 1.21) * 100) / 100))]) : _c('span', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "price",
      fn: function(data) {
        return [(_vm.showPricesExclVat) ? _c('span', [_vm._v(_vm._s(Math.round((data.value / 1.21) * 100) / 100))]) : _c('span', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "profit_margin",
      fn: function(data) {
        return [(data.value >= 30) ? _c('b', {
          staticClass: "text-success"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e(), _vm._v(" "), (data.value < 30 && data.value >= 0) ? _c('b', {
          staticClass: "text-warning"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e(), _vm._v(" "), (data.value < 0) ? _c('b', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "before-block-content"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showPricesInclVat),
      expression: "showPricesInclVat"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showPricesInclVat) ? _vm._i(_vm.showPricesInclVat, null) > -1 : (_vm.showPricesInclVat)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showPricesInclVat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showPricesInclVat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showPricesInclVat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showPricesInclVat = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Incl btw\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showPricesExclVat),
      expression: "showPricesExclVat"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showPricesExclVat) ? _vm._i(_vm.showPricesExclVat, null) > -1 : (_vm.showPricesExclVat)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showPricesExclVat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showPricesExclVat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showPricesExclVat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showPricesExclVat = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Excl btw\n          ")])])])])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.refund !== null && _vm.order !== null) ? _c('span', [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\r\n          Retour #" + _vm._s(_vm.refund.id) + "\r\n          "), _c('refund-status-badge', {
    attrs: {
      "refund": _vm.refund
    }
  })], 1)]), _vm._v(" "), _c('order-timeline', {
    attrs: {
      "order": _vm.order
    }
  })], 1), _vm._v(" "), _c('order-address', {
    attrs: {
      "order": _vm.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.orderLines), function(line) {
    return _c('tr', {
      key: line.id
    }, [(line.product) ? _c('td', [_c('a', {
      staticClass: "font-w600",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(line.product.gtin))])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.product.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.quantity) + " X " + _vm._s(line.product_price))]), _vm._v(" "), _c('td', [(_vm.refund.status !== 'completed') ? _c('div', {
      staticClass: "row"
    }, [_c('input', {
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "id": line.id,
        "type": "number",
        "value": "0",
        "min": "0",
        "max": line.quantity
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateAmountOfProductRefunded(line)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])]) : _c('div', [_vm._v(" " + _vm._s(_vm.amountRefundedValue(line.product.id)) + " ")])]), _vm._v(" "), _c('td', [(_vm.refund.status !== 'completed') ? _c('div', {
      staticClass: "row"
    }, [_c('input', {
      ref: "quantityInput",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "id": line.id,
        "type": "number",
        "max": line.quantity
      }
    })]) : _c('div', [_vm._v(" " + _vm._s(_vm.stockIncreaseValue(line.product.id)) + " ")])]), _vm._v(" "), _c('td', [(_vm.refund.status !== 'completed' && !_vm.isFromMarketPlace) ? _c('div', {
      staticClass: "row"
    }, [_c('input', {
      ref: "priceInput",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "id": line.id,
        "type": "number"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateProductPrice(line)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])]) : _c('div', [_vm._v(" " + _vm._s(_vm.discountValue(line.product.id)) + "% ")])])])
  }), 0)])])]), _vm._v(" "), (_vm.refund.status !== 'completed' && !_vm.isFromMarketPlace) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', [_c('label', {
    staticClass: "css-control css-control-primary css-checkbox",
    attrs: {
      "for": "orderStatus"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatus),
      expression: "orderStatus"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "id": "orderStatus",
      "name": "orderStatus",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.orderStatus) ? _vm._i(_vm.orderStatus, "true") > -1 : (_vm.orderStatus)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.orderStatus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.orderStatus = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.orderStatus = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.orderStatus = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Bestelling status op compleet zetten?\r\n            ")])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "css-control css-control-primary css-checkbox",
    attrs: {
      "for": "refundMail"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendRefundConformationMail),
      expression: "sendRefundConformationMail"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "id": "refundMail",
      "name": "refundMail",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendRefundConformationMail) ? _vm._i(_vm.sendRefundConformationMail, "true") > -1 : (_vm.sendRefundConformationMail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendRefundConformationMail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendRefundConformationMail = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendRefundConformationMail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendRefundConformationMail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Retour bevestiging mail sturen?\r\n            ")])]), _vm._v(" "), _c('div', [(_vm.includeRefundShipmentCosts) ? _c('label', {
    staticClass: "css-control css-control-primary css-checkbox",
    attrs: {
      "for": "calculateRefundShipmentCosts"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculateRefundShipmentCosts),
      expression: "calculateRefundShipmentCosts"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "id": "calculateRefundShipmentCosts",
      "name": "calculateRefundShipmentCosts",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.calculateRefundShipmentCosts) ? _vm._i(_vm.calculateRefundShipmentCosts, "true") > -1 : (_vm.calculateRefundShipmentCosts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.calculateRefundShipmentCosts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.calculateRefundShipmentCosts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.calculateRefundShipmentCosts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.calculateRefundShipmentCosts = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Retour Kosten: " + _vm._s(_vm.refundShippingCost) + ",-\r\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.includeRefundShipmentCosts) ? _c('label', {
    staticClass: "css-control css-control-primary css-checkbox",
    attrs: {
      "for": "orderShipmentCosts"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeOrderShipmentCosts),
      expression: "includeOrderShipmentCosts"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "id": "orderShipmentCosts",
      "name": "orderShipmentCosts",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeOrderShipmentCosts) ? _vm._i(_vm.includeOrderShipmentCosts, "true") > -1 : (_vm.includeOrderShipmentCosts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeOrderShipmentCosts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeOrderShipmentCosts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeOrderShipmentCosts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeOrderShipmentCosts = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Verzend Kosten: " + _vm._s(_vm.orderShippingCost) + "\r\n          ")]) : _vm._e(), _vm._v(" "), (_vm.includeOrderShipmentCosts) ? _c('p', [_c('span', [_vm._v("Verzend kosten ")]), _vm._v(" "), _c('exclude-toggle', {
    model: {
      value: (_vm.incrementOrderShimentCosts),
      callback: function($$v) {
        _vm.incrementOrderShimentCosts = $$v
      },
      expression: "incrementOrderShimentCosts"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" totaal bedrag")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "retourInput"
    }
  }, [_vm._v("Vul handmatig een (extra) retourbedrag in")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.manualRefundPrice),
      expression: "manualRefundPrice",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "0",
      "name": "retourInput"
    },
    domProps: {
      "value": (_vm.manualRefundPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.manualRefundPrice = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.refund != null) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bg-light rounded d-flex flex-column"
  }, [_c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Geretourneerde producten prijs: ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("+ " + _vm._s(Math.round((_vm.totalRefundPrice) * 100) / 100))])]), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Handmatig (extra) retourbedrag")]), _vm._v(" "), (Math.sign(_vm.manualRefundPrice) === 1) ? _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("+ " + _vm._s(_vm.manualRefundPrice))]) : _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v(_vm._s(_vm.manualRefundPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Verzendkosten")]), _vm._v(" "), (_vm.incrementOrderShimentCosts) ? _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("+ " + _vm._s(_vm.orderShippingCost))]) : _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("- " + _vm._s(_vm.orderShippingCost))])]), _vm._v(" "), (_vm.includeRefundShipmentCosts && _vm.calculateRefundShipmentCosts) ? _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Retour Kosten")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("- " + _vm._s(_vm.refundShippingCost))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "border-top px-4 mx-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex pt-3"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("€ " + _vm._s(_vm.calculateTotalRefundCost))])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.refund.status !== 'completed') ? _c('div', {
    staticClass: "p-2 d-flex pt-3"
  }, [_c('button', {
    staticClass: "btn btn-hero btn-alt-success",
    staticStyle: {
      "margin-right": "0px"
    },
    on: {
      "click": _vm.updateRefundPrice
    }
  }, [_vm._v("Retour verwerken")])]) : _vm._e(), _vm._v(" "), (_vm.refund.status === 'completed' && !_vm.isFromMarketPlace) ? _c('div', {
    staticClass: "p-2 d-flex pt-3"
  }, [_c('div', {
    staticClass: "border-top px-4 mx-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("Totaal terug geboekt bedrag: € " + _vm._s(_vm.refund.refund_cost))])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Producten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("EAN")]), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), _c('th', [_vm._v("Aantal geleverd")]), _vm._v(" "), _c('th', [_vm._v("Aantal geretourneerd")]), _vm._v(" "), _c('th', [_vm._v("Voorraad toename")]), _vm._v(" "), _c('th', [_vm._v("Korting (in procenten)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Afrekenen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-8"
  }, [_c('b', [_vm._v("Totaal")])])
}]}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Bestellijst"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(_vm.orderList === null) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n           Bestellijst: " + _vm._s(_vm.orderList.name) + "\n           "), _c('order-list-status-badge', {
    ref: "orderListStatus",
    staticClass: "ml-2",
    attrs: {
      "orderList": _vm.orderList
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n           Producten toevoegen\n         ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content p-0 row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productName),
      expression: "productName"
    }],
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "list": "products",
      "placeholder": "Vul een product naam in"
    },
    domProps: {
      "value": (_vm.productName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.productName = $event.target.value
      }, _vm.getProducts]
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "products"
    }
  }, _vm._l((_vm.products), function(item) {
    return _c('option', {
      key: item.id
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.addProductToOrderList
    }
  }, [_vm._v("\n           Toevoegen aan bestellijst"), _c('i', {
    staticClass: "fa fa-check"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Producten")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toPredictSalesDate),
      expression: "toPredictSalesDate"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Periode van"
    },
    domProps: {
      "value": (_vm.toPredictSalesDate)
    },
    on: {
      "change": _vm.predictSalesForAllProducts,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toPredictSalesDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    ref: "table",
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Product")]), _vm._v(" "), _c('th', [_vm._v("Uitverkocht")]), _vm._v(" "), _c('th', [_vm._v("Voorspelde aantal")]), _vm._v(" "), _c('th', [_vm._v("Te bestellen aantal")]), _vm._v(" "), _c('th', [_vm._v("Acties")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderList.lines), function(line) {
    return _c('tr', {
      key: line.id
    }, [_c('td', [_vm._v(_vm._s(line.product.name))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "date",
        "placeholder": "Periode van"
      },
      on: {
        "change": function($event) {
          _vm.predictSalesPerProduct($event, line.product)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center font-w600"
    }, [_vm._v(" " + _vm._s(_vm.predictedProductSales[line.product.sku]) + " ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.toOrderAmountProducts[line.product.sku]),
        expression: "toOrderAmountProducts[line.product.sku]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.toOrderAmountProducts[line.product.sku])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.toOrderAmountProducts, line.product.sku, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.deleteOrderListLine(line)
        }
      }
    }, [_vm._v("\n                   Verwijderen\n                 ")])])])
  }), 0)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.updateOrderListLines(_vm.orderList.id)
      }
    }
  }, [_vm._v("\n         Bestellen "), _c('i', {
    staticClass: "fa fa-check"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "opacity-0",
    attrs: {
      "id": "page-footer"
    }
  }, [_c('div', {
    staticClass: "content py-20 font-size-xs clearfix"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_vm._v("\n      Crafted with\n      "), _c('i', {
    staticClass: "fa fa-heart text-pulse"
  }), _vm._v(" by\n      "), _c('a', {
    staticClass: "font-w600",
    attrs: {
      "href": "http://fresh-media.nl",
      "target": "_blank"
    }
  }, [_vm._v("Fresh-Media")])]), _vm._v(" "), _c('div', {
    staticClass: "float-left"
  }, [_c('span', {
    staticClass: "font-w600"
  }, [_vm._v("VMControl")]), _vm._v(" ©\n      "), _c('span', {
    staticClass: "js-year-copy"
  })])])])
}]}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b-dropdown', {
    attrs: {
      "size": "sm",
      "variant": _vm.currentStatus.color,
      "disabled": _vm.saving
    }
  }, [_c('template', {
    slot: "button-content"
  }, [(_vm.saving) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin mr-1"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.currentStatus.label) + "\n    ")]), _vm._v(" "), _vm._l((_vm.selectableStatuses), function(status) {
    return _c('b-dropdown-item', {
      key: status.id,
      class: ("bg-" + (status.color)),
      staticStyle: {
        "color": "#fff !important"
      },
      on: {
        "click": function($event) {
          _vm.updateStatus(status.id)
        }
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2), _vm._v(" "), _c('text-alert', {
    staticClass: "ml-1",
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "manualRefundmodal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Manual Refund"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n        Manual Retour\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content p-0 row"
  }, [_c('label', {
    staticStyle: {
      "margin": "right 50px"
    }
  }, [_vm._v("Voer een order nummer in: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OrderNumber),
      expression: "OrderNumber"
    }],
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "list": "orders",
      "placeholder": "Bijvoorbeeld: NL-123456"
    },
    domProps: {
      "value": (_vm.OrderNumber)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.OrderNumber = $event.target.value
      }, _vm.getOrders]
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "orders"
    }
  }, _vm._l((_vm.orders), function(item) {
    return _c('option', {
      key: item.id
    }, [_vm._v(_vm._s(item.number))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.loadOrder
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])])])]), _vm._v(" "), (_vm.order !== null && _vm.refund !== null) ? _c('refund-form', {
    attrs: {
      "order-id": _vm.order.id,
      "refundId": _vm.refund.id,
      "includeRefundShipmentCosts": false
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-cup mr-5"
  }), _vm._v(" Welkom " + _vm._s(_vm.user.username) + "!\n  ")]), _vm._v(" "), (_vm.user.role === 'admin') ? _c('admin-dashboard') : _vm._e(), _vm._v(" "), (_vm.user.role === 'orderpicker') ? _c('order-picker-dashboard') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isEdditing) ? _c('span', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cancel),
      expression: "cancel"
    }]
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPrice),
      expression: "newPrice"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number",
      "step": "any",
      "min": "0"
    },
    domProps: {
      "value": (_vm.newPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPrice = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-check"
  })])])])])]) : _c('span', {
    on: {
      "click": _vm.edit
    }
  }, [(_vm.currentPrice) ? _c('span', {
    staticClass: "editable text-primary"
  }, [_vm._v("€ " + _vm._s(_vm.currentPrice))]) : _c('span', {
    staticClass: "editable text-danger"
  }, [_c('i', [_vm._v("n.n.b.")])])]), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Postzegel post"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Weeg de bestelling en selecteer het gewicht van de bestelling "), _c('br'), _vm._v(" LET OP: Klikken is betalen! ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row gutters-tiny"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('postage-stamp-type', {
    attrs: {
      "icon": "envelope"
    },
    on: {
      "click": function($event) {
        _vm.createShipment(null)
      }
    }
  }, [_vm._v("\n                Ongefrankeerd\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('postage-stamp-type', {
    attrs: {
      "icon": "envelope"
    },
    on: {
      "click": function($event) {
        _vm.createShipment(10)
      }
    }
  }, [_vm._v("\n                0-20 gram\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('postage-stamp-type', {
    attrs: {
      "icon": "envelope"
    },
    on: {
      "click": function($event) {
        _vm.createShipment(40)
      }
    }
  }, [_vm._v("\n                20-50 gram\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('postage-stamp-type', {
    attrs: {
      "icon": "envelope"
    },
    on: {
      "click": function($event) {
        _vm.createShipment(75)
      }
    }
  }, [_vm._v("\n                50-100 gram\n              ")])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('api-table-block', {
    ref: "productsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllProducts,
      "default-sort-by": "created_at",
      "item-label-singular": "product",
      "item-label-plural": "producten"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.details(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "location",
      fn: function(data) {
        return [_c('div', [_c('location-editable', {
          key: data.item.id,
          attrs: {
            "field": "location",
            "value": data.item.location,
            "product-id": data.item.id
          }
        })], 1), _vm._v(" "), _c('div', [_c('small', [_vm._v("\n          Rest:\n          "), _c('field-editable', {
          key: data.item.id,
          attrs: {
            "field": "overstock_location",
            "value": data.item.overstock_location,
            "product-id": data.item.id
          }
        })], 1)])]
      }
    }, {
      key: "in_store",
      fn: function(data) {
        return [_c('in-store-editable', {
          key: data.item.id,
          attrs: {
            "in-store": !!data.value,
            "product-id": data.item.id
          }
        })]
      }
    }, {
      key: "stock_quantity",
      fn: function(data) {
        return [_c('stock-editable', {
          key: data.item.id,
          attrs: {
            "quantity": data.value,
            "product-id": data.item.id
          }
        })]
      }
    }])
  }), _vm._v(" "), (_vm.detailModalProductId) ? _c('product-detail-modal', {
    key: _vm.detailModalProductId,
    attrs: {
      "product-id": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.detailModalProductId = null
      },
      "remove": _vm.refresh
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-tag mr-5"
  }), _vm._v(" Producten\n  ")])
}]}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span')
},staticRenderFns: []}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.isEdditing) ? _c('span', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cancel),
      expression: "cancel"
    }]
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    ref: "input",
    staticClass: "form-control",
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-check"
  })])])])])]) : _c('span', {
    on: {
      "click": _vm.edit
    }
  }, [(_vm.currentValue) ? _c('span', {
    staticClass: "editable text-primary"
  }, [_vm._v(_vm._s(_vm.currentValue))]) : _c('span', {
    staticClass: "editable text-danger"
  }, [_c('i', [_vm._v("n.n.b.")])])]), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success float-right",
    attrs: {
      "disabled": _vm.printing
    },
    on: {
      "click": _vm.printInvoices
    }
  }, [(_vm.printing) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner mr-5"
  }) : _c('i', {
    staticClass: "fa fa-print mr-5"
  }), _vm._v("\n      Print pakbonnen\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-secondary mr-2 float-right",
    attrs: {
      "href": _vm.invoicesPdfUrl,
      "target": "_blank",
      "disabled": _vm.printing
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o text-danger mr-5"
  }), _vm._v(" Download pakbonnen\n    ")]), _vm._v(" "), _c('i', {
    staticClass: "si si-directions mr-5"
  }), _vm._v(" Bestellingen Picken\n  ")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v("  Bestellingen laden...\n  ")]) : _c('div', [(!_vm.singleBin) ? _c('div', {
    staticClass: "row gutters-tiny"
  }, _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order.id,
      staticClass: "col-md-6 col-xl-2"
    }, [_c('div', {
      staticClass: "block text-center bin",
      on: {
        "click": function($event) {
          _vm.detailModalOrderId = order.id
        }
      }
    }, [_c('div', {
      staticClass: "bin__key"
    }, [_vm._v(_vm._s(order.bin.key))]), _vm._v(" "), _c('div', {
      staticClass: "block-content block-content-full text-right",
      style: ({
        'background-color': '#' + order.bin.color
      })
    }, [_c('div', {
      staticClass: "font-w600 text-white mb-5"
    }, [_vm._v("#" + _vm._s(order.number))]), _vm._v(" "), _c('div', {
      staticClass: "text-white-op text-one-line",
      attrs: {
        "title": order.billing_person
      }
    }, [_vm._v(_vm._s(order.billing_person))])])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block mt-20"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_c('strong', [_vm._v(_vm._s(this.currentProductIndex + 1))]), _vm._v(" van "), _c('strong', [_vm._v(_vm._s(_vm.products.length))]), _vm._v(" producten\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-options"
  }, [_c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.previous
    }
  }, [_c('i', {
    staticClass: "si si-arrow-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_c('i', {
    staticClass: "si si-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('swiper', {
    ref: "imageSwiper",
    staticStyle: {
      "height": "450px"
    }
  }, _vm._l((_vm.currentProduct.image_urls), function(image) {
    return _c('swiper-slide', {
      key: image
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": image
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('h1', {
    staticClass: "font-w700",
    on: {
      "click": function($event) {
        _vm.detailModalProductId = _vm.currentProduct.id
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.currentProduct.name) + "\n              "), _vm._m(0)]), _vm._v(" "), _c('h2', {
    staticClass: "mb-3"
  }, [(_vm.currentProduct.location) ? _c('mark', {
    staticClass: "pl-10 pr-10"
  }, [_vm._v(_vm._s(_vm.currentProduct.location))]) : _c('mark', {
    staticClass: "pl-10 pr-10 text-muted"
  }, [_vm._v("Locatie onbekend")]), _vm._v(" "), (_vm.currentProduct.shares_location) ? _c('span', {
    staticClass: "stock-warning text-danger"
  }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" er liggen meedere producten op deze locatie!\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.currentProduct.overstock_location) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Overvoorraad: " + _vm._s(_vm.currentProduct.overstock_location))]) : _vm._e(), _vm._v(" "), (_vm.currentProduct.in_store) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Ligt in de winkel")]) : _vm._e()]), _vm._v(" "), _c('h4', {
    staticClass: "mt-50"
  }, [_vm._v("Aantal: " + _vm._s(_vm.totalQuantity))]), _vm._v(" "), (_vm.singleBin) ? _c('div', {
    staticClass: "block text-center",
    staticStyle: {
      "background-color": "#e82b18",
      "width": "100px"
    }
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('p', {
    staticClass: "font-size-h1 text-white"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalQuantity) + "x")])])])]) : _c('div', {
    staticClass: "row gutters-tiny"
  }, _vm._l((_vm.currentProduct.quantities), function(quantity, orderNumber) {
    return _c('div', {
      key: orderNumber,
      staticClass: "col-6 col-md-4 col-xl-2"
    }, [_c('div', {
      staticClass: "block text-center",
      style: ({
        'background-color': '#' + _vm.findOrderByNumber(orderNumber).bin.color
      })
    }, [_c('div', {
      staticClass: "block-content bg-black-op-5"
    }, [_c('p', {
      staticClass: "font-w600 text-white-op"
    }, [_vm._v("#" + _vm._s(orderNumber))])]), _vm._v(" "), _c('div', {
      staticClass: "block-content"
    }, [_c('p', {
      staticClass: "font-size-h1 text-white"
    }, [_c('strong', [_vm._v(_vm._s(quantity) + "x")])])])])])
  }), 0)])])])]), _vm._v(" "), _c('nav', {
    staticClass: "clearfix push"
  }, [(!_vm.isFirstProduct) ? _c('button', {
    staticClass: "btn btn-alt-secondary min-width-100 float-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.previous
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Vorige")]) : _vm._e(), _vm._v(" "), (_vm.isLastProduct) ? _c('button', {
    staticClass: "btn btn-success btn-noborder min-width-100 float-right btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.finish
    }
  }, [_c('i', {
    staticClass: "fa fa-check fa-fw"
  }), _vm._v(" Afronden")]) : _c('button', {
    staticClass: "btn btn-alt-secondary min-width-100 float-right btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Volgende "), _c('i', {
    staticClass: "fa fa-arrow-right fa-fw"
  })])]), _vm._v(" "), (_vm.detailModalProductId) ? _c('product-detail-modal', {
    key: _vm.detailModalProductId,
    attrs: {
      "product-id": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.detailModalProductId = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.detailModalOrderId) ? _c('order-detail-modal', {
    key: _vm.detailModalOrderId,
    attrs: {
      "order-id": _vm.detailModalOrderId
    },
    on: {
      "close": function($event) {
        _vm.detailModalOrderId = null
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "product-info-button"
  }, [_c('i', {
    staticClass: "si si-info"
  })])
}]}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row gutters-tiny"
  }, [_c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "orders",
      "label": "Bestellingen",
      "icon": "basket"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "refunds",
      "label": "Retouren",
      "icon": "control-rewind",
      "icon-class": "text-danger"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "products",
      "label": "Producten",
      "icon": "tag",
      "icon-class": "text-Pulse"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "users",
      "label": "Gebruikers",
      "icon": "people",
      "icon-class": "text-corporate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "sales-channels",
      "label": "Verkoopkanalen",
      "icon": "share",
      "icon-class": "text-success"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "settings",
      "label": "Instellingen",
      "icon": "wrench",
      "icon-class": "text-elegance"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Productdetails"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default",
    staticStyle: {
      "display": "block"
    }
  }, [_c('h6', [_vm._v("Voer onderstaande gegevens in om het product in te boeken of sluit dit scherm")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Barcode"
    }
  }, [_vm._v("Barcode:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.gtin),
      expression: "product.gtin"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "Barcode"
    },
    domProps: {
      "value": (_vm.product.gtin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "gtin", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Location"
    }
  }, [_vm._v("Locatie:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.location),
      expression: "product.location"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "Location"
    },
    domProps: {
      "value": (_vm.product.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "location", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "ProductTitle"
    }
  }, [_vm._v("Naam:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.name),
      expression: "product.name"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "ProductTitle"
    },
    domProps: {
      "value": (_vm.product.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Quantity"
    }
  }, [_vm._v("Aantal:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.stock_quantity),
      expression: "product.stock_quantity"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "id": "Quantity"
    },
    domProps: {
      "value": (_vm.product.stock_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "stock_quantity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Brand"
    }
  }, [_vm._v("Merk:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.brands,
      "placeholder": "Selecteer een leverancier",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔",
      "allow-input": ""
    },
    model: {
      value: (_vm.product.brand),
      callback: function($$v) {
        _vm.$set(_vm.product, "brand", $$v)
      },
      expression: "product.brand"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Price"
    }
  }, [_vm._v("Prijs:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.price),
      expression: "product.price"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "id": "Price"
    },
    domProps: {
      "value": (_vm.product.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "price", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.createProduct
    }
  }, [_vm._v("Opslaan")])])])])])
},staticRenderFns: []}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.orderNotifications), function(orderNotification) {
    return _c('tr', {
      key: orderNotification.id
    }, [_c('td', [_vm._v(" " + _vm._s(orderNotification.amount) + " ")]), _vm._v(" "), _c('td', [_vm._v("  " + _vm._s(orderNotification.notification_text) + " ")]), _vm._v(" "), (orderNotification.settings.brands.length !== 0) ? _c('td', _vm._l((orderNotification.settings.brands), function(brand) {
      return _c('li', {
        key: brand
      }, [_vm._v(_vm._s(brand))])
    }), 0) : _c('td', [_vm._v(" Alles ")]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "css-control css-control-primary css-checkbox"
    }, [_c('input', {
      staticClass: "css-control-input",
      attrs: {
        "type": "checkbox",
        "readonly": "",
        "disabled": "disabled"
      },
      domProps: {
        "checked": orderNotification.settings.exclude_sale_products
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "css-control-indicator"
    })])]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "css-control css-control-primary css-checkbox"
    }, [_c('input', {
      staticClass: "css-control-input",
      attrs: {
        "type": "checkbox",
        "readonly": "",
        "disabled": "disabled"
      },
      domProps: {
        "checked": orderNotification.status
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "css-control-indicator"
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group",
      attrs: {
        "role": "group"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-secondary  ml-3",
      on: {
        "click": function($event) {
          _vm.select(orderNotification)
        }
      }
    }, [_vm._v("Bewerken")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-secondary  ml-3",
      on: {
        "click": function($event) {
          _vm.deleteNotification(orderNotification.id)
        }
      }
    }, [_vm._v("Verwijderen")])])])])
  }), 0)])])]), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.openEditModal
    }
  }, [_vm._v("\n    Nieuwe order notificatie\n  ")]) : _vm._e(), _vm._v(" "), (_vm.showEditModal) ? _c('order-notification-edit-modal', {
    ref: "editModal",
    attrs: {
      "order-notification": _vm.selected
    },
    on: {
      "close": _vm.refresh
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Totaal")]), _vm._v(" "), _c('th', [_vm._v("Melding tekst")]), _vm._v(" "), _c('th', [_vm._v("Merken")]), _vm._v(" "), _c('th', [_vm._v("Sales uitgesloten")]), _vm._v(" "), _c('th', [_vm._v("Actief")]), _vm._v(" "), _c('th', [_vm._v("Acties")])])])
}]}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "inkooporder aanmaken"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n        Inkooporder\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content p-0 row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderListName),
      expression: "orderListName"
    }],
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "placeholder": "Geef een naam aan de bestelling"
    },
    domProps: {
      "value": (_vm.orderListName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderListName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "options": _vm.brands,
      "placeholder": "Selecteer een leverancier",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    model: {
      value: (_vm.supplier),
      callback: function($$v) {
        _vm.supplier = $$v
      },
      expression: "supplier"
    }
  })], 1)])]), _vm._v(" "), (_vm.fromScratch) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n        Producten toevoegen\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-noborder",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.openUnknownProductModal
    }
  }, [_vm._v("\n          Nieuw product toevoegen aan inkooporder\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content p-0 row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productName),
      expression: "productName"
    }],
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "list": "products",
      "placeholder": "Vul een product naam in"
    },
    domProps: {
      "value": (_vm.productName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.productName = $event.target.value
      }, _vm.getProducts]
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "products"
    }
  }, _vm._l((_vm.products), function(item) {
    return _c('option', {
      key: item.id
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.addProductToOrderList
    }
  }, [_vm._v("\n          Toevoegen aan inkooporder\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.fromScratch) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n        Producten in inkooporder\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("EAN")]), _vm._v(" "), _c('th', [_vm._v("Product")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderListProducts), function(product) {
    return _c('tr', {
      key: product.id
    }, [_c('td', [_c('a', {
      staticClass: "font-w600",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(product.gtin))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.name))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.createOrderList
    }
  }, [_vm._v("\n    Maak een nieuwe inkooporder aan\n  ")]), _vm._v(" "), (_vm.showUnknownProductModal) ? _c('unkown-product-modal', {
    attrs: {
      "barcode": _vm.unknownProductBarcode
    },
    on: {
      "close": function($event) {
        _vm.showUnknownProductModal = null, _vm.unknownProductBarcode = null
      },
      "unkownProductCreated": _vm.handleUnkownProductCreated
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-content"
  }, [(!_vm.isConnectedToScanner) ? _c('p', {
    staticClass: "mt-5",
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "right": "0",
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-3x text-muted fa-border",
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "10px",
      "border": "2px solid red"
    },
    on: {
      "click": function($event) {
        _vm.openBarcodeScannerModal()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isConnectedToScanner) ? _c('p', {
    staticClass: "mt-5",
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "right": "0",
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-plus fa-3x text-muted fa-border",
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "10px",
      "border": "2px solid Green"
    },
    on: {
      "click": function($event) {
        _vm.disconnectFromBarcodeScanner()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showBarcodeScannerModal) ? _c('barcode-scanner-detail-modal', {
    on: {
      "close": function($event) {
        _vm.showBarcodeScannerModal = null, _vm.isConnectedToBarcodeScanner()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-side content-side-full"
  }, [_c('ul', {
    staticClass: "nav-main"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "si si-cup"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'checkout'
      }
    }
  }, [_c('i', {
    staticClass: "si si-wallet"
  }), _vm._v(" "), _c('span', [_vm._v("Showroom order")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'orders'
      }
    }
  }, [_c('i', {
    staticClass: "si si-basket"
  }), _vm._v(" "), _c('span', [_vm._v("Bestellingen")])])], 1), _vm._v(" "), (_vm.$auth.getUser().id === 36 || _vm.$auth.getUser().id === 40) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'refunds'
      }
    }
  }, [_c('i', {
    staticClass: "si si-control-rewind"
  }), _vm._v(" "), _c('span', [_vm._v("Retouren")])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'products'
      }
    }
  }, [_c('i', {
    staticClass: "si si-tag"
  }), _vm._v(" "), _c('span', [_vm._v("Producten")])])], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'order_lists'
      }
    }
  }, [_c('i', {
    staticClass: "si si-tag"
  }), _vm._v(" "), _c('span', [_vm._v("Inkooporders")])])], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'hour_registration'
      }
    }
  }, [_c('i', {
    staticClass: "si si-clock"
  }), _vm._v(" "), _c('span', [_vm._v("UrenReigstratie")])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Orderafhandeling")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Magazijn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Inkooporders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Medewerkers")])])
}]}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-tag mr-5"
  }), _vm._v(" Producten\n    "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success btn-noborder float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCreateProductModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-5"
  }), _vm._v("Nieuwe Product\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('small', {
    staticClass: "mr-1"
  }, [_vm._v("Genereer:")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.showStickerGenerator
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o text-danger mr-1"
  }), _vm._v(" Locatie labels")])])]), _vm._v(" "), _c('api-table-block', {
    ref: "productsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllProducts,
      "default-sort-by": "created_at",
      "item-label-singular": "product",
      "item-label-plural": "producten"
    },
    scopedSlots: _vm._u([{
      key: "image",
      fn: function(data) {
        return [_c('img', {
          key: data.item.id,
          staticClass: "img-avatar img-avatar48",
          attrs: {
            "src": data.item.image_urls[0],
            "alt": ""
          }
        })]
      }
    }, {
      key: "name",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.details(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "price",
      fn: function(data) {
        return [(data.item.sale_price) ? _c('sale-price-editable', {
          key: data.item.id,
          attrs: {
            "price": data.item.price,
            "sale_price": data.item.sale_price,
            "product-id": data.item.id
          }
        }) : _c('price-editable', {
          key: data.item.id,
          attrs: {
            "price": data.item.price,
            "product-id": data.item.id
          }
        })]
      }
    }, {
      key: "location",
      fn: function(data) {
        return [_c('div', [_c('location-editable', {
          key: data.item.id,
          attrs: {
            "field": "location",
            "value": data.item.location,
            "product-id": data.item.id
          }
        })], 1), _vm._v(" "), _c('div', [_c('small', [_vm._v("\n          Rest:\n          "), _c('field-editable', {
          key: data.item.id,
          attrs: {
            "field": "overstock_location",
            "value": data.item.overstock_location,
            "product-id": data.item.id
          }
        })], 1)])]
      }
    }, {
      key: "in_store",
      fn: function(data) {
        return [_c('in-store-editable', {
          key: data.item.id,
          attrs: {
            "in-store": !!data.value,
            "product-id": data.item.id
          }
        })]
      }
    }, {
      key: "stock_quantity",
      fn: function(data) {
        return [_c('stock-editable', {
          key: data.item.id,
          attrs: {
            "quantity": data.value,
            "product-id": data.item.id
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('select-barcode-scanner-widget'), _vm._v(" "), (_vm.detailModalProductId) ? _c('product-detail-modal', {
    key: _vm.detailModalProductId,
    attrs: {
      "product-id": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.detailModalProductId = null
      },
      "remove": _vm.refresh
    }
  }) : _vm._e(), _vm._v(" "), (_vm.unkownProductScanned) ? _c('unkown-product-modal', {
    attrs: {
      "barcode": _vm.scannedBarcode
    },
    on: {
      "close": function($event) {
        _vm.unkownProductScanned = null, _vm.scannedBarcode = null
      },
      "unkownProductCreated": _vm.handleUnkownProductCreated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showStickerGeneratorModal) ? _c('location-sticker-generator', {
    on: {
      "close": function($event) {
        _vm.showStickerGeneratorModal = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.locationScanned) ? _c('update-location-modal', {
    attrs: {
      "location": _vm.scannedLocation,
      "productId": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.scannedLocation = null, _vm.locationScanned = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.productsOnScannedLocation) ? _c('location-scanned-modal', {
    attrs: {
      "products": _vm.productsOnScannedLocation
    },
    on: {
      "select": _vm.details,
      "close": function($event) {
        _vm.productsOnScannedLocation = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCreateProductModal) ? _c('create-product-modal', {
    on: {
      "close": function($event) {
        _vm.showCreateProductModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Locatie gescand"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h1', [_vm._v("Locatie gescand: " + _vm._s(_vm.location) + " "), _c('h4', {
    staticStyle: {
      "display": "block",
      "margin-top": "px"
    }
  }, [_vm._v("Aan welke locatie wil je het toevoegen")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-right": "25px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.update('location')
      }
    }
  }, [_vm._v("Standaard locatie")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-right": "25px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.update('overstock_location')
      }
    }
  }, [_vm._v("Locatie overvoorraad")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Annuleren")])])])])
},staticRenderFns: []}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "page-header"
    }
  }, [_c('div', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "content-header-section"
  }, [_c('button', {
    staticClass: "btn btn-circle btn-dual-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })]), _vm._v(" "), _c('nav', {
    staticClass: "breadcrumb"
  }, [_c('router-link', {
    staticClass: "breadcrumb-item",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('span', {
    staticClass: "breadcrumb-item"
  }, [_vm._v("Magazijn")]), _vm._v(" "), _c('span', {
    staticClass: "breadcrumb-item"
  }, [_vm._v("Producten")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-header-section"
  }, [_c('b-dropdown', {
    attrs: {
      "text": _vm.user.username,
      "variant": "dual-secondary",
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('i', {
    staticClass: "si si-wrench mr-5"
  }), _vm._v(" Instellingen\n        ")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "si si-logout mr-5"
  }), _vm._v(" Log uit\n        ")])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    attrs: {
      "id": "sidebar-scroll"
    }
  }, [_c('div', {
    staticClass: "sidebar-content"
  }, [_c('div', {
    staticClass: "content-header content-header-fullrow px-15"
  }, [_c('div', {
    staticClass: "content-header-section text-center align-parent"
  }, [_c('button', {
    staticClass: "btn btn-circle btn-dual-secondary d-lg-none align-v-r",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSidebar
    }
  }, [_c('i', {
    staticClass: "fa fa-times text-danger"
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "content-side content-side-full content-side-user px-10 align-parent"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "img-link",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": _vm.user.avatar_url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline mt-10"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "link-effect text-dual-primary-dark font-size-xs font-w600 text-uppercase",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.user.username))])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "link-effect text-dual-primary-dark",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "si si-logout"
  })])])])])]), _vm._v(" "), (_vm.user.role === 'admin') ? _c('admin-sidebar') : _vm._e(), _vm._v(" "), (_vm.user.role === 'orderpicker') ? _c('order-picker-sidebar') : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-header-item"
  }, [_c('a', {
    staticClass: "link-effect font-w700",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "si si-check text-primary"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-size-xl text-dual-primary-dark"
  }, [_vm._v("VM")]), _c('span', {
    staticClass: "font-size-xl text-primary"
  }, [_vm._v("Control")])])])
}]}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success btn-noborder float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openManualRefundModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-5"
  }), _vm._v("Nieuwe Retour\n    ")]), _vm._v(" "), _c('i', {
    staticClass: "si si-basket mr-5"
  }), _vm._v(" Retours\n  ")]), _vm._v(" "), (_vm.ManualDetailModalShow) ? _c('manual-refund-modal', {
    on: {
      "close": function($event) {
        _vm.ManualDetailModalShow = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('api-table-block', {
    ref: "ordersTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllRefunds,
      "default-sort-by": "created_at",
      "item-label-singular": "bestelling",
      "item-label-plural": "bestellingen"
    },
    scopedSlots: _vm._u([{
      key: "check",
      fn: function(data) {
        return [_c('label', {
          key: data.item.order.number,
          staticClass: "css-control css-control-primary css-checkbox"
        }, [_c('input', {
          staticClass: "css-control-input",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.selectedOrders.includes(data.item.order.number)
          },
          on: {
            "change": function($event) {
              _vm.selectOrder(data.item.order.number, $event)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "css-control-indicator"
        })])]
      }
    }, {
      key: "number",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.openDetailModal(data.item.order.id, data.item.id)
            }
          }
        }, [_vm._v("#" + _vm._s(data.item.order_number))])]
      }
    }, {
      key: "billing_person",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.item.order.billing_person) + " "), (data.item.order.billing_company) ? _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.order.billing_company))]) : _vm._e()]
      }
    }, {
      key: "placed_at",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("capitalize")(_vm._f("moment")(data.item.order.placed_at, 'calendar'))) + "\n    ")]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('refund-status-badge', {
          attrs: {
            "refund": data.item
          }
        })]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [_c('button', {
          staticClass: "btn btn-sm btn-secondary",
          on: {
            "click": function($event) {
              _vm.openDetailModal(data.item.order.id, data.item.id)
            }
          }
        }, [_vm._v("Details")])]
      }
    }])
  }, [_c('template', {
    slot: "before-block-content"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyProcessing),
      expression: "showOnlyProcessing"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyProcessing) ? _vm._i(_vm.showOnlyProcessing, null) > -1 : (_vm.showOnlyProcessing)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyProcessing,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyProcessing = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyProcessing = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyProcessing = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Alleen openstaand\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyDropship),
      expression: "showOnlyDropship"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyDropship) ? _vm._i(_vm.showOnlyDropship, null) > -1 : (_vm.showOnlyDropship)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyDropship,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyDropship = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyDropship = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyDropship = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Alleen dropshipments\n          ")])])])])], 2), _vm._v(" "), _c('barcode-scanner', {
    on: {
      "scan": _vm.openDetailModal
    }
  }), _vm._v(" "), (_vm.detailModalOrderId) ? _c('refund-detail-modal', {
    key: _vm.detailModalOrderId,
    attrs: {
      "order-id": _vm.detailModalOrderId,
      "refundId": _vm.detailModalRefundId,
      "includeRefundShipmentCosts": true
    },
    on: {
      "close": function($event) {
        _vm.detailModalOrderId = null, _vm.refresh()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Bestellijst"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(_vm.orderList === null) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n           Bestellijst: " + _vm._s(_vm.orderList.name) + "\n           "), _c('order-list-status-badge', {
    ref: "orderListStatus",
    staticClass: "ml-2",
    attrs: {
      "orderList": _vm.orderList
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Producten")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    ref: "table",
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), _c('th', [_vm._v("Besteld")]), _vm._v(" "), _c('th', [_vm._v("Geleverd")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderList.lines), function(line) {
    return _c('tr', {
      key: line.id
    }, [_c('td', [(line.product.image_urls) ? _c('img', {
      staticClass: "img-avatar img-avatar48",
      attrs: {
        "src": line.product.image_urls[0],
        "alt": ""
      }
    }) : _c('i', {
      staticClass: "si si-picture  fa-2x"
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.product.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.ordered_quantity))]), _vm._v(" "), _c('td', [_c('p', [_vm._v(_vm._s(line.delivered_quantity))])])])
  }), 0)])])]), _vm._v(" "), ((_vm.status === 'ordered' || _vm.status === 'delivered') && _vm.user.role === 'admin') ? _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.updateStockQuantity()
      }
    }
  }, [_vm._v("\n         Voorraad bijboeken "), _c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('api-table-block', {
    ref: "ordersTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllOrders,
      "default-sort-by": "placed_at",
      "item-label-singular": "bestelling",
      "item-label-plural": "bestellingen"
    },
    scopedSlots: _vm._u([{
      key: "check",
      fn: function(data) {
        return [_c('label', {
          key: data.item.number,
          staticClass: "css-control css-control-primary css-checkbox"
        }, [_c('input', {
          staticClass: "css-control-input",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.selectedOrders.includes(data.item.number)
          },
          on: {
            "change": function($event) {
              _vm.selectOrder(data.item.number, $event)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "css-control-indicator"
        })])]
      }
    }, {
      key: "number",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.openDetailModal(data.item.id)
            }
          }
        }, [_vm._v("#" + _vm._s(data.value))])]
      }
    }, {
      key: "billing_person",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value) + " "), (data.item.billing_company) ? _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.billing_company))]) : _vm._e()]
      }
    }, {
      key: "placed_at",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("capitalize")(_vm._f("moment")(data.value, 'calendar'))) + "\n    ")]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('order-status-badge', {
          attrs: {
            "order": data.item
          }
        })]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [_c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group"
          }
        }, [_c('router-link', {
          staticClass: "btn btn-sm btn-secondary",
          attrs: {
            "to": {
              name: 'pick-orders',
              query: {
                orders: [data.item.number]
              }
            }
          }
        }, [_vm._v("Pick")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.openDetailModal(data.item.id)
            }
          }
        }, [_vm._v("Details")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.openManualRefundModal(data.item)
            }
          }
        }, [_vm._v("Retourneren")])], 1)]
      }
    }])
  }, [_c('template', {
    slot: "before-block-content"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('span', {
    staticClass: "d-none d-sm-inline",
    staticStyle: {
      "font-size": "medium",
      "font-weight": "bold"
    }
  }, [_vm._v(" Orderpicken: ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-rounded btn-alt-secondary mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.pickSelected
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o text-primary mx-5"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v(" Pick")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      value: ('Pick 20 oudste bestellingen die maar één product bevatten'),
      expression: "'Pick 20 oudste bestellingen die maar één product bevatten'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "btn btn-rounded btn-alt-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pick('single')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward text-danger mx-5"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v("Single")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      value: ('Pick 10 oudste bestellingen die minimaal twee producten bevatten'),
      expression: "'Pick 10 oudste bestellingen die minimaal twee producten bevatten'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "btn btn-rounded btn-alt-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pick('multi')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward text-danger mx-5"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v("Multi")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      value: ('Pick 10 oudste bestellingen'),
      expression: "'Pick 10 oudste bestellingen'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "btn btn-rounded btn-alt-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pick('all')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward text-danger mx-5"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v("Alles")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyNLOrders),
      expression: "showOnlyNLOrders"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyNLOrders) ? _vm._i(_vm.showOnlyNLOrders, null) > -1 : (_vm.showOnlyNLOrders)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyNLOrders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyNLOrders = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyNLOrders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyNLOrders = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" NL\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyBolOrders),
      expression: "showOnlyBolOrders"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyBolOrders) ? _vm._i(_vm.showOnlyBolOrders, null) > -1 : (_vm.showOnlyBolOrders)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyBolOrders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyBolOrders = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyBolOrders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyBolOrders = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Bol\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyProcessing),
      expression: "showOnlyProcessing"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyProcessing) ? _vm._i(_vm.showOnlyProcessing, null) > -1 : (_vm.showOnlyProcessing)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyProcessing,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyProcessing = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyProcessing = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyProcessing = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Openstaand\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyDropship),
      expression: "showOnlyDropship"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyDropship) ? _vm._i(_vm.showOnlyDropship, null) > -1 : (_vm.showOnlyDropship)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyDropship,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyDropship = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyDropship = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyDropship = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Dropshipments\n          ")])])])])], 2), _vm._v(" "), _c('barcode-scanner', {
    on: {
      "scan": _vm.handleMessage
    }
  }), _vm._v(" "), (_vm.refundDetailModalShow && _vm.refund.id !== null) ? _c('refund-detail-modal', {
    key: _vm.refundDetailModalOrderId,
    attrs: {
      "order-id": _vm.refundDetailModalOrderId,
      "refundId": _vm.refund.id,
      "includeRefundShipmentCosts": false
    },
    on: {
      "close": function($event) {
        _vm.refundDetailModalShow = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.detailModalOrderId) ? _c('order-detail-modal', {
    key: _vm.detailModalOrderId,
    attrs: {
      "order-id": _vm.detailModalOrderId
    },
    on: {
      "close": function($event) {
        _vm.detailModalOrderId = null
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('select-barcode-scanner-widget')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-basket mr-5"
  }), _vm._v(" Bestellingen\n  ")])
}]}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "push"
  }, [(!_vm.hideSearchBar) ? _c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('input', {
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ("Zoek " + _vm.itemLabelSingular + "...")
    },
    on: {
      "input": _vm.search
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [(_vm.filter) ? _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e(), _vm._v(" "), _vm._m(0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-light"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_c('strong', [_vm._v(_vm._s(this.currentStart) + "-" + _vm._s(this.currentEnd))]), _vm._v(" van "), _c('strong', [_vm._v(_vm._s(this.totalRows))]), _vm._v(" " + _vm._s(_vm.itemLabelPlural) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "block-options"
  }, [_vm._t("before-block-options"), _vm._v(" "), (_vm.sortBy) ? _c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.sortBy = null
      }
    }
  }, [_c('i', {
    staticClass: "si si-close"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.previous
    }
  }, [_c('i', {
    staticClass: "si si-arrow-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_c('i', {
    staticClass: "si si-arrow-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-block-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_c('i', {
    staticClass: "si si-refresh"
  })]), _vm._v(" "), _vm._t("after-block-options")], 2)]), _vm._v(" "), _vm._t("before-block-content"), _vm._v(" "), _c('div', {
    staticClass: "block-content",
    staticStyle: {
      "padding": "8px 0 0 0"
    }
  }, [_c('b-table', {
    ref: "table",
    staticClass: "table-vcenter table-responsive",
    attrs: {
      "hover": "",
      "show-empty": "",
      "fields": _vm.fields,
      "items": _vm.getItems,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "empty-text": ("Er zijn geen " + _vm.itemLabelPlural),
      "empty-filtered-text": ("Geen " + _vm.itemLabelPlural + " gevonden")
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([_vm._l((_vm.fields), function(field, key) {
      return {
        key: key,
        fn: function(data) {
          return [_c('div', {
            key: key
          }, [_vm._t(key, [_vm._v(_vm._s(data.value))], null, data)], 2)]
        }
      }
    })])
  })], 1), _vm._v(" "), _vm._t("after-block-content")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "alert animated fadeIn",
    class: ("alert-" + _vm.variant),
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa animated pulse",
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.message) + "\n")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success btn-noborder float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCreateUserModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-5"
  }), _vm._v("Nieuwe Gebruiker\n    ")]), _vm._v(" "), _c('i', {
    staticClass: "si si-people mr-5"
  }), _vm._v(" Gebruikers\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.users), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "col-md-6 col-xl-3"
    }, [_c('div', {
      staticClass: "block block-link-shadow text-center"
    }, [_c('div', {
      staticClass: "block-content block-content-full block-sticky-options pt-30"
    }, [_c('div', {
      staticClass: "block-options"
    }, [_c('b-dropdown', {
      staticClass: "dropdown-no-btn",
      attrs: {
        "right": ""
      }
    }, [_c('template', {
      slot: "button-content"
    }, [_c('i', {
      staticClass: "fa fa-fw fa-ellipsis-v"
    })]), _vm._v(" "), (user.role === 'orderpicker') ? _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          _vm.openHourRegistrationModal(user.id)
        }
      }
    }, [_c('i', {
      staticClass: "si si-clock mr-5"
    }), _vm._v("Bekijk uren registratie\n        ")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          _vm.deleteUser(user.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle mr-5"
    }), _vm._v("Verwijder gebruiker\n        ")])], 2)], 1), _vm._v(" "), _c('img', {
      staticClass: "img-avatar",
      attrs: {
        "src": user.avatar_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "block-content block-content-full block-content-sm bg-body-light"
    }, [_c('div', {
      staticClass: "font-w600 mb-5"
    }, [_vm._v(_vm._s(user.username))])]), _vm._v(" "), _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "row items-push text-center"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "font-size-sm text-muted"
    }, [_vm._v(_vm._s(user.role))])]), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "font-size-sm text-muted"
    }, [_vm._v(_vm._s(_vm._f("moment")(user.created_at, 'calendar')))])])])])])])
  }), 0), _vm._v(" "), (_vm.showCreateUserModal) ? _c('create-new-user-modal', {
    on: {
      "userCreated": _vm.loadUsers,
      "close": function($event) {
        _vm.showCreateUserModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHourRegistrationModal) ? _c('hour-registration-modal', {
    attrs: {
      "userId": _vm.selectedUserId
    },
    on: {
      "close": function($event) {
        _vm.showHourRegistrationModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-badge fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-user-follow fa-2x"
  })])
}]}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.isEdditing) ? _c('span', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cancel),
      expression: "cancel"
    }]
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('masked-input', {
    ref: "locationInput",
    staticClass: "form-control",
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "text",
      "mask": "A.11.11.11.11",
      "placeholder": "_.__.__.__.__"
    },
    model: {
      value: (_vm.inputLocation),
      callback: function($$v) {
        _vm.inputLocation = $$v
      },
      expression: "inputLocation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-check"
  })])])], 1)])]) : _c('span', {
    on: {
      "click": _vm.edit
    }
  }, [(_vm.location) ? _c('span', {
    staticClass: "editable text-primary"
  }, [_vm._v(_vm._s(_vm.location))]) : _c('span', {
    staticClass: "editable text-danger"
  }, [_c('i', [_vm._v("n.n.b.")])])]), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-content block-content-full border-bottom"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col py-5"
  }, [_c('h3', {
    staticClass: "h5 font-w700 mb-10"
  }, [(_vm.job.status === 'queued') ? _c('i', {
    class: "fa fa-hourglass-o text-warning mr-5"
  }) : (_vm.job.status === 'finished') ? _c('i', {
    class: "fa fa-check text-success mr-5"
  }) : (_vm.job.status === 'failed') ? _c('i', {
    class: "fa fa-times text-danger mr-5"
  }) : (_vm.job.status === 'executing') ? _c('i', {
    class: "fa fa-spinner fa-spin text-info mr-5"
  }) : _vm._e(), _vm._v("\n\n        " + _vm._s(_vm.name)), (_vm.job.status === 'executing') ? _c('span', [_vm._v("...")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "progress mb-5",
    staticStyle: {
      "height": "8px"
    }
  }, [(_vm.job.status === 'queued') ? _c('div', {
    staticClass: "progress-bar",
    style: ({
      width: '0%'
    }),
    attrs: {
      "role": "progressbar"
    }
  }) : (_vm.job.status === 'finished') ? _c('div', {
    staticClass: "progress-bar bg-success",
    style: ({
      width: '100%'
    }),
    attrs: {
      "role": "progressbar"
    }
  }) : (_vm.job.status === 'failed') ? _c('div', {
    staticClass: "progress-bar bg-danger",
    style: ({
      width: (_vm.progress + "%")
    }),
    attrs: {
      "role": "progressbar"
    }
  }) : (_vm.job.status === 'executing') ? _c('div', {
    staticClass: "progress-bar progress-bar-striped progress-bar-animated bg-info",
    style: ({
      width: (_vm.progress + "%")
    }),
    attrs: {
      "role": "progressbar"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.job.status === 'queued') ? _c('p', {
    staticClass: "font-size-sm font-w600 mb-0"
  }, [_vm._v("In de wachtrij...")]) : (_vm.job.status === 'executing') ? _c('p', {
    staticClass: "font-size-sm font-w600 mb-0"
  }, [(_vm.job.progress_max) ? _c('span', [_c('span', {
    staticClass: "font-w700"
  }, [_vm._v(_vm._s(_vm.job.progress_now))]), _vm._v(" van "), _c('span', {
    staticClass: "font-w700"
  }, [_vm._v(_vm._s(_vm.job.progress_max))])]) : _c('span', [_vm._v("Bezig...")])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-side content-side-full"
  }, [_c('ul', {
    staticClass: "nav-main"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "si si-cup"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'orders'
      }
    }
  }, [_c('i', {
    staticClass: "si si-basket"
  }), _vm._v(" "), _c('span', [_vm._v("Bestellingen")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'refunds'
      }
    }
  }, [_c('i', {
    staticClass: "si si-control-rewind"
  }), _vm._v(" "), _c('span', [_vm._v("Retouren")])])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'products'
      }
    }
  }, [_c('i', {
    staticClass: "si si-tag"
  }), _vm._v(" "), _c('span', [_vm._v("Producten")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'unknown_products'
      }
    }
  }, [_c('i', {
    staticClass: "si si-tag"
  }), _vm._v(" "), (_vm.amountUnknownProducts) ? _c('span', [_c('i', {
    staticClass: "fa fa-exclamation-circle fa-lg text-danger"
  }), _vm._v(" " + _vm._s(_vm.amountUnknownProducts) + " Onbekende producten ")]) : _c('span', [_vm._v("Onbekende producten")])])], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'order_lists'
      }
    }
  }, [_c('i', {
    staticClass: "si si-tag"
  }), _vm._v(" "), _c('span', [_vm._v("Inkooporders")])])], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_c('i', {
    staticClass: "si si-people"
  }), _vm._v(" "), _c('span', [_vm._v("Gebruikers")])])], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'sales-channels'
      }
    }
  }, [_c('i', {
    staticClass: "si si-share"
  }), _vm._v(" "), _c('span', [_vm._v("Verkoopkanalen")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dropshipment'
      }
    }
  }, [_c('i', {
    staticClass: "si si-share"
  }), _vm._v(" "), _c('span', [_vm._v("Dropshipment")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('i', {
    staticClass: "si si-wrench"
  }), _vm._v(" "), _c('span', [_vm._v("Instellingen")])])], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'report_purchasing_value_orders'
      }
    }
  }, [_c('i', {
    staticClass: "si si-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Winstgevendheid")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'report_profit_margins'
      }
    }
  }, [_c('i', {
    staticClass: "si si-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Product winstgevendheid")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'report_revenue'
      }
    }
  }, [_c('i', {
    staticClass: "si si-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Omzet")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'report_products'
      }
    }
  }, [_c('i', {
    staticClass: "si si-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Producten")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Orderafhandeling")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Magazijn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Inkooporders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Medewerkers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Systeem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Rapportage")])])
}]}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('span', {
    staticClass: "animated fadeIn",
    class: ("text-" + _vm.variant)
  }, [_c('i', {
    staticClass: "fa animated pulse",
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.message))]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('job-list', {
    ref: "jobList"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.salesChannels), function(channel) {
    return _c('div', {
      key: channel.key,
      staticClass: "col-md-6 col-xl-3"
    }, [_c('sales-channel-widget', {
      attrs: {
        "sales-channel": channel
      },
      on: {
        "sync": _vm.loadJobList
      }
    })], 1)
  }), 0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-share mr-5"
  }), _vm._v(" Verkoopkanalen\n  ")])
}]}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isEdditing) ? _c('span', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cancel),
      expression: "cancel"
    }]
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPurchasePrice),
      expression: "newPurchasePrice"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number",
      "step": "any",
      "min": "0"
    },
    domProps: {
      "value": (_vm.newPurchasePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPurchasePrice = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-check"
  })])])])])]) : _c('span', {
    on: {
      "click": _vm.edit
    }
  }, [(_vm.currentPurchasePrice) ? _c('span', {
    staticClass: "editable text-primary"
  }, [_vm._v("€ " + _vm._s(_vm.currentPurchasePrice))]) : _c('span', {
    staticClass: "editable text-danger"
  }, [_c('i', [_vm._v("n.n.b.")])])]), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.vendors), function(vendor) {
    return _c('div', {
      key: vendor.name,
      staticClass: "col-md-6 col-xl-3"
    }, [_c('dropshipment-widget', {
      attrs: {
        "vendor": vendor
      }
    })], 1)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-share mr-5"
  }), _vm._v(" Dropshipment kanalen\n  ")])
}]}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Locatiestickers"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Locatiestickers PDF generator")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Rijnummer"
    }
  }, [_vm._v("Letter:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.letter),
      expression: "letter"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "placeholder": "A"
    },
    domProps: {
      "value": (_vm.letter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.letter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Rijnummer"
    }
  }, [_vm._v("Rijnummer:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rowNumber),
      expression: "rowNumber"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "Nummber",
      "placeholder": "05"
    },
    domProps: {
      "value": (_vm.rowNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rowNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.rowNumber && _vm.letter) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.rowNumber))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Stellingen van"
    }
  }, [_vm._v("Stellingen van:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.racksFrom),
      expression: "racksFrom"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "01"
    },
    domProps: {
      "value": (_vm.racksFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.racksFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Stellingen tot"
    }
  }, [_vm._v("Stellingen tot:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.racksTill),
      expression: "racksTill"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "11"
    },
    domProps: {
      "value": (_vm.racksTill)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.racksTill = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.rowNumber && _vm.racksFrom && _vm.racksTill) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.racksFrom))]), _vm._v("-\n                          "), _c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.racksTill))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Planken van"
    }
  }, [_vm._v("Planken van:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planksFrom),
      expression: "planksFrom"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "01"
    },
    domProps: {
      "value": (_vm.planksFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.planksFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Planken tot"
    }
  }, [_vm._v("Planken tot:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planksTill),
      expression: "planksTill"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "06"
    },
    domProps: {
      "value": (_vm.planksTill)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.planksTill = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.rowNumber && _vm.racksFrom && _vm.racksTill && _vm.planksFrom && _vm.planksTill) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.racksFrom))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.planksFrom))]), _vm._v("-\n                          "), _c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.racksTill))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.planksTill))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Locaties van"
    }
  }, [_vm._v("Locaties van")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationsFrom),
      expression: "locationsFrom"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "01"
    },
    domProps: {
      "value": (_vm.locationsFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.locationsFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Locaties tot"
    }
  }, [_vm._v("Locaties tot")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationsTill),
      expression: "locationsTill"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "05"
    },
    domProps: {
      "value": (_vm.locationsTill)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.locationsTill = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.rowNumber && _vm.racksFrom && _vm.racksTill && _vm.planksFrom && _vm.planksTill && _vm.locationsTill && _vm.locationsFrom) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.racksFrom))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.planksFrom))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.locationsFrom))]), _vm._v("-\n                          "), _c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.racksTill))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.planksTill))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.locationsTill))])]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.generateLocationStickerPdf
    }
  }, [_vm._v("Genereer PDF (" + _vm._s(_vm.totalStickersToBePrinted) + " stickers)")])])])])
},staticRenderFns: []}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "block block-link-shadow block-rounded block-bordered",
    class: {
      'package-type--selected': _vm.selected, 'disabled': !_vm.provider
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "py-5 text-center"
  }, [_c('div', {
    staticClass: "mb-15"
  }, [_c('i', {
    class: [("fa fa-" + _vm.icon + " fa-3x text-muted"), {
      'text-whites': _vm.selected
    }]
  })]), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm font-w600 text-uppercase text-muted",
    class: {
      'text-whites': _vm.selected
    }
  }, [(_vm.provider) ? _c('img', {
    staticClass: "shipping-provider-icon",
    attrs: {
      "src": __webpack_require__(772)("./" + _vm.provider + ".png")
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    staticClass: "no-header",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-header": "true",
      "hide-footer": true,
      "title": "1-9 van 9 Urenregistraties"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('hour-registration-table', {
    ref: "registrationTable",
    attrs: {
      "userId": _vm.userId,
      "role": "admin"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b-dropdown', {
    attrs: {
      "size": "sm",
      "variant": _vm.currentStatus.color,
      "disabled": _vm.saving
    }
  }, [_c('template', {
    slot: "button-content"
  }, [(_vm.saving) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin mr-1"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.currentStatus.label) + "\n    ")]), _vm._v(" "), _vm._l((_vm.selectableStatuses), function(status) {
    return _c('b-dropdown-item', {
      key: status.id,
      class: ("bg-" + (status.color)),
      staticStyle: {
        "color": "#fff !important"
      },
      on: {
        "click": function($event) {
          _vm.updateStatus(status.id)
        }
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2), _vm._v(" "), _c('text-alert', {
    staticClass: "ml-1",
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "inkooporder controleren"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(_vm.scannedProduct === null) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n          Scan het in te boeken product...\n          ")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner",
    staticStyle: {
      "margin-top": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-content",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.completeOrderList
    }
  }, [_vm._v("Inkooporder afronden")])])]) : _c('div', [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n        Product uit inkooporde gescanned\n      ")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-borderless table-striped table-hover",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "90% !important"
    }
  }, [_c('tbody', [(_vm.scannedProduct.image_urls) ? _c('td', [_c('img', {
    staticClass: "img-avatar img-avatar48",
    attrs: {
      "src": _vm.scannedProduct.image_urls[0],
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "font-w600",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.scannedProduct.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.scannedProduct.stock_quantity))]), _vm._v(" "), _c('td', [_c('location-editable', {
    key: _vm.scannedProduct.id,
    attrs: {
      "field": "location",
      "value": _vm.scannedProduct.location,
      "product-id": _vm.scannedProduct.id
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-inline",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "75% !important"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "for": "amountDelivered"
    }
  }, [_vm._v("Aantal geleverd")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveredAmount),
      expression: "deliveredAmount"
    }],
    staticClass: "form-control form-control-lg",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "type": "number",
      "id": "amountDelivered"
    },
    domProps: {
      "value": (_vm.deliveredAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveredAmount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.bookProduct
    }
  }, [_vm._v("Bij boeken")])])])])]), _vm._v(" "), (_vm.unkownProductScanned) ? _c('unkown-product-modal', {
    attrs: {
      "barcode": _vm.scannedBarcode
    },
    on: {
      "close": function($event) {
        _vm.unkownProductScanned = null, _vm.scannedBarcode = null
      },
      "unkownProductCreated": _vm.handleUnkownProductCreated
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Bestelling details"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(_vm.order === null) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', [(_vm.order.customer_note) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', {
    staticClass: "alert-heading font-w400 my-2"
  }, [_vm._v("Notitie van klant:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.order.customer_note))])]) : _vm._e(), _vm._v(" "), (_vm.order.gift_wrapping) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fa fa-info-circle mr-5"
  }), _vm._v(" Deze bestelling moet WEL ingepakt worden.")])]) : _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fa fa-info-circle mr-5"
  }), _vm._v(" Deze bestelling hoeft NIET ingepakt te worden.")])]), _vm._v(" "), _vm._l((_vm.orderNotifications), function(orderNotification) {
    return _c('div', {
      key: orderNotification.id,
      staticClass: "alert alert-info",
      attrs: {
        "role": "alert"
      }
    }, [_c('p', {
      staticClass: "mb-0"
    }, [_c('i', {
      staticClass: "fa fa-info-circle mr-5"
    }), _vm._v(" " + _vm._s(orderNotification.notification_text))])])
  }), _vm._v(" "), (_vm.order.discount_code) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', {
    staticClass: "alert-heading font-w400 my-2"
  }, [_vm._v("Kortingscode:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.order.discount_code))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n          Bestelling #" + _vm._s(_vm.order.number) + "\n          "), _c('order-status-badge', {
    ref: "orderStatus",
    staticClass: "ml-2",
    attrs: {
      "order": _vm.order
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block-options"
  }, [_c('small', {
    staticClass: "mr-1"
  }, [_vm._v("Download:")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "href": _vm.invoicePdfUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o text-danger mr-1"
  }), _vm._v(" Pakbon")]), _vm._v(" "), (_vm.order.shipment) ? _c('a', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "href": _vm.shipmentPdfUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-tag text-warning mr-1"
  }), _vm._v(" Verzendlabel")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block-options"
  }, [_c('small', {
    staticClass: "mr-1"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "href": _vm.invoiceOrderPdfUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o text-danger mr-1"
  }), _vm._v(" Factuur")])])]), _vm._v(" "), _c('order-timeline', {
    attrs: {
      "order": _vm.order
    },
    on: {
      "print:label": _vm.printLabel
    }
  })], 1), _vm._v(" "), (_vm.order.shipping_method === 'pickup') ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "py-20 text-center"
  }, [_c('div', {
    staticClass: "font-size-h4 font-w600"
  }, [_vm._v("Wordt opgehaald")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Deze bestelling wordt opgehaald door de klant.")]), _vm._v(" "), (_vm.order.status !== 'completed') ? _c('div', {
    staticClass: "pt-20"
  }, [_c('button', {
    staticClass: "btn btn-rounded btn-alt-success",
    on: {
      "click": _vm.completeOrder
    }
  }, [_c('i', {
    staticClass: "fa fa-check mr-5"
  }), _vm._v(" Bestelling voltooien\n            ")])]) : _vm._e()])])]) : (!_vm.order.shipment) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Verzending aanmaken")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row gutters-tiny"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('package-type', {
    attrs: {
      "icon": "dropbox",
      "selected": _vm.shipment.package_type === 1,
      "provider": _vm.shipmentOptions[1]
    },
    on: {
      "click": function($event) {
        _vm.selectPackageType(1)
      }
    }
  }, [_vm._v("\n              Groot Pakket\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('package-type', {
    attrs: {
      "icon": "folder-open",
      "selected": _vm.shipment.package_type === 2,
      "provider": _vm.shipmentOptions[2]
    },
    on: {
      "click": function($event) {
        _vm.selectPackageType(2)
      }
    }
  }, [_vm._v("\n              Brievenbuspakket\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('package-type', {
    attrs: {
      "icon": "envelope-open",
      "selected": _vm.shipment.package_type === 3,
      "provider": _vm.shipmentOptions[3]
    },
    on: {
      "click": function($event) {
        _vm.selectPackageType(3)
      }
    }
  }, [_vm._v("\n              Envelop\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('package-type', {
    attrs: {
      "icon": "dropbox",
      "selected": _vm.shipment.package_type === 4,
      "provider": _vm.shipmentOptions[4]
    },
    on: {
      "click": function($event) {
        _vm.selectPackageType(4)
      }
    }
  }, [_vm._v("\n              Klein Pakket "), _c('br'), _vm._v(" "), _c('small', [_vm._v("max 3 kg, lengte max 50 cm, omtrek max 111 cm")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center my-20"
  }, [_c('div', {
    attrs: {
      "title": !_vm.showShipmentOptionToggles ? 'Deze opties zijn niet van toepassing op de geselecteerde verzendmethode.' : ''
    }
  }, [_c('label', {
    staticClass: "css-control css-control-primary css-switch",
    class: {
      'disabled': !_vm.showShipmentOptionToggles
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipment.insurance),
      expression: "shipment.insurance"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.showShipmentOptionToggles
    },
    domProps: {
      "checked": Array.isArray(_vm.shipment.insurance) ? _vm._i(_vm.shipment.insurance, null) > -1 : (_vm.shipment.insurance)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.shipment.insurance,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.shipment, "insurance", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.shipment, "insurance", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.shipment, "insurance", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Verzekerd\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-primary css-switch",
    class: {
      'disabled': !_vm.showShipmentOptionToggles
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipment.large_format),
      expression: "shipment.large_format"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.showShipmentOptionToggles
    },
    domProps: {
      "checked": Array.isArray(_vm.shipment.large_format) ? _vm._i(_vm.shipment.large_format, null) > -1 : (_vm.shipment.large_format)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.shipment.large_format,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.shipment, "large_format", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.shipment, "large_format", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.shipment, "large_format", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" XL Pakket\n            ")])]), _vm._v(" "), (_vm.shipment.package_type === 3) ? _c('button', {
    staticClass: "btn btn-hero btn-alt-secondary",
    on: {
      "click": _vm.openPostageStampDetailModal
    }
  }, [_c('i', {
    staticClass: "fa fa-send mr-5 text-primary"
  }), _vm._v("\n            Verzend en print label\n          ")]) : _c('button', {
    staticClass: "btn btn-hero btn-alt-secondary",
    attrs: {
      "disabled": _vm.creatingShipment
    },
    on: {
      "click": _vm.createShipment
    }
  }, [(_vm.creatingShipment) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin mr-5"
  }) : _c('i', {
    staticClass: "fa fa-send mr-5 text-primary"
  }), _vm._v("\n            Verzend en print label\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('order-address', {
    attrs: {
      "order": _vm.order
    }
  }), _vm._v(" "), (_vm.order.contains_sol_product && !_vm.order.shipping_phone) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-danger"
  }, [_c('h3', {
    staticClass: "block-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Telefoonnummer")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row justify-content-center py-sm-3 py-md-5"
  }, [_c('div', {
    staticClass: "col-sm-10 col-md-8"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "telephonenumber"
    }
  }, [_vm._v("Telefoonnummer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerPhonenumber),
      expression: "customerPhonenumber"
    }],
    staticClass: "form-control form-control-alt",
    attrs: {
      "type": "text",
      "id": "telephonenumber",
      "name": "telephonenumber",
      "placeholder": "Vul een telefoon nummer in"
    },
    domProps: {
      "value": (_vm.customerPhonenumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerPhonenumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full block-content-sm bg-body-light"
  }, [_c('button', {
    staticClass: "btn btn-alt-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.setPhonenumber
    }
  }, [_c('i', {
    staticClass: "fa fa-check opacity-50 me-1"
  }), _vm._v(" Vul Villa Madelief nummer in\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full block-content-sm bg-body-light"
  }, [_c('button', {
    staticClass: "btn btn-alt-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.updatePhonenumber
    }
  }, [_c('i', {
    staticClass: "fa fa-check opacity-50 me-1"
  }), _vm._v(" Submit\n        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Producten")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("EAN")]), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Aantal")]), _vm._v(" "), _c('th', [_vm._v("Locatie")]), _vm._v(" "), _c('th', [_vm._v("Productnummer Leverancier")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.order.lines), function(line) {
    return _c('tr', {
      key: line.id
    }, [_c('td', [_c('a', {
      staticClass: "font-w600",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(line.product.gtin))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.product.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center font-w600"
    }, [_vm._v(_vm._s(line.quantity))]), _vm._v(" "), _c('td', [(line.product.dropship) ? _c('i', [_vm._v("Wordt nageleverd "), _c('small', [_vm._v(_vm._s(line.product.dropship))]), (line.dropshipment_completed_at) ? _c('small', [_c('i', {
      staticClass: "fa fa-check fa-4x text-success",
      staticStyle: {
        "font-size": "2em"
      }
    })]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(line.product.location))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.product.vendor_product_id || 'N.v.t.'))])])
  }), 0), _vm._v(" "), (_vm.order.contains_sol_product && !_vm.order.weshipp_id) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.orderSolProducts
    }
  }, [_vm._v("Bestel Sol producten")]) : _vm._e()])])])], 2), _vm._v(" "), (_vm.showPostageStampModal) ? _c('postage-stamp-detail-modal', {
    attrs: {
      "order": _vm.order,
      "shipment": _vm.shipment
    },
    on: {
      "close": function($event) {
        _vm.loadOrder(), _vm.showPostageStampModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isEdditing) ? _c('span', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cancel),
      expression: "cancel"
    }]
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSalePrice),
      expression: "newSalePrice"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number",
      "step": "any",
      "min": "0"
    },
    domProps: {
      "value": (_vm.newSalePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSalePrice = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-check"
  })])])])])]) : _c('span', {
    on: {
      "click": _vm.edit
    }
  }, [(_vm.productPrice && _vm.salePrice) ? _c('span', {
    staticClass: "editable text-primary"
  }, [_c('small', [_c('del', [_vm._v("€ " + _vm._s(_vm.productPrice))])]), _vm._v(" € " + _vm._s(_vm.salePrice))]) : _c('span', {
    staticClass: "editable text-danger"
  }, [_c('i', [_vm._v("n.n.b.")])])]), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Producten"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Producten op gescande locatie")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    ref: "table",
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr')]), _vm._v(" "), _c('tbody', _vm._l((_vm.products), function(product) {
    return _c('tr', {
      key: product.id
    }, [_c('td', {
      staticClass: "border-1",
      staticStyle: {
        "width": "500px"
      },
      attrs: {
        "scope": "row"
      }
    }, [_c('div', {
      staticClass: "p-2"
    }, [_c('img', {
      staticClass: "img-fluid rounded shadow-sm",
      attrs: {
        "src": product.image_urls[0],
        "alt": "",
        "width": "70"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ml-3 d-inline-block align-middle"
    }, [_c('h5', {
      staticClass: "mb-0"
    }, [_c('a', {
      staticClass: "text-dark d-inline-block align-middle",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.select(product)
        }
      }
    }, [_vm._v(_vm._s(product.name))])])])])])])
  }), 0)])])]), _vm._v(" "), (_vm.detailModalProductId) ? _c('product-detail-modal', {
    key: _vm.detailModalProductId,
    attrs: {
      "product-id": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.detailModalProductId = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block block-link-shadow text-center"
  }, [_c('div', {
    staticClass: "block-content block-content-full block-sticky-options pt-30"
  }, [_c('div', {
    staticClass: "block-options"
  }, [_c('b-dropdown', {
    staticClass: "dropdown-no-btn",
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ellipsis-v"
  })]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.openProductsTable
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tag mr-5"
  }), _vm._v("Producten\n          ")])], 2)], 1), _vm._v(" "), _c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": '/static/img/dropshipment/' + _vm.vendor.type + '.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full block-content-sm bg-body-light"
  }, [_c('div', {
    staticClass: "font-w600 mb-5"
  }, [_vm._v(_vm._s(_vm.vendor.name))]), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v(_vm._s(_vm.products.total) + " producten in koppeling")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row items-push text-center"
  }, [(_vm.vendor.sync_interval === 'daily') ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v("Synchroniseert dagelijks om " + _vm._s(_vm.vendor.sync_time))])])]) : _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v("Synchronisatie n.v.t.")])])])])]), _vm._v(" "), (_vm.showProductsTable) ? _c('dropshipment-products-table', {
    attrs: {
      "vendor": _vm.vendor
    },
    on: {
      "close": function($event) {
        _vm.showProductsTable = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-like fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-like fa-2x"
  })])
}]}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.jobs.length) ? _c('div', {
    staticClass: "block"
  }, _vm._l((_vm.jobs), function(job) {
    return _c('job-list-item', {
      key: job.id,
      attrs: {
        "job": job
      }
    })
  }), 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Barcode connector"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Selecteer de barcode scanner die je wilt gebruiker")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row gutters-tiny"
  }, _vm._l((_vm.barcodeScanners), function(barcodeScanner) {
    return _c('div', {
      key: barcodeScanner.id,
      staticClass: "col-md-6"
    }, [_c('barcode-scanner-type', {
      attrs: {
        "icon": "barcode"
      },
      on: {
        "click": function($event) {
          _vm.connectToBarcodeScanner(barcodeScanner.usb_device)
        }
      }
    }, [_vm._v("\n                " + _vm._s(barcodeScanner.name) + "\n              ")])], 1)
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.hourRegistrationStarted) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.startHourRegistration
    }
  }, [_vm._v("Start urenregistratie")]) : _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stopHourRegistartion
    }
  }, [_vm._v("Stop urenregistratie")]), _vm._v(" "), _c('hour-registration-table', {
    ref: "registrationTable",
    attrs: {
      "userId": this.$auth.getUser().id,
      "role": "orderpicker"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-basket mr-5"
  }), _vm._v(" Uren registratie\n  ")])
}]}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "block block-link-shadow text-center",
    attrs: {
      "to": {
        name: _vm.route
      }
    }
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('p', {
    staticClass: "mt-5"
  }, [_c('i', {
    staticClass: "si fa-4x",
    class: ['si-' + _vm.icon, _vm.iconClass]
  })]), _vm._v(" "), _c('p', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.label))])])])
},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "block block-link-shadow block-rounded block-bordered",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "py-5 text-center"
  }, [_c('div', {
    staticClass: "mb-15"
  }, [_c('i', {
    class: [("fa fa-" + _vm.icon + " fa-3x text-muted")]
  })]), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm font-w600 text-uppercase text-muted"
  }, [_c('img', {
    staticClass: "shipping-provider-icon",
    attrs: {
      "src": __webpack_require__(290)
    }
  }), _vm._v(" "), _vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Productdetails"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default",
    staticStyle: {
      "display": "block"
    }
  }, [_c('h6', [_vm._v("Nieuwe order notificatie")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Barcode"
    }
  }, [_vm._v("Notificatie tekst:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNotification.notification_text),
      expression: "orderNotification.notification_text"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderNotification.notification_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderNotification, "notification_text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Location"
    }
  }, [_vm._v("Bedrag:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNotification.amount),
      expression: "orderNotification.amount"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.orderNotification.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderNotification, "amount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Merken:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "multiple": true,
      "options": _vm.brands,
      "placeholder": "Selecteer merken",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔",
      "allow-input": ""
    },
    model: {
      value: (_vm.orderNotification.settings.brands),
      callback: function($$v) {
        _vm.$set(_vm.orderNotification.settings, "brands", $$v)
      },
      expression: "orderNotification.settings.brands"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNotification.settings.exclude_sale_products),
      expression: "orderNotification.settings.exclude_sale_products"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.orderNotification.settings.exclude_sale_products) ? _vm._i(_vm.orderNotification.settings.exclude_sale_products, null) > -1 : (_vm.orderNotification.settings.exclude_sale_products)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.orderNotification.settings.exclude_sale_products,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.orderNotification.settings, "exclude_sale_products", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.orderNotification.settings, "exclude_sale_products", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.orderNotification.settings, "exclude_sale_products", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Sales producten uitsluiten:\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNotification.status),
      expression: "orderNotification.status"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.orderNotification.status) ? _vm._i(_vm.orderNotification.status, null) > -1 : (_vm.orderNotification.status)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.orderNotification.status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.orderNotification, "status", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.orderNotification, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.orderNotification, "status", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Actief\n                      ")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Opslaan\n              ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.marketplaces,
      "multiple": "",
      "placeholder": "Selecteer een marktplaats",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    on: {
      "input": _vm.reload
    },
    model: {
      value: (_vm.selectedMarketplaces),
      callback: function($$v) {
        _vm.selectedMarketplaces = $$v
      },
      expression: "selectedMarketplaces"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateFrom),
      expression: "dateFrom"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Periode van"
    },
    domProps: {
      "value": (_vm.dateFrom)
    },
    on: {
      "change": _vm.reload,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateTo),
      expression: "dateTo"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Periode van"
    },
    domProps: {
      "value": (_vm.dateTo)
    },
    on: {
      "change": _vm.reload,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateTo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeVat),
      expression: "includeVat"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeVat) ? _vm._i(_vm.includeVat, null) > -1 : (_vm.includeVat)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.includeVat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeVat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeVat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeVat = $$c
        }
      }, _vm.reload]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Incl btw\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeShipping),
      expression: "includeShipping"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeShipping) ? _vm._i(_vm.includeShipping, null) > -1 : (_vm.includeShipping)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.includeShipping,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeShipping = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeShipping = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeShipping = $$c
        }
      }, _vm.reload]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Incl verzendkosten\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllMarketplaces),
      expression: "selectAllMarketplaces"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllMarketplaces) ? _vm._i(_vm.selectAllMarketplaces, null) > -1 : (_vm.selectAllMarketplaces)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectAllMarketplaces,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllMarketplaces = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllMarketplaces = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllMarketplaces = $$c
        }
      }, _vm.reload]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Selecteer alle kanalen\n              ")])])])]), _vm._v(" "), (!_vm.result) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', [_c('div', {
    staticClass: "chart"
  }, [_c('line-chart', {
    attrs: {
      "result": _vm.result
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container revenue-numbers"
  }, [_c('div', {
    staticClass: "row gx-10"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "p-3 border bg-light"
  }, [_c('h5', [_vm._v("Omzet")]), _vm._v(" "), _c('h3', [_vm._v("\n              €\n              "), _c('span', [_vm._v("\n                " + _vm._s(_vm.result.total_revenue) + "\n              ")])]), _vm._v(" "), _c('h3', [_vm._v("\n              €\n              "), _c('span', [_vm._v("\n                " + _vm._s(_vm.result.historical_total_revenue) + "\n              ")])]), _vm._v(" "), (_vm.result.percentage_change_revenue >= 30) ? _c('b', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_revenue + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_revenue < 30 && _vm.result.percentage_change_revenue >= 0) ? _c('b', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_revenue + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_revenue < 0) ? _c('b', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_revenue + '%'))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" t.a.v vorige jaar in dezelfde periode ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "p-3 border bg-light"
  }, [_c('h5', [_vm._v("Orders")]), _vm._v(" "), _c('h3', [_c('span', [_vm._v("\n                " + _vm._s(_vm.result.order_amount) + "\n              ")])]), _vm._v(" "), _c('h3', [_c('span', [_vm._v("\n                " + _vm._s(_vm.result.historical_order_amount) + "\n              ")])]), _vm._v(" "), (_vm.result.percentage_change_order_amount >= 30) ? _c('b', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_amount + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_order_amount < 30 && _vm.result.percentage_change_order_amount >= 0) ? _c('b', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_amount + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_order_amount < 0) ? _c('b', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_amount + '%'))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" t.a.v vorige jaar in dezelfde periode ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "p-3 border bg-light"
  }, [_c('h5', [_vm._v("Gemiddelde orderwaarde")]), _vm._v(" "), _c('h3', [_c('span', [_vm._v("\n                " + _vm._s(_vm.result.average_order_value) + "\n              ")])]), _vm._v(" "), _c('h3', [_c('span', [_vm._v("\n                " + _vm._s(_vm.result.historical_average_order_value) + "\n              ")])]), _vm._v(" "), (_vm.result.percentage_change_order_value >= 30) ? _c('b', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_value + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_order_value < 30 && _vm.result.percentage_change_order_value >= 0) ? _c('b', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_value + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_order_value < 0) ? _c('b', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_value + '%'))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" t.a.v vorige jaar in dezelfde periode ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "p-3 mt-3"
  }, [_c('h5', [_vm._v("Labels")]), _vm._v(" "), _c('h5', [_vm._v("\n              Geselecteerde periode\n            ")]), _vm._v(" "), _c('h5', {
    staticClass: "mt-10"
  }, [_vm._v("\n              Geselecteerde periode (vorig jaar)\n            ")])])])
}]}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "css-control css-control-primary css-checkbox"
  }, [_c('input', {
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.currentValue
    },
    on: {
      "change": _vm.save
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.paymentTransactions), function(paymentTransaction) {
    return _c('tr', {
      key: paymentTransaction
    }, [_c('td', [_vm._v(" " + _vm._s(paymentTransaction.reference) + " ")]), _vm._v(" "), _c('td', [_vm._v(" € " + _vm._s(paymentTransaction.amount) + " ")]), _vm._v(" "), _c('td', [_vm._v(" € " + _vm._s(paymentTransaction.openAmount) + " ")]), _vm._v(" "), _c('td', [(paymentTransaction.files.length == 0) ? _c('span', [_vm._v("Geen bestanden geüpload")]) : _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column"
      }
    }, _vm._l((paymentTransaction.files), function(file) {
      return _c('span', {
        key: file
      }, [_vm._v(" " + _vm._s(file) + " ")])
    }), 0)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      staticClass: "form-control",
      staticStyle: {
        "width": "350px"
      },
      attrs: {
        "type": "file"
      },
      on: {
        "change": _vm.onFileChange
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.uploadFile(paymentTransaction)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])])])
  }), 0)])])]), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "btn btn-danger btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.deleteFiles()
      }
    }
  }, [_vm._v("\n    Verwijder alle bestanden\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Referentie nummer")]), _vm._v(" "), _c('th', [_vm._v("Totaal bedrag")]), _vm._v(" "), _c('th', [_vm._v("Openstaand bedrag")]), _vm._v(" "), _c('th', [_vm._v("Geüploade bestanden")]), _vm._v(" "), _c('th', [_vm._v("Upload")])])])
}]}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row-container"
  }, [_c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Land:")]), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "options": _vm.countries,
      "multiple": "true",
      "placeholder": "Selecteer een land",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    on: {
      "input": function($event) {
        _vm.refresh()
      }
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verkoopkanaal:")]), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "options": _vm.marketplaces,
      "multiple": "true",
      "placeholder": "Selecteer een marktplaats",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    on: {
      "input": function($event) {
        _vm.refresh()
      }
    },
    model: {
      value: (_vm.selectedSalesChannel),
      callback: function($$v) {
        _vm.selectedSalesChannel = $$v
      },
      expression: "selectedSalesChannel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Periode van")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPeriodFrom),
      expression: "selectedPeriodFrom"
    }],
    staticClass: "field-select form-control",
    staticStyle: {
      "height": "40px",
      "margin-right": "10px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Periode van"
    },
    domProps: {
      "value": (_vm.selectedPeriodFrom)
    },
    on: {
      "change": function($event) {
        _vm.refresh()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPeriodFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Periode tot:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPeriodTo),
      expression: "selectedPeriodTo"
    }],
    staticClass: "field-select form-control",
    staticStyle: {
      "height": "40px",
      "margin-right": "10px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Periode van"
    },
    domProps: {
      "value": (_vm.selectedPeriodTo)
    },
    on: {
      "change": function($event) {
        _vm.refresh()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPeriodTo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('api-table-block', {
    ref: "ordersTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllOrders,
      "default-sort-by": "profit",
      "item-label-singular": "bestelling",
      "item-label-plural": "bestellingen"
    },
    scopedSlots: _vm._u([{
      key: "order_number",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.openDetailModal(data.item.orders_id)
            }
          }
        }, [_vm._v("#" + _vm._s(data.value))])]
      }
    }, {
      key: "total_sale_price",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(parseFloat(data.value))) + "\n    ")]
      }
    }, {
      key: "purchase_price",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(parseFloat(data.value))) + "\n    ")]
      }
    }, {
      key: "sales_channel_commision",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(parseFloat(data.value))) + "\n    ")]
      }
    }, {
      key: "shipping_cost",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(parseFloat(data.value))) + "\n    ")]
      }
    }, {
      key: "profit",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(parseFloat(data.value))) + "\n    ")]
      }
    }, {
      key: "profit_percentage",
      fn: function(data) {
        return [(data.value >= 30) ? _c('b', {
          staticClass: "text-success"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e(), _vm._v(" "), (data.value < 30 && data.value >= 0) ? _c('b', {
          staticClass: "text-warning"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e(), _vm._v(" "), (data.value < 0) ? _c('b', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bg-light rounded d-flex flex-column"
  }, [_c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Totale inkoopkosten: ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("€ " + _vm._s(_vm.total_purchase_price))])]), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Totale commissiekosten")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("€ " + _vm._s(_vm.total_commission))])]), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Totale verzendkosten")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("€ " + _vm._s(_vm.total_shipping_cost))])]), _vm._v(" "), _c('div', {
    staticClass: "border-top px-4 mx-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex pt-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("€ " + _vm._s(_vm.total_costs))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bg-light rounded d-flex flex-column"
  }, [_c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Totale omzet: ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("€ " + _vm._s(_vm.total_revenue))])]), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Gemiddelde winstpercentage")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v(_vm._s(parseFloat(_vm.average_profit_percentage).toFixed(2)) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "border-top px-4 mx-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex pt-3"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("€ " + _vm._s(_vm.total_profit))])])])])]), _vm._v(" "), (_vm.detailModalOrderId) ? _c('order-detail-modal', {
    key: _vm.detailModalOrderId,
    attrs: {
      "order-id": _vm.detailModalOrderId
    },
    on: {
      "close": function($event) {
        _vm.detailModalOrderId = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Kosten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-8"
  }, [_c('b', [_vm._v("Totale kosten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Opbrengsten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-8"
  }, [_c('b', [_vm._v("Totale winst")])])
}]}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "font-size-lg text-black mb-5"
  }, [_vm._v("\r\n                " + _vm._s(_vm.order.billing_person)), _c('br'), _vm._v(" "), (_vm.order.billing_company) ? _c('small', [_vm._v(_vm._s(_vm.order.billing_company))]) : _vm._e()]), _vm._v(" "), _c('address', [_vm._v("\r\n                " + _vm._s(_vm.order.billing_address)), _c('br'), _vm._v("\r\n                " + _vm._s(_vm.order.billing_postal_code) + " " + _vm._s(_vm.order.billing_city)), _c('br'), _c('br'), _vm._v(" "), (_vm.order.billing_phone) ? _c('span', [_c('i', {
    staticClass: "fa fa-phone mr-5"
  }), _vm._v(" " + _vm._s(_vm.order.billing_phone)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.order.billing_email) ? _c('span', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o mr-5"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.order.billing_email))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "block-content",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "font-size-lg text-black mb-5"
  }, [_vm._v("\r\n                " + _vm._s(_vm.order.shipping_person)), _c('br'), _vm._v(" "), (_vm.order.shipping_company) ? _c('small', [_vm._v(_vm._s(_vm.order.shipping_company))]) : _vm._e()]), _vm._v(" "), _c('address', [_vm._v("\r\n                " + _vm._s(_vm.order.shipping_address)), _c('br'), _vm._v("\r\n                " + _vm._s(_vm.order.shipping_postal_code) + " " + _vm._s(_vm.order.shipping_city)), _c('br'), _c('br'), _vm._v(" "), (_vm.order.shipping_phone) ? _c('span', [_c('i', {
    staticClass: "fa fa-phone mr-5"
  }), _vm._v(" " + _vm._s(_vm.order.shipping_phone)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.order.shipping_email) ? _c('span', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o mr-5"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.order.shipping_email))])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Betaaladres")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Verzendadres")])])
}]}

/***/ }),
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bol.png": 620,
	"./dpd.png": 621,
	"./homerr.png": 622,
	"./postnl.png": 290
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 772;

/***/ })
],[331]);


// WEBPACK FOOTER //
// static/js/app.4678c107666e145b1097.js